import React, { useEffect, useState, useRef } from 'react';
import { Card, Form, Button, Collapse, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt, faSave, faEdit, faBroomBall, faPlus, faPenAlt ,faTimes} from '@fortawesome/free-solid-svg-icons';
import APICom from '../../utils/helpers/APICom';
import ConfirmationModal from '../Controls/ConfirmationModal';
import AlgoSettingsComponent from '../ManifestSetting/algoSettings';
import { InputGroup } from 'react-bootstrap';
import GeneralSettingsComponent from '../ManifestSetting/generalSettings';
import { useDispatch, useSelector } from "react-redux";
import { duration } from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import { Modal} from 'react-bootstrap';
// import MultiSelectDropdown from '../Controls/multiselectdropdown';

const Paratransit = ({ AffID, SettingType, _algorithms }) => {
    console.log(AffID);
  const [routeAdded, setRouteAdded] = useState(-1);
  const [showModalBreakDelete, setShowModalBreakDelete] = useState(false);
  const [loadingCount, setLoadingCount] = useState(0);
  const [routeEdited, setRouteEdited] = useState(-1);
  const [routeTempAdded, setRouteTempAdded] = useState(-1);
  const [routeTempEdited, setRouteTempEdited] = useState(-1);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [query, setQuery] = useState("");
  const startLoading = () => setLoadingCount((prev) => prev + 1);
  const stopLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));
  const styles = {
    container: {
      position: "relative",
      width: "100%",
      maxWidth: "400px",
      margin: "20px auto",
      borderRadius: "9999px",
      border: "1px solid #ccc",
      padding: "10px 40px 10px 35px",
      fontSize: "16px",
      backgroundColor: "#fff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      display: "flex",
      alignItems: "center",
    },
    icon: {
      position: "absolute",
      left: "12px",
      fontSize: "16px",
      color: "#888",
    },
    input: {
      flex: 1,
      border: "none",
      outline: "none",
      fontSize: "16px",
      backgroundColor: "transparent",
    },
    clearButton: {
      position: "absolute",
      right: "12px",
      background: "none",
      border: "none",
      fontSize: "18px",
      color: "#888",
      cursor: "pointer",
      transition: "opacity 0.2s ease-in-out",
    },
  };
  const [formData4, setFormData4] = useState({
    // templateName: '',
    // numberOfRoutes: '',
    vehicle: '',
    routeNo: '',
    depot: '',
    vehicleType: '',
    startTime: '',
    recAffiliate: '',
    duration: '',
    miles: '',
    breakTimes: [],
    zonedetails: [],
    attribute: '',
    activeVehCheck: false,
    defaultRouteCheck:false
  });
  // const [breakTimeEdited,setBreakTimeEdited]=useState({
  //   startTime:'',
  //   startHours:'',
  //   earlyWindow:'',
  //   lateWindow:'',
  //   duration:''
  // });
  // breaksRouteGroups2ndle
  const tripTypeDescriptions = {
    0: 'First Trip',
    1: 'Other Trips',
    2: 'All Trips'
  };
  const [formData6, setFormData6] = useState({
    // vehicle:'',
    templateName: '',
    routePrefix: '',
    noOfRoutes: 0,
    // routeNo:'',
    depot: '',
    vehicleType: '',
    startTime: '',
    recAffiliate: '',
    duration: '',
    miles: '',
    breakTimes: [],
    attribute: '',
    // activeVehCheck:false
  });
  const handleDeleteBreak = async (routeno,breakTime) => {
    // setShowModalBreakDelete(false);
       try {
       xCancelSourceForGrid.current = APICom.GenerateSource();
      let params = {
        iID:breakTime.iID,
      };
      console.log(params);
      // Make the async request
      let response = await APICom.fetchData(
        "GenericManifestDotNetCoreURL",
        // "api/Settings/UpdateRouteBreakTime",
        `api/Routing/RemoveDefaultBreak`,
        "post",
        {},
        params,
        xCancelSourceForGrid.current
      );

      let result = response?.data;
      console.log(result)
      if (result[0].Result=="true") {
      fetchRouteDefinitionData();
        setShowModalBreakDelete(false);
        alert(`deleting Break successful`);
      }
      else{
        setShowModalBreakDelete(false);
        alert('failure : break did not delete')
      }
      // Handle result if needed
    } catch (error) {
      console.error(`Error at deleting Break, error`);

    }
  };
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleBreakTimeEdited = (iID,field, value) => {
    // console.log(index+' '+field+' '+value);
    setEditedBreaksRouteGroups2((prevArray) => {
      const updatedArray = [...prevArray]; // Create a copy of the array
  
    const breakToUpdate = updatedArray.find(breakItem => breakItem.iID === iID);
    if (breakToUpdate) {
      breakToUpdate[field] = value; // Update the field value for the specific break
    }

    return updatedArray; // Return the updated array
  });
  };
  const saveRouteTemplate = async (iID=null) => {
    try {
      let payload={
        TemplateName:formData6?.templateName||'',
        RoutePrefix:formData6?.routePrefix||'',
        iRoutes:parseInt(formData6?.noOfRoutes)||-1,
        Depot:parseInt(formData6?.depot)||-1,
        vAttributeIDs:formData6?.attribute||'',
        vVehicleType:formData6?.vehicleType||-1,
        StartTime:formData6?.startTime||'',
        MaxRouteHours:parseInt(formData6?.duration)||0,
        iAffiliateID:formData6?.recAffiliate||-1,
        iSettingID:sharedData,
        "vSettingName": settingName,
        "dtSelectedDate": getDateInYMDFormat(),
        "vRoute": "0" + AffID + "-" + formData6?.routePrefix || '',
      };
      if (iID != null) {
        payload.iID = iID;
        // params.iFromAlgoSetting = 3;
        // payload.vRoute = formData6?.routePrefix || '';
      }
      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", `api/Routing/saveRouteTemplate`, "post",
        {}, payload, xCancelSourceForGrid.current, false
      );
      console.log(response);
      if (response?.data?.iID) {
      setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Route Template Definition", body: "Route Template saved Successfully", btnOkText: "OK" }));

      //  alert('Route Template saved Successfully');
        if (formData6?.breakTimes) {
          for (let i = 0; i < parseInt(formData6?.noOfRoutes); i++) {
        for (let [index, breakTime] of formData6.breakTimes.entries()) {
          try {
            // Your logic for each breakTime
            // xCancelSourceForGrid.current = APICom.GenerateSource();
            let params = {
              hrsFromRouteStartTime: breakTime.startHours,
              breakDuration: breakTime.duration,
              breakLateWindow: breakTime.lateWindow,
              breakStartTime: breakTime.startTime,
              breakEarlyWindow: breakTime.earlyWindow,
              bRecords: false,
              vManifestNumber: (getTodayDate() + "0" + AffID + "-" + formData6?.routePrefix + (i < 10 ? String(i+1).padStart(2, '0') : String(i+1))) || '',
              // vManifestNumber:getTodayDate()+"0"+AffID+"-"+formData6?.routePrefix+(i < 10 ? String(i).padStart(2, '0') : String(i)) || '',
              updateSelection: 2,
              iSettingID: sharedData,
              iMVRouteVehiclesSettingsTemplateID:response?.data?.iID 
            };
            console.log(params);
            // Make the async request
            let response2 = await APICom.fetchData(
              "GenericManifestDotNetCoreURL",
              // "api/Settings/UpdateRouteBreakTime",
              `api/Routing/UpdateBreakTimes`,
              "post",
              {},
              params,
              xCancelSourceForGrid.current
            );

            let result = response2?.data;
            if (result) {
              console.log(`adding Break index ${index} successful`);
            }
            // Handle result if needed
          } catch (error) {
            console.error(`Error at adding Breakindex ${index}:`, error);
          }
        }
      }
      }

      
        setFormData6(prev => ({
          ...prev,
          // vehicle:'',
          templateName: '',
          routePrefix: '',
          noOfRoutes: 0,
          // routeNo:'',
          depot: '',
          vehicleType: '',
          startTime: '',
          recAffiliate: '',
          duration: '',
          breakTimes: [],
          attribute: '',
          // activeVehCheck:false
        }));
        // console.log("General Settings:", response.data);
        // console.log("General Settings:", response.data[0].dTimeWindowMin);
        // setDepots(response.data);
        fetchRouteDefinitionData();
      } else {
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Route Template Definition", body: "Route Template Save Failed.", btnOkText: "OK" }));

       // alert('Route Template Save Failed.');
        console.warn("Route Template Save Failed.");
        // setDepots([]); // Ensure state is updated even if no data is returned
      }
    } catch (error) {
      alert('Error saving Route Template');
      console.error("Error saving Route Template :", error);
      // setDepots([]); // Reset state in case of an error
    }

  };
  const applyBreakValidations=(BreakTimesArr)=>{
      for (let i = 0; i < BreakTimesArr?.length; i++) {
      try {
        let breakTime = BreakTimesArr[i];
        if (parseFloat(breakTime.startHours < 0)) {
          // setModalHeaderText("Update Break");
          alert("Value should be greater than zero!!!!");
          // setModalBtnHTML(downloadRouteFooterHTML);
          // setShowModal(true);
          return false;
        }
        if (breakTime.lateWindow < 0) {
          // setModalHeaderText("Update Break");
          alert("Value should be greater than zero!!!!");
          // setModalBtnHTML(downloadRouteFooterHTML);
          // setShowModal(true);
          return false;
        }
        if (breakTime.earlyWindow < 0) {
          // setModalHeaderText("Update Break");
          alert("Value should be greater than zero!!!!");
          // setModalBtnHTML(downloadRouteFooterHTML);
          // setShowModal(true);
          return false;
        }
        if (breakTime.duration < 0) {
          // setModalHeaderText("Update Break");
          alert("Value should be greater than zero!!!!");
          // setModalBtnHTML(downloadRouteFooterHTML);
          // setShowModal(true);
          return false;
        }
        if (parseFloat(breakTime.startHours) > 0 && breakTime.startTime != '' &&  breakTime.startTime ) {
          // setModalHeaderText("Update Break");
          alert("You can update only Break Start Time or Hrs From Route Break Time!!!!");
          // setModalBtnHTML(downloadRouteFooterHTML);
          // setShowModal(true);
          return false;
        }
        if ((breakTime.startHours == '' || !breakTime.startHours) && ( breakTime.startTime == '' || !breakTime.startTime) ) {
          // setModalHeaderText("Update Break");
            alert("Both Break Start Time or Hrs From Route Break Time should not be Empty");
            // setModalBtnHTML(downloadRouteFooterHTML);
            // setShowModal(true);
            return false;
        }

        for (let j = i + 1; j < BreakTimesArr?.length; j++) {
          let hrsFromRouteStartTime = BreakTimesArr[i]?.startHour;
          let breakStartTime = BreakTimesArr[i]?.startTime;
          let breakLateWindow = BreakTimesArr[i]?.lateWindow;
          let breakEarlyWindow = BreakTimesArr[i]?.earlyWindow;
          let breakDuration = BreakTimesArr[i]?.duration;
          let iID = BreakTimesArr[i]?.iID;
          if (parseFloat(hrsFromRouteStartTime) > 0) {
            if (hrsFromRouteStartTime == BreakTimesArr[j]?.startHour) {
              // setModalHeaderText("Update Break");
              alert("Clash Between Route Start Time");
              // setModalBtnHTML(downloadRouteFooterHTML);
              // setShowModal(true);
              return false;
            }
          }
          if (breakStartTime) {
            if (breakStartTime == BreakTimesArr[j]?.startTime) {
              // setModalHeaderText("Update Break");
              alert("Clash Between Break Start Times");
              // setModalBtnHTML(downloadRouteFooterHTML);
              // setShowModal(true);
              return false;
            }
          }
          if (breakStartTime == "" && BreakTimesArr[j]?.startTime != "") {
            // setModalHeaderText("Update Break");
            alert("You can updated either Break Start Time or Hrs from Route Start");
            // setModalBtnHTML(downloadRouteFooterHTML);
            // setShowModal(true);
            return false;
          }
          if (hrsFromRouteStartTime == "" && BreakTimesArr[j]?.startHour != "") {
            // setModalHeaderText("Update Break");
            alert("You can updated either Break Start Time or Hrs from Route Start");
            // setModalBtnHTML(downloadRouteFooterHTML);
            // setShowModal(true);
            return false;
          }
          if (parseFloat(hrsFromRouteStartTime) > 0) {
            let startRouteTime = parseFloat(hrsFromRouteStartTime) * 60;
            let endRouteTime = parseFloat(hrsFromRouteStartTime) * 60 + parseFloat(breakDuration);

            let startRouteTime1 = (parseFloat(BreakTimesArr[j]?.startHour) * 60);
            let endRouteTime1 = (parseFloat(BreakTimesArr[j]?.startHour) * 60) + parseFloat(BreakTimesArr[j]?.duration);
            if (startRouteTime < endRouteTime1 && endRouteTime >= startRouteTime1) {
              // setModalHeaderText("Update Break");
              alert("Clash Between Break Start Times");
              // setModalBtnHTML(downloadRouteFooterHTML);
              // setShowModal(true);
              return false;
            }
          }
          if (breakStartTime == "" && BreakTimesArr[j]?.startHour == "") {
            // setModalHeaderText("Update Break");
            alert("You can update either Break Start Time or Hrs From Route Break Time!!!!");
            // setModalBtnHTML(downloadRouteFooterHTML);
            // setShowModal(true);
            return false;
          }
          if (hrsFromRouteStartTime == "" && BreakTimesArr[j]?.duration == "") {
            // setModalHeaderText("Update Break");
            alert("You can update either Break Start Time or Hrs From Route Break Time!!!!");
            // setModalBtnHTML(downloadRouteFooterHTML);
            // setShowModal(true);
            return false;
          }
          if (breakStartTime) {
            let dat = new Date();
            let year = dat.getFullYear();
            let month = dat.getMonth();
            let day = dat.getDate();

            let getMinutes = 0;
            let getHour = 0;
            try {
              getMinutes = breakStartTime?.split(':')[1];
              getHour = breakStartTime?.split(':')[0];
            } catch { }

            let getSeconds = breakStartTime?.split(':')[2];
            try {
              if (typeof (breakStartTime?.split(':')[2]) == 'undefined') {
                getSeconds = 0;
              }
              else {
                getSeconds = breakStartTime?.split(':')[2];
              }

            } catch { }
            let startTime = new Date(year, month, day, getHour, parseInt(getMinutes), getSeconds);
            let endTime = new Date(year, month, day, getHour, parseInt(getMinutes) + parseInt(breakDuration), getSeconds);

            let breakStartTime1 = BreakTimesArr[j]?.startTime;
            let breakDuration1 = BreakTimesArr[j]?.duration;
            let getMinutes1 = 0;
            let getHour1 = 0;
            try {
              getMinutes1 = breakStartTime1?.split(':')[1];
              getHour1 = breakStartTime1?.split(':')[0];
            } catch { }

            let getSeconds1 = 0;
            try {
              if (typeof (breakStartTime1?.split(':')[2]) == 'undefined') {
                getSeconds1 = 0;
              }
              else {
                getSeconds1 = breakStartTime1?.split(':')[2];
              }

            } catch { }

            let startTime1 = new Date(year, month, day, getHour1, parseInt(getMinutes1), getSeconds1);
            let endTime1 = new Date(year, month, day, getHour1, parseInt(getMinutes1) + parseInt(breakDuration1), getSeconds1);
            if (startTime < endTime1 && endTime > startTime1) {
              // setModalHeaderText("Update Break");
              alert("Clash Between Break Start Times");
              // setModalBtnHTML(downloadRouteFooterHTML);
              // setShowModal(true);
              return false;
            }
          }
        }


        // Handle result if needed
      } catch (error) {
        console.error(`Error validating break times`, error);
      }
    }
    return true;
  };
  function getTodayDate() {
    const today = new Date();
    const formattedDate = today.getFullYear() + 
                          ("0" + (today.getMonth() + 1)).slice(-2) +  // Add 1 to month (0-indexed)
                          ("0" + today.getDate()).slice(-2);  // Ensure the date is two digits
    return formattedDate;
  }
  
const handleNewBreakSave= async (routeno,breakTime)=>{
  if(sharedData!=null){
    try {
      // Your logic for each breakTime
      // xCancelSourceForGrid.current = APICom.GenerateSource();
      let params = {
        hrsFromRouteStartTime: breakTime.startHours,
        breakDuration: breakTime.duration,
        breakLateWindow: breakTime.lateWindow,
        breakStartTime: breakTime.startTime,
        breakEarlyWindow: breakTime.earlyWindow,
        bRecords: false,
        vManifestNumber: getTodayDate()+""+routeno|| '',
        updateSelection: 2,
        iSettingID: sharedData
      };
      console.log(params);
      // Make the async request
      let response = await APICom.fetchData(
        "GenericManifestDotNetCoreURL",
        // "api/Settings/UpdateRouteBreakTime",
        `api/Routing/UpdateBreakTimes`,
        "post",
        {},
        params,
        xCancelSourceForGrid.current
      );

      let result = response?.data;
      if (result) {
        const filteredArray = editedBreaksRouteGroups2.filter(item => item.iID !== 0);
        setEditedBreaksRouteGroups2(filteredArray);
        setIsButtonThreeDisabled(false);
        fetchRouteDefinitionData();

        console.log(`adding Break successful`);
      }
      // Handle result if needed
    } catch (error) {
      console.error(`Error at adding Break, error`);

    }
  }
};
  // Convert 12-hour AM/PM time to minutes
  const convertToMinutes = (time) => {
    if(time==='' || time===null){
      return null
    }
    // Time is in the format of "hh:mm AM/PM"
    const [timePart, period] = time.split(" ");
    const [hours, minutes] = timePart.split(":").map(Number);
    
    let adjustedHours = hours;

    // Convert to 24-hour format
    if (period === "AM" && hours === 12) {
      adjustedHours = 0; // 12 AM is midnight (00:00)
    } else if (period === "PM" && hours !== 12) {
      adjustedHours += 12; // Convert PM hours to 24-hour format (e.g., 1 PM -> 13)
    }

    // Convert to total minutes
    return adjustedHours * 60 + minutes;
  };
const handleBreakEditSave= async (routeno,breaktime)=>{
  if(sharedData!=null){
let payload={
  "iID": breaktime.iID,
  "hrsFromRouteStartTime": String(breaktime.startHours)||'',
  "breakStartTime": breaktime.startTime||'',
  "breakEarlyWindow": breaktime.earlyWindow||0,
  "breakLateWindow": breaktime.lateWindow||0,
  "breakDuration": breaktime.duration||0,
  "iSettingID": sharedData,
  "vManifestNumber": getTodayDate()+""+routeno,
};

try {
  let response = await APICom.fetchData("GenericManifestDotNetCoreURL", `api/Routing/UpdateDefaultBreak`, "post",
    {}, payload, xCancelSourceForGrid.current, false
  );
  if (response?.data && response.data.length > 0) {
    alert('Break Time saved Successfully');
    fetchRouteDefinitionData();
    // console.log("General Settings:", response.data);
    // console.log("General Settings:", response.data[0].dTimeWindowMin);
    // setDepots(response.data);
  } else {
    console.warn("Break Time UPDATE FAILED.");
    // setDepots([]); // Ensure state is updated even if no data is returned
  }
} catch (error) {
  console.error("Error UPDATING Break Time :", error);
  // setDepots([]); // Reset state in case of an error
}
  }
// console.log(iID);
};
// const dropdownRef = useRef(null);
// const handleClickOutside = (e) => {
//   if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//     setIsDropdownOpen(false);
//   }
// };
// React.useEffect(() => {
//   document.addEventListener("mousedown", handleClickOutside);
//   return () => {
//     document.removeEventListener("mousedown", handleClickOutside);
//   };
// }, []);
  // const [routeTempAdded, setRouteTempAdded] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isButtonTwoDisabled, setIsButtonTwoDisabled] = useState(false);
  const [isButtonThreeDisabled, setIsButtonThreeDisabled] = useState(false);

  const vehDataRef = useRef([]);
  const AttributeDataRef = useRef([]);
  const [VehOptionsManageHTML, setVehOptionsManageHTML] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false); // Track whether dropdown is open or closed

  const [routeAttributeDropDownHTML, setRouteAttributeDropDownHTML] = useState([]);
  const [routeTempAttributeDropDownHTML, setRouteTempAttributeDropDownHTML] = useState([]);

  const { DispatchVehicleData, VehicleTypesPerAffiliateData } = useSelector((store) => store.combinedata);
  // const PerAffiliateVehTypesFilter = VehicleTypesPerAffiliateData?.filter(vehicle => vehicle?.iVTypeATSPID === parseInt(AffID)).map(vehicle => vehicle?.vName);
  const { FundingSourceData } = useSelector((store) => store.combinedata);
  const [FundingSourceFilterMultiSelect, SetFundingSourceFilterMultiSelect] = useState({ options: [], selectedValues: [], placeholder: "Select FS", displayValue: "name", emptyRecordMsg: "N/A", id: "MultiIterationsTabFundingSourcesSelect", className: "MultiIterationsTabFundingSourcesSelect text-nowrap", SelectAllPlaceHolder: "All FS", AllItemsSelectedPlaceHolder: "All FS", styles: { width: "auto", maxWidth: "150px", marginLeft: "3px" } });
  const [VehTypeOptionsManageHTML, setVehTypeOptionsManageHTML] = useState([]);
  const [VehTypeOptionsTemplateManageHTML, setVehTypeOptionsTemplateManageHTML] = useState([]);

  const [sections, setOpenSections] = useState({});
  const [AffiliateID, setAffiliateID] = useState(AffID);
  const [showRuleFormID, setShowRuleFormID] = useState(-1);
  const [showIterationForm, setShowIterationsForm] = useState(false);

  // console.log(AffiliateID);
  // console.log(AffID);
  const [sharedData, setSharedData] = useState(null);
  const [settingName, setSettingName] = useState(null);  // You can adjust the initial state as needed
  const xCancelSourceForGrid = useRef(null);
  const prevIterationsRef = useRef({});
  const [attributeTypes, setAttributeTypes] = useState([]);
  // const [attributes, setAttributes] = useState([]);
  const [pickupAttributes, setpickupAttributes] = useState([]);
  const [dropoffAttributes, setdropoffAttributes] = useState([]);
  const [rulesData, setrulesData] = useState([]);
  const [showRouteZoneDetailModal, setShowRouteZoneDetailModal] = useState(false);
  const [showRouteZoneDetailModal2, setShowRouteZoneDetailModal2] = useState(false);
  const [iterations, setIterations] = useState({});
  const [activeTab, setActiveTab] = useState('Route Builder');
  const [outerActiveTab, setOuterActiveTab] = useState("Tab 1")
  const [currentIteration, setCurrentIteration] = useState("");
  const [depotData, setDepotData] = useState([]);
  const [AttributeData, setAttributeData] = useState([]);
  const [ReceivingAffiliates, setReceivingAffiliates] = useState([]);
  const [formData5, setFormData5] = useState({
    pickupattribute: '',
    dropoffattribute: '',
    triptype: ''
  });
  const [formData7, setFormData7] = useState({
    pickupattribute: '',
    dropoffattribute: '',
    triptype: ''
  });
  const [formData, setFormData] = useState({
    acceptableCostRevThreshold: 0,
    attributeType: '',
    // attribute: '',
    pickupattribute: '',
    dropoffattribute: '',
    matchExempted: false,
    // only: false
    allAttributeMustApply: false
  });
  const tabButtonStyle = {
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: '#f0f0f0',
    border: '2px solid transparent',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    color: '#333',
    fontWeight: 'bold',
    outline: 'none',
  };
  // const formatTimeForInput = (dateString) => {
  //   const date = new Date(dateString); // Convert the string to a Date object
  //   const hours = date.getHours().toString().padStart(2, '0'); // Get hours and ensure two digits
  //   const minutes = date.getMinutes().toString().padStart(2, '0'); // Get minutes and ensure two digits
  //   return `${hours}:${minutes}`; // Return in HH:mm format
  // };
  const convertTo12HourFormat = (time24) => {
    const [hours, minutes] = time24.split(":").map(Number); // Split the time string into hours and minutes
    const period = hours >= 12 ? "PM" : "AM"; // Check if it's PM or AM
    const hours12 = hours % 12 || 12; // Convert hours to 12-hour format, 0 becomes 12
    const formattedMinutes = minutes.toString().padStart(2, "0"); // Ensure minutes are two digits
    return `${hours12}:${formattedMinutes}`; // Return formatted 12-hour time
  };
  const dropdownpadding = {
    paddingLeft: '5px'
  };
  // Inline CSS for active tab
  const activeTabStyle = {
    backgroundColor: '#87CEFA',
    color: 'white',
    borderColor: '#87CEFA',
  };

  // Inline CSS for hover state
  const hoverTabStyle = {
    backgroundColor: '#ddd',
    borderColor: '#ccc',
  };
  const [obj, setObj] = useState(null)
  // Tab switch handler
  const handleTabSwitch = (tab) => {
    setActiveTab(tab);
  };
  const algorithms = _algorithms.map(item => ({
  id: item.iValue.toString(),  
  name: item.DisplayName  
}));

  const fetchRouteDefinitionData = async () => {
    if (sharedData != null) {
      try {
        const response = await APICom.fetchData(
          'GenericManifestDotNetCoreURL',
          "api/Settings/GetRoutesSettings?iSettingID=" + sharedData,
          'get',
          {}
        );

        if (response?.data) {
          console.log(response.data);
          setRouteGroups2(response.data.Routes);
          setbreaksRouteGroups2(response.data.BreakTimes);
          setEditedBreaksRouteGroups2(response.data.BreakTimes);
          setRouteAttributeCombinationDetails(response.data.RouteAttributeDetails);
          setRouteGroups(response.data.RouteTemplates);
          setbreaksRouteGroups(response.data.BreakTimes);
          // const tableData = response.data.Table;
          // ""
          //setApiData(tableData); // Store the Table data in the state

        } else {
          console.log('No data received from the API.');
        }
      } catch (error) {
        console.error('Error fetching API data:', error);
      }
    }
  };

  const handleDepotAttributeCombinationDelete = async (iID) => {
    try {
      const response = await APICom.fetchData(
        'GenericManifestDotNetCoreURL',
        "api/Settings/DeletedepotAttributeCombinations?iID=" + iID,
        'get',
        {}
      );

      if (response?.data) {

        alert('depot Attribute Combination deleted');
        setDepotAttributeCombinationDetails(depotAttributeCombinationDetails.filter(entry => entry.iID !== iID));
        fetchRouteDefinitionData()
      }
      else {
        console.log('Error deleting depot Attribute Combination.');
      }
    }
    catch (error) {
      console.error('Error DELTING depot Attribute Combinations:', error);
    }
  };

  const fetchRouteDefinitionSettingsData = async () => {
    if (sharedData != null) {
      try {
        const response = await APICom.fetchData(
          'GenericManifestDotNetCoreURL',
          "api/Settings/GetRouteDefinitonSettings?iSettingID=" + sharedData + "&iAffiliateID=" + AffID,
          'get',
          {}
        );

        if (response?.data) {
          console.log(response.data);
          setDepotData(response.data?.Depot?.filter(depot => depot.bDefault === false));
          setReceivingAffiliates(response.data.TransferingAffiliates);
          if (response && response?.data.Attribute && response?.data.Attribute?.length > 0) {
            console.log('here');
            AttributeDataRef.current = response?.data?.Attribute;
            // let attributeComponentHTML = response?.data.Attribute?.map(function (item, index) {
            //   return (

            //     // <option key={index} value={item.iID}>{item.vTitle}</option>
            //     <div key={index} className="checkbox-item">
            //       <input
            //         type="checkbox"
            //         id={item.iID}
            //         value={item.iID}
            //         checked={formData4.attribute.split(',').includes(String(item.iID))}
            //         onChange={handleCheckboxChange2} // onChange handler for each checkbox
            //       />
            //       <label htmlFor={item.iID}>{item.vTitle}</label>
            //     </div>
            //   );
            // });

            // let attributeTempComponentHTML = response?.data.Attribute?.map(function (item, index) {
            //   return (

            //     // <option key={index} value={item.iID}>{item.vTitle}</option>
            //     <div key={index} className="checkbox-item">
            //       <input
            //         type="checkbox"
            //         id={item.iID}
            //         value={item.iID}
            //         checked={formData6.attribute.split(",").includes(String(item.iID))}
            //         onChange={handleCheckboxChange3} // onChange handler for each checkbox
            //       />
            //       <label htmlFor={item.iID}>{item.vTitle}</label>
            //     </div>
            //   );
            // });
            // console.log(attributeComponentHTML);
            // console.log('hello')
            // setRouteTempAttributeDropDownHTML(attributeTempComponentHTML);
            // setRouteAttributeDropDownHTML(attributeComponentHTML);
            // console.log("attributeTempComponentHTML",attributeTempComponentHTML);
          }
          // setRouteGroups2(response.data);
          // const tableData = response.data.Table;
          // ""
          //setApiData(tableData); // Store the Table data in the state


        } else {
          console.log('No data received from the API.');
        }
      } catch (error) {
        console.error('Error fetching API data:', error);
      }
    }
  };
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggleIsDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  function FilterFundingSourcesBySelectedAffiliates(selectedAffiliates) {
    let optsFS = [];
    for (const key in FundingSourceData) {
      if (FundingSourceData.hasOwnProperty(key) && selectedAffiliates.indexOf(key.toString()) > -1) {
        const value = FundingSourceData[key];
        try {
          const FundingSourceDataJSON = JSON.parse(value);
          for (var i = 0; i < FundingSourceDataJSON.length; i++) {
            optsFS.push({ "name": FundingSourceDataJSON[i]["AccountID"] + " (" + FundingSourceDataJSON[i].AffiliateAbbrevation + ")", "id": (FundingSourceDataJSON[i]["FID"] + "-" + FundingSourceDataJSON[i]["iFSATSPID"]) });
          }
        } catch (error) {
        }
      }
    }
    // FilterFundingSourcesBySelectedAffiliates([AffID]);

    // SetFundingSourceFilterMultiSelect({ ...FundingSourceFilterMultiSelect, ...{ options: optsFS } });
    console.log(optsFS);
    console.log(FundingSourceFilterMultiSelect.options);
    SetFundingSourceFilterMultiSelect(prevState => ({
      ...prevState,
      options: optsFS
    }));
    console.log(FundingSourceFilterMultiSelect);
  };
  // const handleSelectChange = (event) => {
  //   const selectedOptions = event.target.selectedOptions;
  //   console.log(selectedOptions);
  //   const selectedValues = Array.from(selectedOptions).map(option => option.value);

  //   // Check if "Select All" is selected (empty value "")
  //   if (selectedValues.includes("")) {
  //     // If "Select All" is selected, select all options
  //     SetFundingSourceFilterMultiSelect(prevState => ({
  //       ...prevState,
  //       selectedValues: prevState.options.map(option => option.id.toString())
  //     }));
  //   } else {
  //     // Otherwise, update selected values based on user selection
  //     SetFundingSourceFilterMultiSelect(prevState => ({
  //       ...prevState,
  //       selectedValues
  //     }));
  //   }
  // };
  const handleCheckboxChange2 = (event) => {
    const { value, checked } = event.target;
    console.log("Previous Form Data: ", formData4);
    console.log("Checkbox Value: ", value, "Checked: ", checked);
  
    setFormData4((prevFormData) => {
      // Ensure formData4.attribute is always a string, even if it's empty
      const selectedAttributes = prevFormData.attribute ? prevFormData.attribute.split(',') : [];
  
      // If the checkbox is checked, add the value to the list
      if (checked) {
        if (!selectedAttributes.includes(value)) {
          selectedAttributes.push(value); // Avoid duplicates
        }
      } else {
        // If the checkbox is unchecked, remove the value from the list
        const index = selectedAttributes.indexOf(value);
        if (index > -1) {
          selectedAttributes.splice(index, 1); // Remove the value
        }
      }
  
      console.log("Updated Selected Attributes: ", selectedAttributes.join(','));
  
      // Return the updated state with the updated attribute list
      return {
        ...prevFormData,
        attribute: selectedAttributes.join(','),
      };
    });
  };

  const handleAttributeCheckboxChange = (event) => {
    const { value, checked } = event.target;
    console.log("Previous Form Data: ", formData6);
    console.log("Checkbox Value: ", value, "Checked: ", checked);
  
    setFormData6((prevFormData) => {
      // Ensure formData4.attribute is always a string, even if it's empty
      const selectedAttributes = prevFormData.attribute ? prevFormData.attribute.split(',') : [];
  
      // If the checkbox is checked, add the value to the list
      if (checked) {
        if (!selectedAttributes.includes(value)) {
          selectedAttributes.push(value); // Avoid duplicates
        }
      } else {
        // If the checkbox is unchecked, remove the value from the list
        const index = selectedAttributes.indexOf(value);
        if (index > -1) {
          selectedAttributes.splice(index, 1); // Remove the value
        }
      }
  
      console.log("Updated Selected Attributes: ", selectedAttributes.join(','));
  
      // Return the updated state with the updated attribute list
      return {
        ...prevFormData,
        attribute: selectedAttributes.join(','),
      };
    });
  };
  
  

  const handleCheckboxChange3 = (event) => {
    const { value, checked } = event.target;
    console.log(checked);
    console.log('here');
    // Update formData4.attribute with a comma-separated string
    setFormData6((prevFormData) => {
      const selectedAttributes = prevFormData.attribute ? prevFormData.attribute.split(',') : [];

      if (checked) {
        selectedAttributes.push(value);
      } else {
        const index = selectedAttributes.indexOf(value);
        if (index > -1) {
          selectedAttributes.splice(index, 1);
        }
      }
      console.log(selectedAttributes.join(','));
      // Convert array to comma-separated string and update the formData4 state
      return {
        ...prevFormData,
        attribute: selectedAttributes.join(','),
      };
    });
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    SetFundingSourceFilterMultiSelect((prevState) => {
      const updatedSelectedValues = checked
        ? [...prevState.selectedValues, value]
        : prevState.selectedValues.filter((item) => item !== value);

      return { ...prevState, selectedValues: updatedSelectedValues };
    });
  };

  // Handle Select All checkbox
  const handleSelectAllChange = () => {
    if (FundingSourceFilterMultiSelect.selectedValues.length === FundingSourceFilterMultiSelect.options.length) {
      SetFundingSourceFilterMultiSelect((prevState) => ({ ...prevState, selectedValues: [] }));
    } else {
      const allValues = FundingSourceFilterMultiSelect.options.map((option) => option.id);
      SetFundingSourceFilterMultiSelect((prevState) => ({ ...prevState, selectedValues: allValues }));
    }
  };
  // Toggle dropdown open/close
  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  // Default text when no options are selected
  const getDropdownText = () => {
    return FundingSourceFilterMultiSelect.selectedValues.length === 0
      ? `0 selected of ${FundingSourceFilterMultiSelect.options.length}`
      : `${FundingSourceFilterMultiSelect.selectedValues.length} selected of ${FundingSourceFilterMultiSelect.options.length}`;
  };
  const [confirmationModalObj, setConfirmationModalObj] = useState({
    show: false, title: 'Confirmation',
    body: 'Are you Sure you want to Delete Rule?', btnCanceText: 'No',
    btnOkText: 'Yes', closeOnly: false, isCancel: false
  });
  const [confirmationModalObj1, setConfirmationModalObj1] = useState({
    show: false, title: 'Confirmation',
    body: 'Are you Sure you want to Delete Rule?', btnCanceText: 'No',
    btnOkText: 'Yes',
  });
  const [editingRule, setEditingRule] = useState(null);
  const [reload, setReload] = useState(true)

  const handleThresholdChange = (e, iterationId) => {
    // prevIterationsRef.current=JSON.parse(JSON.stringify(iterations));;
    // prevIterationsRef.current.cancel();
    prevIterationsRef.current = { ...iterations };

    // prevIterationsRef.current = [...iterations]; 
    const updatedValue = Number(e.target.value);
    setIterations(prev => ({
      ...prev,
      [iterationId]: {
        ...prev[iterationId],
        rules: [
          {
            ...prev[iterationId]?.rules[0],  // Spread the first rule
            dAcceptableCostRevThreshold: updatedValue,  // Update the field
          },
          ...prev[iterationId]?.rules.slice(1),  // Keep the other rules unchanged
        ],
      },
    }));
  };
  const handleConfirmationModalOk1 = async () => {
          setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));

  }
  const handleConfirmationModalOk = async () => {
    if (obj?.onlyIterationId) {
      setIterations(prev => {
        const newIterations = { ...prev };
        delete newIterations[obj.iterationId];
        return newIterations;
      });
      const payload = {
        iAffiliateID: AffiliateID,
        iIterationID: obj.iterationId,
        tableName:obj.tno==='V0'?'dtl_AttributeRoutingRules':'dtl_AttributeRoutingRulesV1'
      };
      xCancelSourceForGrid.current = APICom.GenerateSource();
      await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/DeleteAttributeSettings", "post", {}, payload, xCancelSourceForGrid.current);
      setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
      setObj(null)
      fetchAttributeData(AffID);
      return
    }
    setIterations(prev => {
      const updatedRules = prev[obj?.iterationId]?.rules?.filter(rule => rule?.id !== obj?.ruleId);
      return {
        ...prev,
        [obj?.iterationId]: { ...prev[obj?.iterationId], rules: updatedRules }
      };
    });
    const payload = {
      iAffiliateID: AffiliateID,
      iID: obj?.ruleId,
      tableName:obj.tno==='V0'?'dtl_AttributeRoutingRules':'dtl_AttributeRoutingRulesV1'
    };
    xCancelSourceForGrid.current = APICom.GenerateSource();
    let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/DeleteAttributeSettings", "post", {}, payload, xCancelSourceForGrid.current);
    setReload(!reload)
    setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    setObj(null)
  }
  const handleConfirmationModalClose = () => {
    setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    setConfirmationModalObj1((prevState) => ({ ...prevState, show: false }));
  }
  const handleConfirmationModalCancel = () => {
    setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    setConfirmationModalObj1((prevState) => ({ ...prevState, show: false }));
  }
  const handleCancel = () => {
    setEditingRule(null);
    setCurrentIteration("");

  };
  const transformRuleData = (rule, attributeTypes,pickupAttributes, dropoffAttributes) => {
    // if (!rule?.iAttributeTypeID || !rule?.iAttributeID) {
    
    if (!rule?.iAttributeTypeID ) {
      return {
        id: rule?.iID,
        attributeType: 'None',
        // attribute: 'None',
        pickupattribute: 'None',
        dropoffattribute: 'None',
        dAcceptableCostRevThreshold:rule?.dAcceptableCostRevThreshold || 0,
        active: rule?.bActive || false,
        // only: rule?.bAttributeOnly || false,
        allattributemustapply: rule?.bAllAttributeMustApply || false,
        matchExempted: rule?.bApplyAttribute || false,
      };
    }

    const attributeType = attributeTypes?.find(type => type?.iID === rule?.iAttributeTypeID);
    // const attribute = attributes?.find(attr => attr?.iID === rule?.iAttributeID);
    const pickupattribute = pickupAttributes?.find(attr => attr?.iID === (rule.tno==='V0'?rule?.iAttributeID:rule?.iPickupAttributeID));
    const dropoffattribute = dropoffAttributes?.find(attr => attr?.iID === rule?.iDropoffAttributeID);

    return {
      id: rule?.iID,
      attributeType: attributeType?.vName || 'None',
      // attribute: attribute?.vTitle || 'None',
      pickupattribute: pickupattribute?.vTitle || 'None',
      dropoffattribute: dropoffattribute?.vTitle || 'None',
      // only: rule?.bAttributeOnly || false,
      allattributemustapply: rule?.bAllAttributeMustApply || false,
      active: rule?.bActive || false,
      dAcceptableCostRevThreshold: rule?.dAcceptableCostRevThreshold || 999999,
      matchExempted: rule?.bApplyAttribute || false,
    };
  };

  useEffect(() => {
    FilterFundingSourcesBySelectedAffiliates([AffID]);
    let PerAffiliateVehTypesFilter=null
    let PerAffiliateVehTypesTempFilter=null
    // if(formData4.recAffiliate){
    if(parseInt(formData4.recAffiliate) > 0){
    PerAffiliateVehTypesFilter = VehicleTypesPerAffiliateData?.filter(vehicle => vehicle?.iVTypeATSPID === parseInt(formData4.recAffiliate)).map(vehicle => vehicle?.vName);
    }
    else{
      PerAffiliateVehTypesFilter = VehicleTypesPerAffiliateData?.filter(vehicle => vehicle?.iVTypeATSPID === parseInt(AffID)).map(vehicle => vehicle?.vName);
    }
    if(parseInt(formData6.recAffiliate) > 0){
      PerAffiliateVehTypesTempFilter = VehicleTypesPerAffiliateData?.filter(vehicle => vehicle?.iVTypeATSPID === parseInt(formData6.recAffiliate)).map(vehicle => vehicle?.vName);
    }
    else{
      PerAffiliateVehTypesTempFilter = VehicleTypesPerAffiliateData?.filter(vehicle => vehicle?.iVTypeATSPID === parseInt(AffID)).map(vehicle => vehicle?.vName);
    }
    let vehicleTypeOptionsHTML = PerAffiliateVehTypesFilter?.map((type, index) => {
      if (type && type.toUpperCase() !== "TESTTYPE") {
        return (
          <option key={index} value={type}>{type}</option>
        );
      }
    });
    let vehicleTypeOptionsTempHTML = PerAffiliateVehTypesTempFilter?.map((type, index) => {
      if (type && type.toUpperCase() !== "TESTTYPE") {
        return (
          <option key={index} value={type}>{type}</option>
        );
      }
    });
    setVehTypeOptionsTemplateManageHTML(vehicleTypeOptionsTempHTML);
    setVehTypeOptionsManageHTML(vehicleTypeOptionsHTML);
    let vehData=null;
    if(DispatchVehicleData[parseInt(formData4.recAffiliate)] != undefined){
    vehData = DispatchVehicleData[parseInt(formData4.recAffiliate)] !== "" ? DispatchVehicleData[parseInt(formData4.recAffiliate)] : "[]";
    }
    else{
      vehData = DispatchVehicleData[parseInt(AffID)] !== "" ? DispatchVehicleData[parseInt(AffID)] : "[]";
    }
    if (vehData != "[]" && vehData != undefined) {
      let tempArray = JSON.parse(vehData);
      const newObject = {
        "VehicleNumber": " ", "VehicleID": -1, "VehicleType": "Select", "DriverNumber": "",
        "DriverID": -1, "DriverName": ",", "RowNumber": 46, "iAffID": 28, "STATE": "", "iVTypeID": 3,
        "VehicleNoANDRank": "-1", "MaxWheelChairs": 2, "TotalCapacity": 16, "LessPerWheelChair": 0.00
      };
      tempArray.unshift(newObject);
      const updatedJSON = JSON.stringify(tempArray);
      vehDataRef.current = JSON.parse(updatedJSON);
      vehDataRef.current = handleDuplicates(JSON.parse(updatedJSON), "VehicleNumber");
      let vehDropDown = handleDuplicates(JSON.parse(updatedJSON), "VehicleType");
      let vehicleNumOptionsHTML = vehDataRef?.current?.map(function (item, index) {
        return (
          <option key={index} value={item.VehicleID}>{item.VehicleNumber}</option>
        );
      });
      setVehOptionsManageHTML(vehicleNumOptionsHTML);
    }

  }, [reload, AffID,formData4.recAffiliate,formData4.vehicleType,formData6.recAffiliate]);
  const fetchGeneralSettings = async () => {
    xCancelSourceForGrid.current = APICom.GenerateSource();
    try {
      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", `api/Settings/GetAlgoSettingsForGrid?iSettingID=${sharedData}`, "get",
        {}, {}, xCancelSourceForGrid.current
      );
      if (response?.data && response.data.length > 0) {
        console.log(response.data[0].iAlgorithmType);
        console.log(response.data[0].dTimeHorizon);
        console.log(response.data[0].dRollingHorizon);
        console.log(response.data[0].bTripPairBiasing);
        console.log(response.data[0].dEarlyPickTimeMin);
        setoperationConstraintsData(prevState => ({
          ...prevState,
          routingAlgorithm: String(response.data[0].iAlgorithmType) || '',
          timeHorizon: response.data[0].dMultiTripEvalTimeWindow || 0,
          timeHorizonRhcg:response.data[0].dTimeHorizon || 0,
          rollingHorizon: response.data[0].dRollingHorizon || 0,
          tripPairBiasing: response.data[0].bTripPairBiasing || false,
          autoRoutingMode: (response.data[0].SubTitle === 'AutoRoutingFlag' ? response.data[0].value : response.data[1].value) || 0,
          periodicTimer: (response.data[0].SubTitle === 'AutoRoutingTimer' ? response.data[0].value : response.data[1].value) || 0,
          iOtherManualActionsAlgoTypeID: String(response.data[0].iOtherManualActionsAlgoTypeID),
          iManSingleRoutingAlgoTypeID: String(response.data[0].iManSingleRoutingAlgoTypeID),
          iManBatchRoutingAlgoTypeID: String(response.data[0].iManBatchRoutingAlgoTypeID),
          iPeriodicAlgoTypeID: String(response.data[0].iPeriodicAlgoTypeID),
          iFinalRunAlgoTypeID: String(response.data[0].iFinalRunAlgoTypeID),
          iPredictiveAlgoTypeID: String(response.data[0].iPredictiveAlgoTypeID),
          ArialTimeAdjPercentage:response.data[0].dArialTimeAdjPercentage || 0,
          dServiceStartTime:convertMinutesToTime(response.data[0].dEarlyPickTimeMin)||''
        }));

        setoperationConstraintsData1(prevState => ({
          ...prevState,
          maxRouteDuration: response.data[0].dMaxRouteHours || '',
          maxTripsPerRoute: response.data[0].iMaxRoutes || '',
          // earliestStartTime: response.data[0].dTimeWindowMin || '',
          maxRouteMiles:response.data[0].dMaxRouteMiles || '',
          fixedStartTime: response.data[0].bFixedRouteStartTime || false,
          disableRideSharing: response.data[0].bDisableRideSharing || false,
          maxUniqueStops:response.data[0].iMaxUniqueStopsInRoute||'',
          iOtherManualActionsAlgoTypeID: String(response.data[0].iOtherManualActionsAlgoTypeID),
          iManSingleRoutingAlgoTypeID: String(response.data[0].iManSingleRoutingAlgoTypeID),
          iManBatchRoutingAlgoTypeID: String(response.data[0].iManBatchRoutingAlgoTypeID),
          iPeriodicAlgoTypeID: String(response.data[0].iPeriodicAlgoTypeID),
          iFinalRunAlgoTypeID: String(response.data[0].iFinalRunAlgoTypeID),
          iPredictiveAlgoTypeID: String(response.data[0].iPredictiveAlgoTypeID),
        }));

        setPickupWindow(prevState => ({
          ...prevState,
          earliestDesired: response.data[0].dTimeWindowMin || '',
          earliestRelaxed: response.data[0].dTimeWindowMinRelaxed || '',
          lateDesired: response.data[0].dEndWindowTimeMin || '',
          lateRelaxed: response.data[0].dEndWindowTimeMinRelaxed || ''
        }));

        setDropOffWindow(prevState => ({
          ...prevState,
          // earliestDesired: response.data[0].dApptTimeWindowMin || '',
          earliestDesired: response.data[0].dApptTimeWindow || '',
          earliestRelaxed: response.data[0].dTimeWindowMinRelaxed || '',
          // latestDesired: response.data[0].dApptTimeWindow || '',
          latestDesired: response.data[0].dApptTimeWindowMax || '',
          latestRelaxed: response.data[0].dApptTimeWindowRelaxed || ''
        }));

        setMaxRideTime(prevState => ({
          ...prevState,
          shortDesired: response.data[0].MinimumRidTimeMin || '',
          shortRelaxed: response.data[0].MinimumRidTimeMinRelaxed || '',
          longDesired: response.data[0].MaxRideTimePer || '',
          longRelaxed: response.data[0].MaxRideTimePerRelaxed || ''
        }));

        setServiceTime(prevState => ({
          ...prevState,
          singleAmb: response.data[0].dDOtoPUIntMin || '',
          singleWc: response.data[0].dWCServiceTime || '',
          additionalAmb: response.data[0].dAdditionalServiceTimePer || '',
          additionalWc: response.data[0].dAdditionalWServiceTimePer || ''
        }));


        const daysOfWeek = [
          "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
        ];
        console.log(response.data);
        console.log(response.data[0].vScheduleDays);
        
        console.log(response.data[0].vScheduleDays?.length);
        for (let i = 0; i < response.data[0].vScheduleDays?.length; i++) {
          console.log(response.data[0].vScheduleDays[i]);
          if (response.data[0].vScheduleDays[i] != ' ') {
            setScheduleDays(prevState => ({
              ...prevState,
              [daysOfWeek[i]]: true
            }));
          }
          else {
            setScheduleDays(prevState => ({
              ...prevState,
              [daysOfWeek[i]]: false
            }));
          }
        }
        console.log(response.data[0].AutoRoutingDisabledAccounts);
        const splitArray = response.data[0].AutoRoutingDisabledAccounts.split(",");
        console.log(splitArray);
        
        const filteredArray = FundingSourceFilterMultiSelect.options.filter(item => {
          const firstPart = item.id.split('-')[0];  // Get the first part of the id
          return splitArray.includes(firstPart);   // Check if the first part matches any element in splitArray
        });
        // const filteredArray = FundingSourceFilterMultiSelect.options.filter(item => splitArray.includes(item.id));
        console.log(filteredArray)
        if (filteredArray.length > 0) {
          SetFundingSourceFilterMultiSelect(prevState => ({
            ...prevState,
            selectedValues: Array.from(filteredArray).map(option => option.id)
          }));
        }
        else {
          // SetFundingSourceFilterMultiSelect(prevState => ({
          //   ...prevState,
          //   selectedValues: Array.from(FundingSourceFilterMultiSelect.options).map(option => option.id)
          // }));
        }
        console.log(FundingSourceFilterMultiSelect);

        // SetFundingSourceFilterMultiSelect(response.data[0].AutoRoutingDisabledAccounts);

        setoperationConstraintsData(prevState => ({
          ...prevState,
          routingAlgorithm: String(response.data[0].iAlgorithmType) || '',
          timeHorizon: response.data[0].dMultiTripEvalTimeWindow || 0,
          timeHorizonRhcg:response.data[0].dTimeHorizon || 0,
          rollingHorizon: response.data[0].dRollingHorizon || 0,
          tripPairBiasing: response.data[0].bTripPairBiasing || false,
          autoRoutingMode: (response.data[0].SubTitle === 'AutoRoutingFlag' ? response.data[0].value : response.data[1].value) || 0,
          periodicTimer: (response.data[0].SubTitle === 'AutoRoutingTimer' ? response.data[0].value : response.data[1].value) || 0,
          iOtherManualActionsAlgoTypeID: String(response.data[0].iOtherManualActionsAlgoTypeID),
          iManSingleRoutingAlgoTypeID: String(response.data[0].iManSingleRoutingAlgoTypeID),
          iManBatchRoutingAlgoTypeID: String(response.data[0].iManBatchRoutingAlgoTypeID),
          iPeriodicAlgoTypeID: String(response.data[0].iPeriodicAlgoTypeID),
          iFinalRunAlgoTypeID: String(response.data[0].iFinalRunAlgoTypeID),
          iPredictiveAlgoTypeID: String(response.data[0].iPredictiveAlgoTypeID),
          ArialTimeAdjPercentage:response.data[0].dArialTimeAdjPercentage || 0,
          dServiceStartTime:convertMinutesToTime(response.data[0].dEarlyPickTimeMin)||''
        }));

      } else {
        console.warn("No General Settings.");
      }
    } catch (error) {
      console.error("Error fetching General Settings:", error);
      // setDepots([]); // Reset state in case of an error
    }
  };
  const fetchAttributeData = async (id) => {
    const payload = {
      iAffiliateID: id,
      iSettingID: sharedData
    };
    if (sharedData != null) {
      resetForm();
      xCancelSourceForGrid.current = APICom.GenerateSource();
      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetAttributeSettings", "post", {}, payload, xCancelSourceForGrid.current);

      if (response?.data) {
        console.log(response.data);
        setAttributeTypes(response?.data?.AttributeTypeData);
        // setAttributes(response?.data?.AttributeData);
        
        setpickupAttributes(response?.data?.PickupAttributeData);
        setdropoffAttributes(response?.data?.DropoffAttributeData);
        setrulesData(response?.data?.RulesData);

      }
    }
  };

  useEffect(()=>{

    const transformedIterations = {};
    const openState = {}; // Will store open/closed state for each iteration

    rulesData.forEach(rule => {
      if (!transformedIterations[rule?.iIteration]) {
        transformedIterations[rule?.iIteration] = {
          rules: [],
          routeType: rule?.vRouteFilter || 'All',
          tno:rule?.tno
        };
      }
      // Initialize openSections state for this iteration (start closed)
      openState[rule?.iIteration] = true;
      const transformedRule = transformRuleData(rule, attributeTypes, pickupAttributes, dropoffAttributes);
      
      transformedIterations[rule?.iIteration]?.rules.push(transformedRule);
    });

    setIterations(transformedIterations);
    setOpenSections(openState);

   },[pickupAttributes, dropoffAttributes]);
  useEffect(() => {
    //console.log('ld '+String(loadingCount))
    //startLoading();
    //console.log(AffID);
  //  console.log(FundingSourceFilterMultiSelect);
  //  const id = AffID
  //  setAffiliateID(id)
    // const fetchGeneralSettings = async () => {
    //   xCancelSourceForGrid.current = APICom.GenerateSource();
    //   try {
    //     let response = await APICom.fetchData("GenericManifestDotNetCoreURL", `api/Settings/GetAlgoSettingsForGrid?iSettingID=${sharedData}`, "get",
    //       {}, {}, xCancelSourceForGrid.current
    //     );
    //     if (response?.data && response.data.length > 0) {
    //       console.log(response.data[0].iAlgorithmType);
    //       console.log(response.data[0].dTimeHorizon);
    //       console.log(response.data[0].dRollingHorizon);
    //       console.log(response.data[0].bTripPairBiasing);
    //       setoperationConstraintsData(prevState => ({
    //         ...prevState,
    //         routingAlgorithm: String(response.data[0].iAlgorithmType) || '',
    //         timeHorizon: response.data[0].dMultiTripEvalTimeWindow || 0,
    //         rollingHorizon: response.data[0].dRollingHorizon || 0,
    //         tripPairBiasing: response.data[0].bTripPairBiasing || false,
    //         autoRoutingMode: (response.data[0].SubTitle === 'AutoRoutingFlag' ? response.data[0].value : response.data[1].value) || 0,
    //         periodicTimer: (response.data[0].SubTitle === 'AutoRoutingTimer' ? response.data[0].value : response.data[1].value) || 0,
    //       }));

    //       setoperationConstraintsData1(prevState => ({
    //         ...prevState,
    //         maxRouteDuration: response.data[0].dMaxRouteHours || '',
    //         maxTripsPerRoute: response.data[0].iMaxRoutes || '',
    //         // earliestStartTime: response.data[0].dTimeWindowMin || '',
    //         maxRouteMiles:response.data[0].dMaxRouteMiles || '',
    //         fixedStartTime: response.data[0].bFixedRouteStartTime || false,
    //         disableRideSharing: response.data[0].bDisableRideSharing || false,
    //         maxUniqueStops:response.data[0].iMaxUniqueStopsInRoute||''
    //       }));

    //       setPickupWindow(prevState => ({
    //         ...prevState,
    //         earliestDesired: response.data[0].dTimeWindowMin || '',
    //         earliestRelaxed: response.data[0].dTimeWindowMinRelaxed || '',
    //         lateDesired: response.data[0].dEndWindowTimeMin || '',
    //         lateRelaxed: response.data[0].dEndWindowTimeMinRelaxed || ''
    //       }));

    //       setDropOffWindow(prevState => ({
    //         ...prevState,
    //         // earliestDesired: response.data[0].dApptTimeWindowMin || '',
    //         earliestDesired: response.data[0].dApptTimeWindow || '',
    //         earliestRelaxed: response.data[0].dTimeWindowMinRelaxed || '',
    //         // latestDesired: response.data[0].dApptTimeWindow || '',
    //         latestDesired: response.data[0].dApptTimeWindowMax || '',
    //         latestRelaxed: response.data[0].dApptTimeWindowRelaxed || ''
    //       }));

    //       setMaxRideTime(prevState => ({
    //         ...prevState,
    //         shortDesired: response.data[0].MinimumRidTimeMin || '',
    //         shortRelaxed: response.data[0].MinimumRidTimeMinRelaxed || '',
    //         longDesired: response.data[0].MaxRideTimePer || '',
    //         longRelaxed: response.data[0].MaxRideTimePerRelaxed || ''
    //       }));

    //       setServiceTime(prevState => ({
    //         ...prevState,
    //         singleAmb: response.data[0].dDOtoPUIntMin || '',
    //         singleWc: response.data[0].dWCServiceTime || '',
    //         additionalAmb: response.data[0].dAdditionalServiceTimePer || '',
    //         additionalWc: response.data[0].dAdditionalWServiceTimePer || ''
    //       }));


    //       const daysOfWeek = [
    //         "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    //       ];
    //       console.log(response.data);
    //       console.log(response.data[0].vScheduleDays);
    //       console.log(response.data[0].vScheduleDays.length);
    //       for (let i = 0; i < response.data[0].vScheduleDays.length; i++) {
    //         console.log(response.data[0].vScheduleDays[i]);
    //         if (response.data[0].vScheduleDays[i] != ' ') {
    //           setScheduleDays(prevState => ({
    //             ...prevState,
    //             [daysOfWeek[i]]: true
    //           }));
    //         }
    //         else {
    //           setScheduleDays(prevState => ({
    //             ...prevState,
    //             [daysOfWeek[i]]: false
    //           }));
    //         }
    //       }
    //       console.log(response.data[0].AutoRoutingDisabledAccounts);
    //       const splitArray = response.data[0].AutoRoutingDisabledAccounts.split(",");
    //       console.log(splitArray);
    //       const filteredArray = FundingSourceFilterMultiSelect.options.filter(item => {
    //         const firstPart = item.id.split('-')[0];  // Get the first part of the id
    //         return splitArray.includes(firstPart);   // Check if the first part matches any element in splitArray
    //       });
    //       // const filteredArray = FundingSourceFilterMultiSelect.options.filter(item => splitArray.includes(item.id));
    //       console.log(filteredArray)
    //       if (filteredArray.length > 0) {
    //         SetFundingSourceFilterMultiSelect(prevState => ({
    //           ...prevState,
    //           selectedValues: Array.from(filteredArray).map(option => option.id)
    //         }));
    //       }
    //       else {
    //         SetFundingSourceFilterMultiSelect(prevState => ({
    //           ...prevState,
    //           selectedValues: Array.from(FundingSourceFilterMultiSelect.options).map(option => option.id)
    //         }));
    //       }
    //       console.log(FundingSourceFilterMultiSelect);

    //       // SetFundingSourceFilterMultiSelect(response.data[0].AutoRoutingDisabledAccounts);

    //       setoperationConstraintsData(prevState => ({
    //         ...prevState,
    //         routingAlgorithm: String(response.data[0].iAlgorithmType) || '',
    //         timeHorizon: response.data[0].dMultiTripEvalTimeWindow || 0,
    //         rollingHorizon: response.data[0].dRollingHorizon || 0,
    //         tripPairBiasing: response.data[0].bTripPairBiasing || false,
    //         autoRoutingMode: (response.data[0].SubTitle === 'AutoRoutingFlag' ? response.data[0].value : response.data[1].value) || 0,
    //         periodicTimer: (response.data[0].SubTitle === 'AutoRoutingTimer' ? response.data[0].value : response.data[1].value) || 0,
    //       }));

    //     } else {
    //       console.warn("No General Settings.");
    //     }
    //   } catch (error) {
    //     console.error("Error fetching General Settings:", error);
    //     // setDepots([]); // Reset state in case of an error
    //   }
    // };
    // fetchGeneralSettings();
    // const fetchAttributeData = async () => {
    //   const payload = {
    //     iAffiliateID: id,
    //     iSettingID: sharedData
    //   };
    //   if (sharedData != null) {
    //     resetForm();
    //     xCancelSourceForGrid.current = APICom.GenerateSource();
    //     let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetAttributeSettings", "post", {}, payload, xCancelSourceForGrid.current);

    //     if (response?.data) {
    //       console.log(response.data);
    //       setAttributeTypes(response?.data?.AttributeTypeData);
    //       // setAttributes(response?.data?.AttributeData);
    //       setpickupAttributes(response?.data?.PickupAttributeData);
    //       setdropoffAttributes(response?.data?.DropoffAttributeData);

    //       const openState = {}; // Will store open/closed state for each iteration
    //       const transformedIterations = {};
    //       response?.data?.RulesData?.forEach(rule => {
    //         if (!transformedIterations[rule?.iIteration]) {
    //           transformedIterations[rule?.iIteration] = {
    //             rules: [],
    //             routeType: rule?.vRouteFilter || 'All',
    //             tno:rule?.tno
    //           };
    //         }
    //         // Initialize openSections state for this iteration (start closed)
    //         openState[rule?.iIteration] = true;
    //         const transformedRule = transformRuleData(rule, response?.data?.AttributeTypeData, response?.data?.PickupAttributeData, response?.data?.DropoffAttributeData);
    //         transformedIterations[rule?.iIteration]?.rules.push(transformedRule);
    //       });

    //       setIterations(transformedIterations);
    //       setOpenSections(openState);
    //     }
    //   }
    // };

    // fetchAttributeData();
    // if (sharedData != null) {
    //   fetchAttributeData(AffID);
    //   fetchGeneralSettings();

    // }
    // setRouteAdded(-1);
    // setRouteEdited(-1);
    // setFormData4(prev => ({
    //   ...prev,
    //   vehicle: '',
    //   routeNo: '',
    //   depot: '',
    //   vehicleType: '',
    //   startTime: '',
    //   recAffiliate: '',
    //   duration: '',
    //   breakTimes: [],
    //   attribute: '',
    //   activeVehCheck: false
    // }));
    const loadData = async () => {
    startLoading();
    try {
      //await fetchDepotData();
    //console.log('ld '+String(loadingCount))
    //startLoading();
    console.log(AffID);
    console.log(FundingSourceFilterMultiSelect);
    const id = AffID
    setAffiliateID(id)
    if (sharedData != null) {
      await fetchAttributeData(AffID);
      await fetchGeneralSettings();

    }
    setRouteAdded(-1);
    setRouteEdited(-1);
    setFormData4(prev => ({
      ...prev,
      vehicle: '',
      routeNo: '',
      depot: '',
      vehicleType: '',
      startTime: '',
      recAffiliate: '',
      duration: '',
      breakTimes: [],
      attribute: '',
      activeVehCheck: false,
      defaultRouteCheck:false,
      miles:''
    }));
    } catch (err) {
      console.error("API error:", err);
    } finally {
      // stopLoading();
          setTimeout(() => {
        stopLoading();
      }, 2000); 
    }
  };

  if(sharedData){
  loadData();
  }
    //stopLoading();
    // fetchRouteDefinitionData();
  }, [reload, sharedData]);

  useEffect(() => {
    // startLoading();
    // fetchDepotData();
    // stopLoading();
      const loadData = async () => {
    startLoading();
    try {
      await fetchDepotData();
    } catch (err) {
      console.error("API error:", err);
    } finally {
      // stopLoading();
          setTimeout(() => {
        stopLoading();
      }, 2000); // Delay 500ms
    }
  };

  if(sharedData){
  loadData();
  }
  }, [sharedData]);

  useEffect(() => {
        //startLoading();

    // if (sharedData != null) {
    //   fetchGeneralSettingsData();
    // }
        //stopLoading();
    const loadData = async () => {
    startLoading();
    try {
      await fetchGeneralSettingsData();
    } catch (err) {
      console.error("API error:", err);
    } finally {
      // stopLoading();
          setTimeout(() => {
        stopLoading();
      }, 2000); // Delay 500ms
    }
  };

  if(sharedData){
  loadData();
  }


  }, [sharedData]);
  const toggleSection = (iterationId) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [iterationId]: !prevState[iterationId], // Toggle the open state of the iteration
    }));
  };
  const fetchDepotData = async () => {
    xCancelSourceForGrid.current = APICom.GenerateSource();

    const iSettingID = sharedData != null ? sharedData : -1;

    try {
      if (iSettingID != -1) {
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", `api/Settings/GetDepots?iSettingID=${iSettingID}`, "get",
          {}, {}, xCancelSourceForGrid.current
        );
        console.log(response);
        if (response?.data) {
          console.log("Depot Data:", response.data);
          setDepots(response.data.Depots.filter(depot => depot.bDefault === false));
          setDepotAttributeCombinationDetails(response.data.DepotAttributeDetails);
        } else {
          console.warn("No depots found.");
          setDepots([]); // Ensure state is updated even if no data is returned
        }
      }
    } catch (error) {
      console.error("Error fetching depot data:", error);
      setDepots([]); // Reset state in case of an error
    }
  };


  const getFilteredPickupAttributes = (selectedAttributeType) => {
    if (!selectedAttributeType) return [];
    const typeId = attributeTypes.find(type => type?.vName === selectedAttributeType)?.iID;
    return pickupAttributes.filter(attr => attr?.iAttrType === typeId);
  };

  const getFilteredDropoffAttributes = (selectedAttributeType) => {
    if (!selectedAttributeType) return [];
    const typeId = attributeTypes.find(type => type?.vName === selectedAttributeType)?.iID;
    return dropoffAttributes.filter(attr => attr?.iAttrType === typeId);
  };

  const iterationOptions = Object.keys(iterations).map(num => Number(num));

  const resetForm = () => {
    console.log('here');
    setFormData({
      acceptableCostRevThreshold: 0,
      attributeType: '',
      attribute: '',
      matchExempted: false,
      only: false
    });
    setEditingRule(null);
  };

  const handleAttributeTypeChange = (e) => {
    const newAttributeType = e.target.value;
    console.log(newAttributeType);
    setFormData({
      ...formData,
      attributeType: newAttributeType,
      attribute: ''
    });
  };

  const handleAdd = async (tableName) => {
    ""
    console.log(formData?.attributeType);
    console.log(editingRule?.attributeType);
    console.log(sharedData);
    if (sharedData == null) {
      setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Validation", body: "Select Attribute Type/Setting", btnOkText: "OK" }));
      return;
    }
    if (!editingRule?.attributeType && !formData?.attributeType) {
      setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Validation", body: "Select Attribute Type/Setting", btnOkText: "OK" }));
      return;
    }
    // if(!formData?.attributeType){
    //   setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Validation", body: "Select Attribute Type/Setting", btnOkText: "OK" }));
    //   return;
    // }
    const attributeTypeId = attributeTypes?.find(type => type?.vName === formData?.attributeType)?.iID;
    // const attributeId = attributes?.find(attr => attr?.vTitle === formData?.attribute)?.iID;
    const pickupAttributeID = pickupAttributes?.find(attr => attr?.vTitle === formData?.pickupattribute)?.iID;
    const dropoffAttributeID = dropoffAttributes?.find(attr => attr?.vTitle === formData?.dropoffattribute)?.iID;

    let newIterationId = currentIteration;
    let status = true;
    if (currentIteration === "") {
      newIterationId = Math.max(...Object.keys(iterations).map(Number), 0) + 1;
      status = false;
      console.log('new iterid');
    }
    var payload;
    console.log(iterations);
    console.log(newIterationId)
    if (status && Object.keys(iterations).length > 0) {
      payload = {
        iAffiliateID: AffiliateID,
        iSettingID: sharedData,
        iIterationID: newIterationId,
        // iAttributeID: attributeId || -1,
        iPickupAttributeID: pickupAttributeID || -1,
        iDropoffAttributeID: dropoffAttributeID || -1,
        iAttributeTypeID: attributeTypeId || -1,
        // bOnly: iterations[newIterationId]?.rules[0].only,
        bAllAttributeMustApply: iterations[newIterationId]?.rules[0].bAllAttributeMustApply,
        bExempt: formData?.matchExempted,
        dAcceptableCostRevThreshold: iterations[newIterationId]?.rules[0].dAcceptableCostRevThreshold,
        vRouteFilter: iterations[newIterationId]?.routeType
      };
      if (editingRule) {
        payload = {
          ...payload,
          iPickupAttributeID: pickupAttributes?.find(attr => attr?.vTitle === editingRule?.pickupattribute)?.iID || -1,
          iDropoffAttributeID: dropoffAttributes?.find(attr => attr?.vTitle === editingRule?.dropoffattribute)?.iID || -1,
          iAttributeID: pickupAttributes?.find(attr => attr?.vTitle === editingRule?.pickupattribute)?.iID || -1,
          iAttributeTypeID: attributeTypes?.find(type => type?.vName === editingRule?.attributeType)?.iID || -1,
          bExempt: editingRule?.matchExempted,
          bActive: editingRule?.active
        }
      }
    }
    else {
      console.log(formData);
      payload = {
        iAffiliateID: AffiliateID,
        iSettingID: sharedData,
        iIterationID: newIterationId,
        // iAttributeID: attributeId || -1,
        iPickupAttributeID: pickupAttributeID || -1,
        iDropoffAttributeID: dropoffAttributeID || -1,
        iAttributeTypeID: attributeTypeId || -1,
        // bOnly: formData?.only,
        bAllAttributeMustApply: formData?.allAttributeMustApply,
        bExempt: formData?.matchExempted,
        dAcceptableCostRevThreshold: formData?.acceptableCostRevThreshold,
      };
    }

    if (editingRule) {
      payload = {
        ...payload,
        iID: editingRule.id
      }
    }
    payload={
      ...payload,
      tableName: tableName==='V0'?'dtl_AttributeRoutingRules':'dtl_AttributeRoutingRulesV1'
    }

    try {
      xCancelSourceForGrid.current = APICom.GenerateSource();
      const response = await APICom.fetchData(
        "GenericManifestDotNetCoreURL",
        "api/Routing/UpdateAttributeSettings",
        "post",
        {},
        payload,
        xCancelSourceForGrid.current
      );

      if (response.data) {
        if (response.data == 'Fail') {
          throw new Error('Failed to add rule');
        }
        else {
          setIterations(prev => {
            const updatedIterations = { ...prev };
            const currentIterationData = prev[newIterationId] || { rules: [], routeType: 'All' };

            const newRule = {
              id: response?.data?.iID || Math.random(),
              attributeType: formData?.attributeType || 'None',
              // attribute: formData?.attribute || 'None',
              // only: formData?.only,
              pickupattribute: formData?.pickupattribute || 'None',
              dropoffattribute: formData?.dropoffattribute || 'None',
              allattributemustapply: formData?.allAttributeMustApply,
              dAcceptableCostRevThreshold: formData?.acceptableCostRevThreshold,
              matchExempted: formData?.matchExempted,
            };

            updatedIterations[newIterationId] = {
              ...currentIterationData,
              rules: [...currentIterationData?.rules, newRule],
            };
            return updatedIterations;
          });

          setCurrentIteration(newIterationId?.toString());
          setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Success", body: editingRule ? "Rule updated successfully!" : "Rule added successfully!", btnOkText: "OK" }));
          fetchAttributeData(AffID);
          setReload(!reload)
        }
      }
    } catch (error) {
      console.error('Error adding rule:', error);
      setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Failure", body: editingRule ? "Rule updated failed!" : "Rule failed to add!", btnOkText: "OK" }));
    }

    resetForm();
    setShowIterationsForm(false);
    setShowRuleFormID(-1);
    fetchAttributeData(AffID);
    // setShowRuleFormID(-1);
  };
  const handleIterationUpdate = async (tableName) => {
    console.log(iterations);
    try {
      console.log(iterations[obj.iterationId].rules[0].allattributemustapply);
      const payload = {
        iSettingID: sharedData,
        iIterationID: obj.iterationId,
        // bOnly: iterations[obj.iterationId].rules[0].only,
        bAllAttributeMustApply: iterations[obj.iterationId].rules[0].allattributemustapply===true?true:false,
        dAcceptableCostRevThreshold: iterations[obj.iterationId].rules[0].dAcceptableCostRevThreshold,
        vRouteFilter: iterations[obj.iterationId].routeType,
        tableName:tableName==='V0'?'dtl_AttributeRoutingRules':'dtl_AttributeRoutingRulesV1'

      };
      xCancelSourceForGrid.current = APICom.GenerateSource();
      const response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UpdateIterationSettings", "post", {}, payload, xCancelSourceForGrid.current);
      // setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
      if (response?.data) {
        console.log('iteration updated successfully');
        fetchAttributeData(AffID);
        setObj(null)
        // setIterationOnly(null)
        setReload(!reload)
        return
      }

    }
    catch (error) {
      console.error('Error adding rule:', error);
    }
  };

  const handleEdit = (iterationId, rule) => {
    setCurrentIteration(iterationId);
    setEditingRule(rule);
    // setFormData({
    //   attributeType: rule?.attributeType,
    //   attribute: rule?.attribute,
    //   matchExempted: rule?.matchExempted,
    //   acceptableCostRevThreshold:rule?.dAcceptableCostRevThreshold,
    //   only: rule?.only
    // });
  };

  const handleDeleteRule = async (iterationId, ruleId,tno) => {
    setObj({ iterationId, ruleId ,tno:tno})
    setConfirmationModalObj((prevState) => ({
      ...prevState, show: true, body: "Are you Sure you want to Delete Rule?", btnOkText: 'Yes'
    }));
  };

  const handleDeleteIteration = async (iterationId,tno) => {
    setObj({ iterationId, onlyIterationId: true ,tno:tno})
    setConfirmationModalObj((prevState) => ({
      ...prevState, show: true, body: "Are you Sure you want to Delete Iteration?", btnOkText: 'Yes'
    }));
  };
  const handleEditIteration = async (iterationId) => {
    console.log('here');
    console.log(iterations)
    setObj({ iterationId, onlyIterationId: true, editIteration: true })
    console.log(obj);
    // setConfirmationModalObj((prevState) => ({
    // ...prevState, show: true, body: "Are you Sure you want to Update Iteration?", btnOkText: 'Yes' }));
  };


  // const handleIterationChange = (e) => {
  //   const newIteration = e.target.value;
  //   setCurrentIteration(newIteration);
  //   if (newIteration === "") return;

  //   setIterations(prev => ({
  //     ...prev,
  //     [newIteration]: prev[newIteration] || { rules: [], routeType: 'All' }
  //   }));
  // };

  const handleIterationChange = (newIteration) => {
    setCurrentIteration(newIteration);
    if (newIteration === "") return;

    setIterations(prev => ({
      ...prev,
      [newIteration]: prev[newIteration] || { rules: [], routeType: 'All' }
    }));
  };

  const handleRouteTypeChange = async (iterationId, routeType) => {
    // prevIterationsRef.current=JSON.parse(JSON.stringify(iterations));;
    // prevIterationsRef.current.cancel();
    prevIterationsRef.current = { ...iterations };

    // prevIterationsRef.current = [...iterations]; 
    setIterations(prev => ({
      ...prev,
      [iterationId]: { ...prev[iterationId], routeType }
    }));

    // const payload = {
    //   iAffiliateID: AffiliateID,
    //   iIterationID: iterationId,
    //   vRouteFilter: routeType
    // };
    // xCancelSourceForGrid.current = APICom.GenerateSource();
    // await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UpdateRouteFilter", "post", {}, payload, xCancelSourceForGrid.current);
  };

  const handleDataChange = (iSettingName, iSettingID) => {
    setSharedData(iSettingID);  // Update the shared data when AlgoSettingsComponent triggers a change
    setSettingName(iSettingName);
    setIsButtonDisabled(false);
    setIsButtonTwoDisabled(false);
  };


  // State for each table's editable fields
  const [pickupWindow, setPickupWindow] = useState({
    earliestDesired: '',
    earliestRelaxed: '',
    lateDesired: '',
    lateRelaxed: ''
  });

  const [dropOffWindow, setDropOffWindow] = useState({
    earliestDesired: '',
    earliestRelaxed: '',
    latestDesired: '',
    latestRelaxed: ''
  });

  const [maxRideTime, setMaxRideTime] = useState({
    shortDesired: '',
    shortRelaxed: '',
    longDesired: '',
    longRelaxed: ''
  });

  const [serviceTime, setServiceTime] = useState({
    singleAmb: '',
    singleWc: '',
    additionalAmb: '',
    additionalWc: ''
  });

  // Improved handler for numeric fields
  const handleNumericChange = (setter, field) => (e) => {
    const value = e.target.value;

    // Allow empty string, minus sign, and valid numbers
    if (value === '' || value === '-' || /^-?\d*\.?\d*$/.test(value)) {
      setter(prev => ({ ...prev, [field]: value }));
    }
  };

  // Handler for converting input to number when losing focus
  const handleNumericBlur = (setter, field) => (e) => {
    const value = e.target.value;

    // Convert to number, defaulting to 0 if invalid
    setter(prev => ({
      ...prev,
      [field]: value === '' || value === '-' ? 0 : Number(value)
    }));
  };

  // Generic handler for updating string fields
  const handleStringChange = (setter, field) => (e) => {
    setter(prev => ({ ...prev, [field]: e.target.value }));
  };

  const handleRouteDefinitionsSave = async () => {
    if (sharedData != null) {
      let payload = {
        dMaxRouteHours: parseFloat(operationConstraintsData1.maxRouteDuration) || 0,
        iMaxRoutes: parseInt(operationConstraintsData1.maxTripsPerRoute) || 0,
        // dTimeWindowMin: parseFloat(operationConstraintsData1.earliestStartTime) || 0,
        dTimeWindowMin: parseFloat(pickupWindow.earliestDesired) || 0,
        dMaxRouteMiles:parseFloat(operationConstraintsData1.maxRouteMiles)||0,
        dApptTimeWindowMax:parseFloat(dropOffWindow.latestDesired)||0,
        bFixedRouteStartTime: operationConstraintsData1.fixedStartTime || false,
        bDisableRideSharing: operationConstraintsData1.disableRideSharing || false,
        dTimeWindowMinRelaxed: pickupWindow.earliestRelaxed || 0,
        dEndWindowTimeMin: pickupWindow.lateDesired || 0,
        dEndWindowTimeMinRelaxed: pickupWindow.lateRelaxed || 0,
        dApptTimeWindow: dropOffWindow.earliestDesired || 0,
        dApptTimeWindowRelaxed: dropOffWindow.latestRelaxed || 0,
        MinimumRidTimeMin: parseInt(maxRideTime.shortDesired) || 0,
        MinimumRidTimeMinRelaxed: parseInt(maxRideTime.shortRelaxed) || 0,
        MaxRideTimePer: maxRideTime.longDesired || 0,
        MaxRideTimePerRelaxed: maxRideTime.longRelaxed || 0,
        dDOtoPUIntMin: parseFloat(serviceTime.singleAmb) || 0,
        dAdditionalServiceTimePer: serviceTime.additionalAmb || 0,
        dAdditionalWServiceTimePer: serviceTime.additionalWc || 0,
        dWCServiceTime:serviceTime.singleWc||0,
        iSettingID: sharedData,
        iMaxUniqueStopsInRoute:operationConstraintsData1.maxUniqueStops||0
      };
      console.log('Saving Route Definitions:', payload);

      try {
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", `api/Settings/UpdateConstraintsSettingsForGrid`, "post",
          {}, payload, xCancelSourceForGrid.current, false
        );
        if (response?.data && response.data.length > 0) {
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Constraints", body: "Constraints Saved Successfully", btnOkText: "OK" }));

         // alert('Constraints Settings Saved Successfully');
          fetchGeneralSettings();
          // console.log("General Settings:", response.data);
          // console.log("General Settings:", response.data[0].dTimeWindowMin);
          // setDepots(response.data);
        } else {
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Constraints", body: "Constraints Saving Failed", btnOkText: "OK" }));

          console.warn("SETTING UPDATE FAILED.");
          // setDepots([]); // Ensure state is updated even if no data is returned
        }
      } catch (error) {
        console.error("Error UPDATING SETTING data:", error);
        // setDepots([]); // Reset state in case of an error
      }

    }
    else {
      alert('Select a setting first');
    }
  };

  const [operationConstraintsData, setoperationConstraintsData] = useState({
    routingAlgorithm: '',
    timeHorizon: '',
    timeHorizonRhcg:'',
    rollingHorizon: '',
    tripPairBiasing: false,
    autoRoutingMode: '',
    periodicTimer: '',
    iOtherManualActionsAlgoTypeID:'',
    iPredictiveAlgoTypeID:'',
    iFinalRunAlgoTypeID:'',
    iPeriodicAlgoTypeID:'',
    iManBatchRoutingAlgoTypeID:'',
    iManSingleRoutingAlgoTypeID:'',
    ArialTimeAdjPercentage:'',
    dServiceStartTime:''

    // disableRideSharing: false
  });

  const [operationConstraintsData1, setoperationConstraintsData1] = useState({
    maxTripsPerRoute: '',
    // earliestStartTime: '',
    maxRouteMiles:'',
    disableRideSharing: false,
    fixedStartTime: false,
    maxRouteDuration: '',
    maxUniqueStops:'',
    iOtherManualActionsAlgoTypeID:'',
    iPredictiveAlgoTypeID:'',
    iFinalRunAlgoTypeID:'',
    iPeriodicAlgoTypeID:'',
    iManBatchRoutingAlgoTypeID:'',
    iManSingleRoutingAlgoTypeID:''
  });
  const convertMinutesToTime = (minutes) => {
    if(minutes === null){
      return null
    }
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  // Format hours and minutes as a two-digit string for 24-hour time format
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = remainingMinutes.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}`;
};
  const handleConstraintsChange = (e) => {
    const { name, value, type, checked } = e.target;
    setoperationConstraintsData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleConstraintsChange1 = (e) => {
    const { name, value, type, checked } = e.target;
    setoperationConstraintsData1(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // States for different parameter sections
  const [routeStartUpCost, setRouteStartUpCost] = useState({
    newRouteStartCost: '',
    includeOutDepotTrip: false,
    includeReturnDepotTrip: false
  });

  const [costOptimationParameter, setCostOptimationParameter] = useState({
    travelCostPerDrivenMile: '',
    travelCostPerDrivenMinute: '',
    costPerIdleMinute: '',
    relaxedSlope: '',
    PUEarlyPenaltyUnitCost: '',
    PULatePenaltyUnitCost: '',
    ApptEarlyPenaltyUnitCost: '',
    ApptLatePenaltyUnitCost:''
  });

  const [revenueOptimationParameter, setRevenueOptimationParameter] = useState({
    revenuePerPessengerTravelMile: '',
    revenuePerPessengerTravelMinute: '',
    pickupFee: '',
    milesIncludedInFee: ''
  });

  // Handlers for different parameter sections
  const handleStartUpCost = (e) => {
    const { name, value } = e.target;
    setRouteStartUpCost(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCostOptimation = (e) => {
    const { name, value } = e.target;
    // console.log(name);
    // console.log(value);
    setCostOptimationParameter(prev => ({
      ...prev,
      [name]: value
    }));
    // console.log(costOptimationParameter);
  };

  const handleRevenueOptimationParameterChange = (e) => {
    const { name, value } = e.target;
    setRevenueOptimationParameter(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleGeneralSettingsSave = async () => {
    if (sharedData == null) {
      alert('You have to first Select an Algorithm setting first');
      return;
    }
    let daysStr = "";
    for (let day of Object.keys(scheduleDays)) {
      if (scheduleDays[day]) {
        daysStr += day[0]; // Add the first letter of the day
      } else {
        daysStr += " "; // Add a space if the day is false
      }
    }
    debugger
    let payload = {
      iSettingID: sharedData,
      iAffiliateID: parseInt(AffID),
      iAlgorithmType: parseInt(operationConstraintsData?.routingAlgorithm) || 0,
      dMultiTripEvalTimeWindow:parseFloat(operationConstraintsData?.timeHorizon) || 0,
      dTimeHorizon:parseFloat(operationConstraintsData?.timeHorizonRhcg) || 0,
      dRollingHorizon: parseFloat(operationConstraintsData?.rollingHorizon) || 0,
      bTripPairBiasing: operationConstraintsData?.tripPairBiasing || false,
      autoRoutingMode: parseInt(operationConstraintsData?.autoRoutingMode) || 0,
      periodicTimer: parseInt(operationConstraintsData?.periodicTimer) || 0,
      AutoRoutingDisabledAccounts: FundingSourceFilterMultiSelect?.selectedValues.map(value => value.split('-')[0]).join(","),
      vScheduleDays: daysStr,
      iPredictiveAlgoTypeID: parseInt(operationConstraintsData?.iPredictiveAlgoTypeID) > 0? parseInt(operationConstraintsData?.iPredictiveAlgoTypeID): 0,
      iFinalRunAlgoTypeID: parseInt(operationConstraintsData?.iFinalRunAlgoTypeID) > 0? parseInt(operationConstraintsData?.iFinalRunAlgoTypeID): 0,
      iPeriodicAlgoTypeID: parseInt(operationConstraintsData?.iPeriodicAlgoTypeID) > 0? parseInt(operationConstraintsData?.iPeriodicAlgoTypeID) : 0,
      iManBatchRoutingAlgoTypeID: parseInt(operationConstraintsData?.iManBatchRoutingAlgoTypeID) > 0? parseInt(operationConstraintsData?.iManBatchRoutingAlgoTypeID): 0,
      iManSingleRoutingAlgoTypeID: parseInt(operationConstraintsData?.iManSingleRoutingAlgoTypeID) > 0? parseInt(operationConstraintsData?.iManSingleRoutingAlgoTypeID): 0,
      iOtherManualActionsAlgoTypeID: parseInt(operationConstraintsData?.iOtherManualActionsAlgoTypeID) > 0? parseInt(operationConstraintsData?.iOtherManualActionsAlgoTypeID): 0,
      dArialTimeAdjPercentage:parseInt(operationConstraintsData?.ArialTimeAdjPercentage) || 0,
      dEarlyPickTimeMin:parseInt(convertToMinutes(operationConstraintsData.dServiceStartTime))||0

      //FundingSourceFilterMultiSelect?.selectedValues.join(",")||""
    }
    xCancelSourceForGrid.current = APICom.GenerateSource();
    // const iSettingID =124;
    try {
      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", `api/Settings/UpdateGeneralSettingsForGrid`, "post",
        {}, payload, xCancelSourceForGrid.current, false
      );
      if (response?.data && response.data.length > 0) {
              setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "General Settings", body: "General Settings Saved Successfully", btnOkText: "OK" }));

        // alert('General Settings Saved Successfully');
        fetchGeneralSettings();
        // console.log("General Settings:", response.data);
        // console.log("General Settings:", response.data[0].dTimeWindowMin);
        // setDepots(response.data);
      } else {
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "General Settings", body: "General Settings Saving Failed", btnOkText: "OK" }));

        console.warn("SETTING UPDATE FAILED.");
        // setDepots([]); // Ensure state is updated even if no data is returned
      }
    } catch (error) {
      console.error("Error UPDATING SETTING data:", error);
      // setDepots([]); // Reset state in case of an error
    }
  };
  const handleSave = async () => {
    if (sharedData == null) {
      alert('You have to first Select an Algorithm setting first');
      return;
    }
    let value = 0;
    if (routeStartUpCost.includeOutDepotTrip && routeStartUpCost.includeReturnDepotTrip) {
      value = 3;
    }
    else if (!routeStartUpCost.includeOutDepotTrip && routeStartUpCost.includeReturnDepotTrip) {
      value = 2;
    }
    else if (routeStartUpCost.includeOutDepotTrip && !routeStartUpCost.includeReturnDepotTrip) {
      value = 1;
    }
    let payload = {
      iSettingID: sharedData,
      // dTimeWindowMin: routeStartUpCost?.newRouteStartCost || 0,
      dCallTimeMinWindow: routeStartUpCost?.newRouteStartCost || 0,
      iAddDepotCost: value,
      dUnitDistanceCost: costOptimationParameter?.travelCostPerDrivenMile || 0,
      dUnitTimeCost: costOptimationParameter?.travelCostPerDrivenMinute || 0,
      dUnitIdleTimeCost: costOptimationParameter?.costPerIdleMinute || 0,
      dOptimalThreshold: costOptimationParameter?.relaxedSlope || 0,
      dRevenuePerDRM: revenueOptimationParameter?.revenuePerPessengerTravelMile || 0,
      dRevenuePerDRT: revenueOptimationParameter?.revenuePerPessengerTravelMinute || 0,
      dMinRevDRMPerTrip: revenueOptimationParameter?.milesIncludedInFee || 0,
      dPickUpFeePerTrip: revenueOptimationParameter?.pickupFee || 0,
      PUEarlyPenaltyUnitCost: costOptimationParameter?.PUEarlyPenaltyUnitCost || 0,
      PULatePenaltyUnitCost: costOptimationParameter?.PULatePenaltyUnitCost || 0,
      ApptEarlyPenaltyUnitCost: costOptimationParameter?.ApptEarlyPenaltyUnitCost || 0,
      ApptLatePenaltyUnitCost:costOptimationParameter?.ApptLatePenaltyUnitCost || 0

    };
    xCancelSourceForGrid.current = APICom.GenerateSource();
    // const iSettingID =124;
    try {
      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", `api/Settings/UpdateAlgoSettingsForGrid`, "post",
        {}, payload, xCancelSourceForGrid.current, false
      );
      if (response?.data && response.data.length > 0) {
      setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Cost Revenue Settings", body: "Cost Revenue Settings Saved Successfully", btnOkText: "OK" }));

       // alert('Algorithm Settings Saved Successfully');
        fetchGeneralSettingsData();
      } else {
              setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Cost Revenue Settings", body: "Cost Revenue Settings Saving Failed", btnOkText: "OK" }));

        console.warn("SETTING UPDATE FAILED.");
      }
    } catch (error) {
      console.error("Error UPDATING SETTING data:", error);
    }
  };


  const [depots, setDepots] = useState([
    // { id: 1, name: "Depot 01", address: "Lahore, Pak", lat: "23214.2342", long: "3242.454643", zone: "Cantt", isEditing: false },
  ]);
  const [AddingDepot, setAddingDepot] = useState(false);
  const [zones] = useState(["Cantt", "DHA", "Gulberg", "Johar Town"]);

  const [cijSlowDown, setCijSlowDown] = useState([
    { id: 1, name: "Depot 01", address: "Lahore, Pak", lat: "23214.2342", long: "3242.454643", zone: "Cantt", isEditing: false },
  ]);
  const [zone] = useState(["MOCO", "PG", "TR", "DT"]);
  const handleDepotEdit = async (id) => {
    console.log("Before Edit:", depots);

    // Find the depot being edited
    const depotToAdd = depots.find(depot => depot.depotId === id);
    if (!depotToAdd) return;

    // If the depot is being edited, fetch latitude & longitude
    if (depotToAdd.isEditing) {
      try {
        const coordinates = await fetchGeocode(depotToAdd.Street);
        if (coordinates) {
          setDepots(prevDepots => {
            const updatedDepots = prevDepots.map(depot => {
              if (depot.depotId === id) {
                return {
                  ...depot,
                  Latitude: String(coordinates.lat),
                  Longitude: String(coordinates.lng),
                  isEditing: false
                };
              }
              return depot;
            });

            // Find the updated depot after state update
            const updatedDepot = updatedDepots.find(d => d.depotId === id);
            if (updatedDepot) {
              SaveDepotData(updatedDepot); // Save updated depot to DB
            }

            return updatedDepots;
          });

          console.log("Updated with Geocoding:", coordinates);
        } else {
          alert("Geocoding failed : Enter Valid Address")
          console.warn("Geocoding failed for:", depotToAdd.Street);
        }
      } catch (error) {
        console.error("Error fetching geocode:", error);
      }
    } else {
      // Toggle isEditing without geocode update
      setDepots(prevDepots =>
        prevDepots.map(depot =>
          depot.depotId === id ? { ...depot, isEditing: !depot.isEditing } : depot
        )
      );
    }

    console.log("After Edit:", depots);
  };

  const handleDeleteDepot = async (id) => {
    try {
      const payload = {
        iSettingID: sharedData,
        iDepot: id
      };
      console.log("ID to delete:", id);
      console.log("Current Depots:", depots);

      xCancelSourceForGrid.current = APICom.GenerateSource();
      const response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Settings/DeleteDepot", "post", {}, payload, xCancelSourceForGrid.current);

      if (response?.data === true) {
        setDepots(prevDepots => {
          const updatedDepots = prevDepots.filter(depot => depot.depotId !== id);
          console.log("Updated Depots after deletion:", updatedDepots);
          return updatedDepots;
        });
        
        console.log("Depot deleted successfully");
              setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Depot Definitions", body: "Depot Deleted Successfully", btnOkText: "OK" }));

      } else {
        console.error("Failed to delete depot:", response?.data);
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Depot Definitions", body: "Depot Deletion Failed", btnOkText: "OK" }));

      }
    } catch (error) {
      console.error("Error deleting depot:", error);
    }
  }

  const fetchGeocode = async (address) => {
    try {
      const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=AIzaSyCUZiQELkgLvz9RFYDCl4Lsetn3H54jaXI`);
      const data = await response.json();

      if (data.status === "OK" && data.results.length > 0) {
        const location = data.results[0].geometry.location;
        return { lat: location.lat, lng: location.lng };
      } else {
        console.error("Geocode API Error:", data);
        return null;
      }
    } catch (error) {
      console.error("Error in fetchGeocode:", error);
      return null;
    }
  };

  const handleDepotAdd = () => {
    // const newDepot = { id: Date.now(), name: "", address: "", lat: "", long: "", zone: zones[0], isEditing: true };
    if (sharedData == null) {
      alert('Select a Setting first');
      return;
    }
    const newDepot = {
      depotId: Date.now(),
      depotName: "",
      street: "",
      zip: "",
      city: "",
      state: "",
      Latitude: "",
      Longitude: "",
      vDepotZone: zones[0],
      iSettingID: sharedData,
      isEditing: true
    };

    setAddingDepot(true)

    console.log(newDepot)
    setDepots([...depots, newDepot]);
    console.log(depots);
  };

  const fetchGeneralSettingsData = async () => {
    xCancelSourceForGrid.current = APICom.GenerateSource();
    // const iSettingID =124;
    try {
      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", `api/Settings/GetAlgoSettingsForGrid?iSettingID=${sharedData}`, "get",
        {}, {}, xCancelSourceForGrid.current
      );
      if (response?.data && response.data.length > 0) {
        setRouteStartUpCost(prevState => ({
          ...prevState,
          newRouteStartCost: response.data[0].dCallTimeMinWindow|| '',
          includeOutDepotTrip: (response.data[0].iAddDepotCost === 1 || response.data[0].iAddDepotCost === 3) || false,
          includeReturnDepotTrip: (response.data[0].iAddDepotCost === 2 || response.data[0].iAddDepotCost === 3) || false
        }));
        setCostOptimationParameter(prevState => ({
          ...prevState,
          travelCostPerDrivenMile: response.data[0].dUnitDistanceCost || '',
          travelCostPerDrivenMinute: response.data[0].dUnitTimeCost || '',
          costPerIdleMinute: response.data[0].dUnitIdleTimeCost || '',
          relaxedSlope: response.data[0].dOptimalThreshold || '',
          PUEarlyPenaltyUnitCost: response.data[0].PUEarlyPenaltyUnitCost || '',
          PULatePenaltyUnitCost: response.data[0].PULatePenaltyUnitCost || '',
          ApptEarlyPenaltyUnitCost: response.data[0].ApptEarlyPenaltyUnitCost || '',
          ApptLatePenaltyUnitCost:response.data[0].ApptLatePenaltyUnitCost || ''
        }));
        setRevenueOptimationParameter(prevState => ({
          ...prevState,
          revenuePerPessengerTravelMile: response.data[0].dRevenuePerDRM || '',
          revenuePerPessengerTravelMinute: response.data[0].dRevenuePerDRT || '',
          pickupFee: response.data[0].dPickUpFeePerTrip || '',
          milesIncludedInFee: response.data[0].dMinRevDRMPerTrip || '',
        }));
        // setDepots(response.data);
      } else {
        console.warn("No depots found.");
        // setDepots([]); // Ensure state is updated even if no data is returned
      }
    } catch (error) {
      console.error("Error fetching depot data:", error);
      // setDepots([]); // Reset state in case of an error
    }
  };


  const SaveDepotData = async (newDepot) => {

    if (!AddingDepot) {

      try {
        const payload = {
          iSettingID: sharedData,
          vSettingName: settingName,
          iDepot: newDepot.depotId,
          vDepotName: newDepot.depotName,
          vDepotAddress: newDepot.Street,
          vDepotState: "",
          vDepotCity: "",
          vDepotZip: "",
          vDepotLat: newDepot.Latitude,
          vDepotLong: newDepot.Longitude,
          bHoldingLot: true,
          vDepotZone: newDepot.vDepotZone
        };

        console.log(payload)

        xCancelSourceForGrid.current = APICom.GenerateSource();
        const response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Settings/UpdateDepot", "post", {}, payload, xCancelSourceForGrid.current);
        // Check if the API call was successful
        if (response?.data === true) {
          // setDepots(prevDepots => [...prevDepots, newDepot]);
          // setEditedDepot(null);
          console.log("Depot Updated successfully.");
          setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Depot Definitions", body: "Depot Updated Successfully", btnOkText: "OK" }));

        } else {
          console.error("Failed to update depot:", response?.data);
          setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Depot Definitions", body: "Depot Update Failed", btnOkText: "OK" }));

        }
      } catch (error) {
        console.error("Error adding depot:", error);
      }

    }
    else {
      try {
        const payload = {
          iSettingID: sharedData,
          vSettingName: settingName,
          iDepot: -1,
          vDepotName: newDepot.depotName,
          vDepotAddress: newDepot.Street,
          vDepotState: "",
          vDepotCity: "",
          vDepotZip: "",
          vDepotLat: newDepot.Latitude,
          vDepotLong: newDepot.Longitude,
          bHoldingLot: true,
          vDepotZone: newDepot.vDepotZone,
          bDefault:false
        };

        console.log(payload)

        xCancelSourceForGrid.current = APICom.GenerateSource();
        const response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Settings/AddDepot", "post", {}, payload, xCancelSourceForGrid.current);

        // Check if the API call was successful
        if (response?.data === true) {
          // setDepots(prevDepots => [...prevDepots, newDepot]);
          console.log("Depot added successfully.");
          setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Depot Definitions", body: "Depot Added Successfully", btnOkText: "OK" }));

          setAddingDepot(false);
          fetchDepotData();
        } else {
          //alert('Failed to add depot');
          setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Depot Definitions", body: "Depot Add Failed", btnOkText: "OK" }));

          console.error("Failed to add depot:", response?.data);
          setDepots(depots.filter(item=>item.depotId===newDepot.depotId));
        }
      } catch (error) {
        console.error("Error adding depot:", error);
      }

    }

  };

  const handleChange = (id, field, value) => {
    setDepots(depots.map(depot => depot.depotId === id ? { ...depot, [field]: value } : depot));
  };


  const [scheduleDays, setScheduleDays] = useState({
    Sunday: false, Monday: false, Tuesday: false,
    Wednesday: false, Thursday: false,
    Friday: false, Saturday: false
  });

  const [formData1, setFormData1] = useState({
    routingAlgorithm: '',
    timeHorizon: '',
    timeHorizonRhcg:'',
    rollingHorizon: '',
    tripPairBiasing: '',
    excludedFS: '',
    autoRoutingMode: '',
    periodicTimer: '',
    pinRTH: '',
    noOfMinutes1: '',
    noOfMinutes2: '',
    manualControl: '',
    ArialTimeAdjPercentage:'',
    dServiceStartTime:''
  });

  const toggleDay = (day) => {
    setScheduleDays(prev => ({ ...prev, [day]: !prev[day] }));
  };

  // const handleInputChange = (key, value) => {
  //   setFormData1(prev => ({ ...prev, [key]: value }));
  // };
  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const updatedBreakTimes = [...formData4.breakTimes];
    updatedBreakTimes[index][name] = value;

    // Update formData4 state with new break times
    setFormData4({
      ...formData4,
      breakTimes: updatedBreakTimes
    });
  };

  const handleInputChangeTwo = (index, e) => {
    const { name, value } = e.target;
    const updatedBreakTimes = [...formData6.breakTimes];
    updatedBreakTimes[index][name] = value;

    // Update formData4 state with new break times
    setFormData6({
      ...formData6,
      breakTimes: updatedBreakTimes
    });
  };
  const removeBreakTime = (index) => {
    const updatedBreakTimes = formData4.breakTimes.filter((_, i) => i !== index);
    setFormData4({
      ...formData4,
      breakTimes: updatedBreakTimes
    });
  };

  const removeBreakTimeTwo = (index) => {
    const updatedBreakTimes = formData6.breakTimes.filter((_, i) => i !== index);
    setFormData6({
      ...formData6,
      breakTimes: updatedBreakTimes
    });
  };

  const selectOptions = [{ value: "Option 01" }, { value: "Option 03" }, { value: "Option 04" },]
  const handleChangeSelect = (value) => {
    console.log(value)
  }



  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showDepotDetailModal, setShowDepotDetailModal] = useState(false);
  const [showDepotDetailModal2, setShowDepotDetailModal2] = useState(false);
  const [showBreakInputModal, setShowBreakInputModal] = useState(false);
  const [showBreakInputModalTwo, setShowBreakInputModalTwo] = useState(false);
  const [showDetailModal2, setShowDetailModal2] = useState(false);
  const [showDetailModal3, setShowDetailModal3] = useState(false);

  const [routeGroups, setRouteGroups] = useState([]);
  const [routeGroups2, setRouteGroups2] = useState([]);
  const [breaksRouteGroups2, setbreaksRouteGroups2] = useState([]);
  const [editedBreaksRouteGroups2, setEditedBreaksRouteGroups2] = useState([]);
  const [breaksRouteGroups, setbreaksRouteGroups] = useState([]);

  const [depotAttributeCombinationDetails, setDepotAttributeCombinationDetails] = useState([]);
  const [routetAttributeCombinationDetails, setRouteAttributeCombinationDetails] = useState([]);
  const [routeTempAttributeCombinationDetails, setRouteTempAttributeCombinationDetails] = useState([]);

  // const [zones, setzones] = useState([]);
  const [formData3, setFormData3] = useState({
    templateName: '',
    routePrefixAndStartingNumber: '',
    vehicle: '',
    numberOfRoutes: '',
    depot: '',
    vehicleType: '',
    startTime: '',
    recAffiliate: '',
    duration: '',
    miles: '',
    breakTimes: [],
    attribute: '',
    activeVehCheck: false
  });

  const [formData2, setFormData2] = useState({
    templateName: '',
    routeNumber: '',
    vehicleNumber: '',
    depot: '',
    vehicleType: '',
    startTime: '',
    recAffiliate: '',
    duration: '',
    miles: '',
    breakTimes: [],
    attribute: ''
  });
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedDepot, setSelectedDepot] = useState(null);
  const [selectedDepot2, setSelectedDepot2] = useState(null);
  // const [editedDepot, setEditedDepot] = useState(null);
  // const [depotAdded, setDepotAdded] = useState(false);

  const [selectedGroup2, setSelectedGroup2] = useState(null);
  const [selectedGroup3, setSelectedGroup3] = useState(null);

  // const handleChange3 = (e) => {
  //   const { name, value } = e.target;
  //   setFormData3(prev => ({
  //     ...prev,
  //     [name]: value
  //   }));
  // };
  const handleChange3 = (e) => {
    const { name, value, type, checked } = e.target;

    // If the input type is checkbox, use `checked` otherwise use `value`
    setFormData3(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleChangeDepotAttributeCombinationPopup = (e) => {
    const { name, value, type, checked } = e.target;
    console.log('here');
    // If the input type is checkbox, use `checked` otherwise use `value`
    setFormData5(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleChangeDepotAttributeCombinationPopup2 = (e) => {
    const { name, value, type, checked } = e.target;
    console.log('here');
    // If the input type is checkbox, use `checked` otherwise use `value`
    setFormData7(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleChange4 = (e) => {
    const { name, value, type, checked } = e.target;
    // console.log(name+' '+value+' '+type+' '+checked);
    //  console.log(name+' '+value+' '+type+' '+checked);
    console.log(type === 'checkbox' ? checked + ' ' + name : value);
    // If the input type is checkbox, use `checked` otherwise use `value`
    setFormData4(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    if(name=='vehicle' && value==''){
      setFormData4(prev => ({
        ...prev,
        ['activeVehCheck']: false
      }));
    }
        try {
      //setVehNum(e?.target?.value);
      if(name=='vehicle' && value!=''){
      let vehicleTypeVar = (vehDataRef?.current?.find(item => parseInt(item.VehicleID) == parseInt(e?.target?.value?.split("_")[0])));
      if (vehicleTypeVar?.VehicleType != 'Select'){
              //setVehType(vehicleTypeVar?.VehicleType);
                  setFormData4(prev => ({
                    ...prev,
                    ['vehicleType']:vehicleTypeVar?.VehicleType
                  }));
      }
    }
    if(name=='vehicleType'){
                  setFormData4(prev => ({
                    ...prev,
                    ['vehicle']:''
                  }));
    }
    }
    catch (err) { console.log(err); }
    console.log(type === 'checkbox' ? checked + ' ' + name : value);

  };

  const handleChange5 = (e) => {
    const { name, value, type, checked } = e.target;
    // console.log(name+' '+value+' '+type+' '+checked);
    //  console.log(name+' '+value+' '+type+' '+checked);
    console.log(type === 'checkbox' ? checked + ' ' + name : value);
    // If the input type is checkbox, use `checked` otherwise use `value`
    setFormData6(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    console.log(type === 'checkbox' ? checked + ' ' + name : value);

  };
  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setFormData2(prev => ({
      ...prev,
      [name]: value
    }));
  };
  function getDateInYMDFormat(date = new Date()) {
    // Get the year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');  // Months are 0-indexed, so add 1
    const day = String(date.getDate()).padStart(2, '0');  // Ensure day is two digits

    // Format the date as Y-M-D
    return `${year}-${month}-${day}`;
}
  const handleSave3 = async (iRouteID = null) => {
    // setRouteGroups([...routeGroups, formData]);
    if (sharedData != null) {
      console.log(formData4);
      let params = {
        "vSettingName": settingName,
        "dtSelectedDate": getDateInYMDFormat(),
        // "vRoute": "0" + AffID + "-" + formData4?.routeNo || '',
        "vRoute": (AffID.toString().padStart(3, "0")) + "-" + (formData4?.routeNo || ""),
        "vVehNum": formData4?.vehicle || '',
        "vDepotNum": String(formData4?.depot) || '',
        "ManifestSettings": false,
        "vVehicleType": formData4?.vehicleType || '',
        "bActiveInAvtiveVeh": formData4?.activeVehCheck || false,
        // "bUpdateActiveInActiveVehFromCshkBox": false,
        "RouteDuration": formData4?.duration || 0,
        "dRouteMiles":formData4?.miles || 0,
        "RouteStartTime": formData4?.startTime || '',
        "iSettingID": sharedData || 0,
        "iRouteID": 0, //RouteIDSelectedForDay,
        "attributeID": formData4?.attribute || '',
        "receivingAffiliateID": formData4?.recAffiliate || 0,
        "iFromAlgoSetting": 2,
        "bDefaultRoute":formData4?.defaultRouteCheck
      }
      if (iRouteID != null) {
        params.iRouteID = iRouteID;
        params.iFromAlgoSetting = 3;
        params.vRoute = formData4?.routeNo || '';
      }
      try {
        if(params.RouteStartTime==='' || formData4?.routeNo==='' || formData4?.duration===''){
          let missing = [];

          if (params.RouteStartTime === '') {
            missing.push("StartTime");
          }
          if (formData4?.routeNo === '') {
            missing.push("RouteNo");
          }
          if (formData4?.duration === '') {
            missing.push("Duration");
          }

          if (missing.length > 0) {
            let message = "Route " + missing.join(", ") + " can't be empty";
            alert(message);
          }
          // setFormData4(prev => ({
          //   ...prev,
          //   vehicle: '',
          //   routeNo: '',
          //   depot: '',
          //   vehicleType: '',
          //   startTime: '',
          //   recAffiliate: '',
          //   duration: '',
          //   miles: '',
          //   breakTimes: [],
          //   attribute: '',
          //   activeVehCheck: false
          // }));
          return;
        }
        xCancelSourceForGrid.current = APICom.GenerateSource();
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UpdateRouteInfo", "post", {}, params, xCancelSourceForGrid.current);
        let result = response?.data;
        if (result[0]?.Passed == "true") {

          if (formData4?.breakTimes) {
            for (let [index, breakTime] of formData4.breakTimes.entries()) {
              try {
                // Your logic for each breakTime
                // xCancelSourceForGrid.current = APICom.GenerateSource();
                let params = {
                  hrsFromRouteStartTime: breakTime.startHours,
                  breakDuration: breakTime.duration,
                  breakLateWindow: breakTime.lateWindow,
                  breakStartTime: breakTime.startTime,
                  breakEarlyWindow: breakTime.earlyWindow,
                  bRecords: false,
                  vManifestNumber:getTodayDate()+"0"+AffID+"-"+formData4?.routeNo || '',
                  updateSelection: 2,
                  iSettingID: sharedData
                };
                console.log(params);
                // Make the async request
                let response = await APICom.fetchData(
                  "GenericManifestDotNetCoreURL",
                  // "api/Settings/UpdateRouteBreakTime",
                  `api/Routing/UpdateBreakTimes`,
                  "post",
                  {},
                  params,
                  xCancelSourceForGrid.current
                );

                let result = response?.data;
                if (result) {
                  console.log(`adding Break index ${index} successful`);
                }
                // Handle result if needed
              } catch (error) {
                console.error(`Error at adding Breakindex ${index}:`, error);
              }
            }
          }
          // setRouteGroups2([...routeGroups2, formData4]);
          setShowModal3(false);
          // console.log(routeGroups2);
              setFormData4(prev => ({
              ...prev,
              vehicle: '',
              routeNo: '',
              depot: '',
              vehicleType: '',
              startTime: '',
              recAffiliate: '',
              duration: '',
              breakTimes: [],
              attribute: '',
              activeVehCheck: false,
              defaultRouteCheck:false,
              miles:''

            }));
            
            setRouteAdded(-1);
            setRouteEdited(-1);
             setRouteGroups2(prevArray => {
                  const newArray = [...prevArray];
                  newArray.pop();
                  return newArray;
                  });
            setIsButtonDisabled(false);
            if (iRouteID != null) {
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Route Definition", body: "Route Updated Successfully", btnOkText: "OK" }));
            }
            else{
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Route Definition", body: "Route Added Successfully", btnOkText: "OK" }));

            }
            fetchRouteDefinitionData();

        }
        else {// alert('route save failed'); 
                      if (iRouteID != null) {
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Route Definition", body: "Route Update Failed", btnOkText: "OK" }));
            }
            else{
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Route Definition", body: "Route Add Failed", btnOkText: "OK" }));

            }
        }
      }
      catch (error) {
        console.error('Error saving route:', error);
      }
    }
    else {
      alert('Select a Setting First');
    }
    // setFormData4(prev => ({
    //   ...prev,
    //   vehicle: '',
    //   routeNo: '',
    //   depot: '',
    //   vehicleType: '',
    //   startTime: '',
    //   recAffiliate: '',
    //   duration: '',
    //   breakTimes: [],
    //   attribute: '',
    //   activeVehCheck: false
    // }));
  };
  const handleSave2 = () => {
    setRouteGroups2([...routeGroups2, formData2]);
    setShowModal2(false);
  };
  const handleBreakTimeChange = (index, e) => {
    const { name, value } = e.target;
    const newBreakTimes = [...formData.breakTimes];
    newBreakTimes[index][name] = value;
    setFormData(prev => ({
      ...prev,
      breakTimes: newBreakTimes
    }));
  };

  const handleBreakTimeChange2 = (index, e) => {
    const { name, value } = e.target;
    const newBreakTimes = [...formData2.breakTimes];
    newBreakTimes[index][name] = value;
    setFormData2(prev => ({
      ...prev,
      breakTimes: newBreakTimes
    }));
  };
  const addZoneDetailsToAttrbiuteRefTable = async (Id, RefName) => {
    try {
      const pickupAttributeID = pickupAttributes?.find(attr => attr?.vTitle === formData5?.pickupattribute)?.iID;
      const dropoffAttributeID = dropoffAttributes?.find(attr => attr?.vTitle === formData5?.dropoffattribute)?.iID;
      console.log(pickupAttributeID);
      console.log(dropoffAttributeID);
      // const isPickupValid = pickupAttributeID != null && pickupAttributeID !== -1 && pickupAttributeID !== '' && pickupAttributeID!==undefined;
      // const isPickupValid = pickupAttributeID != null && pickupAttributeID !== -1 ;
      // const isDropoffValid = dropoffAttributeID != null && dropoffAttributeID !== -1 && dropoffAttributeID !== '' && dropoffAttributeID!==undefined;
      // const isDropoffValid = dropoffAttributeID != null && dropoffAttributeID !== -1;
      // if (!isPickupValid && !isDropoffValid) {
      //   alert('no pickup/dropoff attribute(s)  attached');
      //   return;
      // }
      let params = {
        "iSettingID": sharedData,
        "iPickupAttributeID": pickupAttributeID,
        "iDropoffAttributeID": dropoffAttributeID,
        "RefName": RefName,
        "REFID": Id,
        "TripType": '2'
      };
      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Settings/AddAttributeCombination", "post", {}, params, xCancelSourceForGrid.current);


      if (response?.data) {

        fetchDepotData();
        fetchRouteDefinitionData();
        alert('Attribute Combination added successfully');
        setFormData5(prev => ({
          ...prev,
          pickupattribute: '',
          dropoffattribute: '',
          triptype: ''
        }));

      } else {
        console.log('No Attribute Combination added.');
      }
    } catch (error) {
      console.error('Error adding Attribute Combination :', error);
    }
  };
  const addZoneDetailsToRoute = () => {
    setFormData4(prev => ({
      ...prev,
      zonedetails: [...prev?.zonedetails || [], {
        pickupattribute: '',
        dropoffattribute: ''
      }]
    }));

  };
  const addBreakTime = () => {
    setFormData4(prev => ({
      ...prev,
      breakTimes: [...prev?.breakTimes || [], {
        startTime: '',
        startHours: '',
        earlyWindow: '',
        lateWindow: '',
        duration: ''
      }]
    }));
  };

  const addBreakTimeTwo = () => {
    setFormData6(prev => ({
      ...prev,
      breakTimes: [...prev?.breakTimes || [], {
        startTime: '',
        startHours: '',
        earlyWindow: '',
        lateWindow: '',
        duration: ''
      }]
    }));
  };

  const addBreakTime2 = () => {
    setFormData2(prev => ({
      ...prev,
      breakTimes: [...prev?.breakTimes || [], {
        startTime: '',
        startHours: '',
        earlyWindow: '',
        lateWindow: '',
        duration: ''
      }]
    }));
  };

  // const removeBreakTime = (index) => {
  //   const newBreakTimes = formData?.breakTimes.filter((_, i) => i !== index);
  //   setFormData(prev => ({
  //     ...prev,
  //     breakTimes: newBreakTimes
  //   }));
  // };

  const removeBreakTime2 = (index) => {
    const newBreakTimes = formData2?.breakTimes.filter((_, i) => i !== index);
    setFormData2(prev => ({
      ...prev,
      breakTimes: newBreakTimes
    }));
  };

  const handleViewDetails = (group) => {
    setSelectedGroup(group);
    setShowDetailModal(true);
  };

  const handleZoneDetails = (depot) => {
    setSelectedDepot(depot);
    setShowDepotDetailModal(true);
  };

  const handleZoneDetails2 = (depot) => {
    setSelectedDepot2(depot);
    setShowDepotDetailModal2(true);
  };

  const handleViewDetails2 = (group) => {
    setSelectedGroup2(group);
    // setBreakTimeEdited(breaksRouteGroups2.filter(item => item.routeNumber === selectedGroup2.Route || selectedGroup2.routeNo));
    setShowDetailModal2(true);
  };

  const handleViewDetails3 = (group) => {
    setSelectedGroup3(group);
    setShowDetailModal3(true);
  };

  const handleDelete = async (group) => {
    try {
      let params = {
        // "vRoute": group.Route,
        "iSettingID": sharedData,
        "iID": group.iID,
        "reqDate": getFormattedDate()
      };
      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/DeleteRouteTemplate", "post", {}, params, xCancelSourceForGrid.current);


      if (response?.data) {
        // console.log(response.data);
        // setRouteGroups2(response.data);
        //alert('Route Template deleted successfully');
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Route Template Definition", body: "Route Template Deleted Successfully", btnOkText: "OK" }));

        const newRouteGroups = routeGroups.filter(g => g !== group);
        setRouteGroups(newRouteGroups);
        fetchRouteDefinitionData();
        // const newRouteGroups = routeGroups2.filter(g => g !== group);
        // setRouteGroups2(newRouteGroups);
        // const tableData = response.data.Table;
        // ""
        //setApiData(tableData); // Store the Table data in the state

      } else {
        console.log('No route template deleted.');
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Route Template Definition", body: "Route Template Deletion Failed", btnOkText: "OK" }));

      }
    } catch (error) {
      console.error('Error deleting route template :', error);
    }

  }
  const getFormattedDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Get month and pad it to ensure it's two digits
    const day = String(today.getDate()).padStart(2, '0'); // Get day and pad it to ensure it's two digits

    return `${year}${month}${day}`;
  };
  const handleDelete2 = async (group) => {
    try {
      let params = {
        "vRoute": group.Route,
        "iSettingID": sharedData,
        "reqDate": getFormattedDate()
      };
      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/DeleteRoute", "post", {}, params, xCancelSourceForGrid.current);


      if (response?.data) {
        // console.log(response.data);
        // setRouteGroups2(response.data);
        //alert('Route deleted successfully');
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Route Definition", body: "Route deleted Successfully", btnOkText: "OK" }));

        fetchRouteDefinitionData();
        // const newRouteGroups = routeGroups2.filter(g => g !== group);
        // setRouteGroups2(newRouteGroups);
        // const tableData = response.data.Table;
        // ""
        //setApiData(tableData); // Store the Table data in the state

      } else {
        console.log('No route deleted.');
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Route Definition", body: "Route Delete Failed", btnOkText: "OK" }));

      }
    } catch (error) {
      console.error('Error deleting route:', error);
    }

  }
  const handleDuplicates = (dict, title) => {
    try {
      let newArray = [];
      let uniqueObject = {};

      for (var j in dict) {
        let objTitle = dict[j][title];
        uniqueObject[objTitle] = dict[j];
      }
      for (var u in uniqueObject) {
        newArray.push(uniqueObject[u]);
      }
      return newArray;
    }
    catch (err) { console.log(err); }
  };
  useEffect(() => {
    // console.log('AFFID CHANGED');
    setSharedData(null);
    setIterations({});
    setRouteGroups([]);
    setRouteGroups2([]);
    // setEditedDepot(null);
    setDepots([]);
    setRouteStartUpCost(prevState => ({
      ...prevState,
      newRouteStartCost: '',
      includeOutDepotTrip: false,
      includeReturnDepotTrip: false
    }));
    setCostOptimationParameter(prevState => ({
      ...prevState,
      travelCostPerDrivenMile: '',
      travelCostPerDrivenMinute: '',
      costPerIdleMinute: '',
      relaxedSlope: '',
      PUEarlyPenaltyUnitCost: '',
      PULatePenaltyUnitCost: '',
      ApptEarlyPenaltyUnitCost: '',
      ApptLatePenaltyUnitCost:''
    }));
    setRevenueOptimationParameter(prevState => ({
      ...prevState,
      revenuePerPessengerTravelMile: '',
      revenuePerPessengerTravelMinute: '',
      pickupFee: '',
      milesIncludedInFee: '',
    }));
    setoperationConstraintsData1(prevState => ({
      ...prevState,
      maxTripsPerRoute: '',
      // earliestStartTime: '',
      maxRouteMiles:'',
      disableRideSharing: false,
      fixedStartTime: false,
      maxRouteDuration: '',
      maxUniqueStops:'',
      iOtherManualActionsAlgoTypeID:'',
      iPredictiveAlgoTypeID:'',
      iFinalRunAlgoTypeID:'',
      iPeriodicAlgoTypeID:'',
      iManBatchRoutingAlgoTypeID:'',
      iManSingleRoutingAlgoTypeID:''
    }));
    setPickupWindow(prevState => ({
      ...prevState,
      earliestDesired: '',
      earliestRelaxed: '',
      lateDesired: '',
      lateRelaxed: ''
    }));
    setDropOffWindow(prevState => ({
      ...prevState,
      earliestDesired: '',
      earliestRelaxed: '',
      latestDesired: '',
      latestRelaxed: ''
    }));
    setMaxRideTime(prevState => ({
      ...prevState,
      shortDesired: '',
      shortRelaxed: '',
      longDesired: '',
      longRelaxed: ''
    }));
    setServiceTime(prevState => ({
      ...prevState,
      singleAmb: '',
      singleWc: '',
      additionalAmb: '',
      additionalWc: ''
    }));
    setoperationConstraintsData(prevState => ({
      ...prevState,
      routingAlgorithm: '',
      timeHorizon: '',
      timeHorizonRhcg:'',
      rollingHorizon: '',
      tripPairBiasing: false,
      autoRoutingMode: '',
      periodicTimer: '',
      iOtherManualActionsAlgoTypeID:'',
      ArialTimeAdjPercentage:'',
      dServiceStartTime:''
    }));
    SetFundingSourceFilterMultiSelect(prevState => ({
      ...prevState,
      selectedValues: []
    }));
    setRouteAdded(-1);
    setRouteEdited(-1);

    setFormData4(prev => ({
      ...prev,
      vehicle: '',
      routeNo: '',
      depot: '',
      vehicleType: '',
      startTime: '',
      recAffiliate: '',
      duration: '',
      breakTimes: [],
      attribute: '',
      activeVehCheck: false,
      defaultRouteCheck:false,
      miles:''

    }));
  }, [AffID]);

  useEffect(() => {
    // console.log('AFFID CHANGED');
    //startLoading()
    // fetchRouteDefinitionData();
    // fetchRouteDefinitionSettingsData();

    //stopLoading()
      const loadData = async () => {
    startLoading();
    try {
      //await fetchDepotData();
      await fetchRouteDefinitionData();
      await fetchRouteDefinitionSettingsData();
    } catch (err) {
      console.error("Error loading:", err);
    } finally {
      setTimeout(() => {
        stopLoading();
      }, 2000); // Delay 500ms
    }
  };
if(sharedData){
  loadData();
}
  }, [sharedData]);

  // useEffect(() => {
    // let attributeComponentHTML =  AttributeDataRef.current.map(function (item, index) {
    //   return (

    //     <div key={index} className="checkbox-item">
    //       <input
    //         type="checkbox"
    //         id={item.iID}
    //         value={item.iID}
    //         checked={formData4.attribute.split(',').includes(String(item.iID))}
    //         onChange={handleCheckboxChange2} // onChange handler for each checkbox
    //       />
    //       <label htmlFor={item.iID}>{item.vTitle}</label>
    //     </div>
    //   );
    // });

    // let attributeTempComponentHTML =  AttributeDataRef.current.map(function (item, index) {
    //   return (

    //     <div key={index} className="checkbox-item">
    //       <input
    //         type="checkbox"
    //         id={item.iID}
    //         value={item.iID}
    //         checked={formData6.attribute.split(",").includes(String(item.iID))}
    //         onChange={handleCheckboxChange3} // onChange handler for each checkbox
    //       />
    //       <label htmlFor={item.iID}>{item.vTitle}</label>
    //     </div>
    //   );
    // });

    // setRouteTempAttributeDropDownHTML(attributeTempComponentHTML);
    // setRouteAttributeDropDownHTML(attributeComponentHTML);
  // }, [formData6.attribute]);

  const zoneOptions = ['Zone A', 'Zone B', 'Zone C', 'Zone D', 'Zone E'];

  // Initial state
  const [cijSlowDownn, setCijSlowDownn] = useState([]);

  // Generate unique ID for new rows
  const generateId = () => {
    return Date.now().toString();
  };

  // Add new row
  const handleAddd = () => {
    const newRow = {
      id: generateId(),
      fromZone: '',
      toZone: '',
      multiplier: '',
      applyReverse: 'No',
      isEditing: true
    };

    setCijSlowDownn([...cijSlowDownn, newRow]);
  };

  // Handle deleting a row
  const handleDeletee = (id) => {
    setCijSlowDownn(cijSlowDownn.filter(row => row.id !== id));
  };

  // Toggle edit mode
  const handleEditt = (id) => {
    setCijSlowDownn(cijSlowDownn.map(row => {
      if (row.id === id) {
        return { ...row, isEditing: !row.isEditing };
      }
      return row;
    }));
  };

  // Handle field changes
  const handleChangee = (id, field, value) => {
    setCijSlowDownn(cijSlowDownn.map(row => {
      if (row.id === id) {
        return { ...row, [field]: value };
      }
      return row;
    }));
  };
  return (
    <div >
{loadingCount > 0 && (
  <div style={{
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw', height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.4)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }}>
    <Spinner animation="border" variant="success" />
  </div>
)}
      {/* <div style={{ display: 'flex', flexDirection: 'column', width: '50%', gap: '20px' }}> */}
      <div style={{ width: '50%' }}>
        <AlgoSettingsComponent AffiliateID={AffID} SettingType={SettingType} onDataChange={handleDataChange}></AlgoSettingsComponent>
      </div>
      {/* </div> */}
      {/* Tab Buttons */}
      {/* Tab Buttons with modern style */}
      <div style={{ display: 'flex' }}>
        <button
          onClick={() => handleTabSwitch('Route Builder')}
          style={{
            ...tabButtonStyle,
            ...(activeTab === 'Route Builder' ? activeTabStyle : {}),
            ...(activeTab !== 'Route Builder' ? hoverTabStyle : {}),
            marginRight: '8px',
          }}
        >
          General Settings
        </button>
        <button
          onClick={() => handleTabSwitch('Constraints')}
          style={{
            ...tabButtonStyle,
            ...(activeTab === 'Constraints' ? activeTabStyle : {}),
            ...(activeTab !== 'Constraints' ? hoverTabStyle : {}),
            marginRight: '8px',
          }}
        >
          Constraints
        </button>
        <button
          onClick={() => handleTabSwitch('Cost Revenue Settings')}
          style={{
            ...tabButtonStyle,
            ...(activeTab === 'Cost Revenue Settings' ? activeTabStyle : {}),
            ...(activeTab !== 'Cost Revenue Settings' ? hoverTabStyle : {}),
            marginRight: '8px',
          }}
        >
          Cost Revenue Settings
        </button>
        {/* <button
          onClick={() => handleTabSwitch('Depot Definitions')}
          style={{
            ...tabButtonStyle,
            ...(activeTab === 'Depot Definitions' ? activeTabStyle : {}),
            ...(activeTab !== 'Depot Definitions' ? hoverTabStyle : {}),
            marginRight: '8px',
          }}
        >
          Depot Definitions
        </button> */}
        {SettingType !== 4 && (
  <button 
    onClick={() => handleTabSwitch('Depot Definitions')}
    style={{
      ...tabButtonStyle,
      ...(activeTab === 'Depot Definitions' ? activeTabStyle : {}),
      ...(activeTab !== 'Depot Definitions' ? hoverTabStyle : {}),
      marginRight: '8px',
    }}
  >
    Depot Definitions
  </button>
)}
 {SettingType !== 4 && (
        <button
          onClick={() => handleTabSwitch('Route Definitions')}
          style={{
            ...tabButtonStyle,
            ...(activeTab === 'Route Definitions' ? activeTabStyle : {}),
            ...(activeTab !== 'Route Definitions' ? hoverTabStyle : {}),
            marginRight: '8px',
          }}
        >
          Route Definitions
        </button>
)}
 {SettingType !== 4 && SettingType !== 6 && (

        <button
          onClick={() => handleTabSwitch('Multi Iterations')}
          style={{
            ...tabButtonStyle,
            ...(activeTab === 'Multi Iterations' ? activeTabStyle : {}),
            ...(activeTab !== 'Multi Iterations' ? hoverTabStyle : {}),
            marginRight: '8px',
          }}
        >
          Multi Iterations
        </button>
 )}
        {/* <button
          onClick={() => handleTabSwitch('Cij Slow Down')}
          style={{
            ...tabButtonStyle,
            ...(activeTab === 'Cij Slow Down' ? activeTabStyle : {}),
            ...(activeTab !== 'Cij Slow Down' ? hoverTabStyle : {}),
            marginRight: '8px',
          }}
        >
         Cij Slow Down
        </button> */}

      </div>
      <div style={{ marginTop: '20px' }}>
        {activeTab === 'Cij Slow Down' && (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

            <Card style={{ width: "40%" }} className="mb-4 ">
              <div className="container mt-4">

                <div className="mb-4">
                  <div className="bg-success text-white p-2 mb-2 w-25 mx-auto text-center">
                    CIJ Slow Down
                  </div>
                  <div className="container mt-4">
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead className="thead-dark">
                          <tr>
                            <th style={{ width: "150px" }}>Action</th>
                            <th style={{ width: "200px" }}>From Zone</th>
                            <th style={{ width: "200px" }}>To Zone</th>
                            <th style={{ width: "200px" }}>Multiplier</th>
                            <th style={{ width: "200px" }}>Apply Reverse</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cijSlowDownn.length === 0 ? (
                            <tr>
                              <td colSpan="5" className="text-center">
                                <button className="btn btn-secondary" onClick={handleAddd}><FontAwesomeIcon icon={faPlus} /></button>
                              </td>
                            </tr>
                          ) : (
                            cijSlowDownn.map((row, index) => (
                              <tr key={row.id}>
                                <td>
                                  {index + 1 === cijSlowDownn.length && (
                                    <button
                                      className="btn btn-primary btn-sm me-2"
                                      onClick={handleAddd}
                                    >
                                      <FontAwesomeIcon icon={faPlus} />
                                    </button>
                                  )}
                                  <button
                                    className="btn btn-warning btn-sm me-2"
                                    onClick={() => handleEditt(row.id)}
                                  >
                                    {row.isEditing ? (
                                      <FontAwesomeIcon icon={faSave} />
                                    ) : (
                                      <FontAwesomeIcon icon={faPencilAlt} />
                                    )}
                                  </button>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleDeletee(row.id)}
                                  >
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                  </button>
                                </td>
                                <td>
                                  {row.isEditing ? (
                                    <select
                                      className="form-select"
                                      value={row.fromZone}
                                      onChange={(e) => handleChangee(row.id, "fromZone", e.target.value)}
                                    >
                                      <option value="">Select Zone</option>
                                      {zoneOptions.map(zone => (
                                        <option key={zone} value={zone}>{zone}</option>
                                      ))}
                                    </select>
                                  ) : (
                                    row.fromZone || '-'
                                  )}
                                </td>
                                <td>
                                  {row.isEditing ? (
                                    <select
                                      className="form-select"
                                      value={row.toZone}
                                      onChange={(e) => handleChangee(row.id, "toZone", e.target.value)}
                                    >
                                      <option value="">Select Zone</option>
                                      {zoneOptions.map(zone => (
                                        <option key={zone} value={zone}>{zone}</option>
                                      ))}
                                    </select>
                                  ) : (
                                    row.toZone || '-'
                                  )}
                                </td>
                                <td>
                                  {row.isEditing ? (
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={row.multiplier}
                                      onChange={(e) => handleChangee(row.id, "multiplier", e.target.value)}
                                    />
                                  ) : (
                                    row.multiplier || '-'
                                  )}
                                </td>
                                <td>
                                  {row.isEditing ? (
                                    <select
                                      className="form-select"
                                      value={row.applyReverse}
                                      onChange={(e) => handleChangee(row.id, "applyReverse", e.target.value)}
                                    >
                                      <option value="Yes">Yes</option>
                                      <option value="No">No</option>
                                    </select>
                                  ) : (
                                    row.applyReverse || 'No'
                                  )}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>



            </Card>
          </div>
        )}
        {activeTab === 'Cost Revenue Settings' && (
          <div>
            {/* Content for Cost Revenue Settings */}
            {/* <GeneralSettingsComponent data={sharedData}></GeneralSettingsComponent> */}
            <Card style={{ width: "100%" }} className="mb-4">
              <div className="gap-2 d-flex flex-column flex-md-row justify-content-between">
                {/* Left section */}
                <div className="border col-12 col-md-6 border-1 border-dark p-3 mb-4">
                  <div className="text-white p-2 mb-2 w-50 mx-auto text-center" style={{ backgroundColor: '#87CEFA' }}>
                    Route Startup Cost & Depot Consideration
                  </div>
                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">New Route Start Cost ($)</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          name="newRouteStartCost"
                          value={routeStartUpCost.newRouteStartCost}
                          onChange={handleStartUpCost}
                          className="border border-dark p-2"
                          placeholder="miles"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Include Out Depot Trip</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <input
                        type="checkbox"
                        style={{ transform: 'scale(1.5)' }} // Adjust scale to make the checkbox bigger
                        name="includeOutDepotTrip"
                        checked={routeStartUpCost.includeOutDepotTrip}
                        onChange={() => setRouteStartUpCost(prev => ({
                          ...prev,
                          includeOutDepotTrip: !prev.includeOutDepotTrip,  // Toggle the value
                        }))}
                      />
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Include Return Depot Trip</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <input
                        type="checkbox"
                        style={{ transform: 'scale(1.5)' }} // Adjust scale to make the checkbox bigger
                        name="includeReturnDepotTrip"
                        checked={routeStartUpCost.includeReturnDepotTrip}
                        onChange={() => setRouteStartUpCost(prev => ({
                          ...prev,
                          includeReturnDepotTrip: !prev.includeReturnDepotTrip,  // Toggle the value
                        }))}
                      />
                    </div>
                  </div>

                  <div className="text-white p-2 mb-2 w-50 mx-auto text-center" style={{ backgroundColor: '#87CEFA' }}>
                    Cost Optimization Parameter
                  </div>
                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Travel Cost Per Driven Mile (miles)</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          name="travelCostPerDrivenMile"
                          value={costOptimationParameter.travelCostPerDrivenMile}
                          onChange={handleCostOptimation}
                          className="border border-dark p-2"
                          placeholder="miles"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Travel Cost Per Driven Minute ($)</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          name="travelCostPerDrivenMinute"
                          value={costOptimationParameter.travelCostPerDrivenMinute}
                          onChange={handleCostOptimation}
                          className="border border-dark p-2"
                          placeholder="$"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Cost Per Idle Minute ($)</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          name="costPerIdleMinute"
                          value={costOptimationParameter.costPerIdleMinute}
                          onChange={handleCostOptimation}
                          className="border border-dark p-2"
                          placeholder="$"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Min. Profit Growth Margin (%)</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          name="relaxedSlope"
                          value={costOptimationParameter.relaxedSlope}
                          onChange={handleCostOptimation}
                          className="border border-dark p-2"
                          placeholder="$"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right section */}
                <div className="border col-12 col-md-6 border-1 border-dark p-3 mb-4">
                  <div className="text-white p-2 mb-2 w-50 mx-auto text-center" style={{ backgroundColor: '#87CEFA' }}>
                    Revenue Optimization Parameter
                  </div>
                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Revenue Per Passenger Travel Mile ($)</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          name="revenuePerPessengerTravelMile"
                          value={revenueOptimationParameter.revenuePerPessengerTravelMile}
                          onChange={handleRevenueOptimationParameterChange}
                          className="border border-dark p-2"
                          placeholder="$"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Revenue Per Passenger Travel Minute ($)</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          name="revenuePerPessengerTravelMinute"
                          value={revenueOptimationParameter.revenuePerPessengerTravelMinute}
                          onChange={handleRevenueOptimationParameterChange}
                          className="border border-dark p-2"
                          placeholder="$"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Pickup Fee (min Rev. per Trip) ($)</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          name="pickupFee"
                          value={revenueOptimationParameter.pickupFee}
                          onChange={handleRevenueOptimationParameterChange}
                          className="border border-dark p-2"
                          placeholder="$"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Miles included in Fee (miles)</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          name="milesIncludedInFee"
                          value={revenueOptimationParameter.milesIncludedInFee}
                          onChange={handleRevenueOptimationParameterChange}
                          className="border border-dark p-2"
                          placeholder="miles"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="text-white p-2 mb-2 w-50 mx-auto text-center" style={{ backgroundColor: '#87CEFA' }}>
                    Penalty Cost Parameters
                  </div>
                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Cost Per Early PU Time Deviation Minutes ($)</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          name="PUEarlyPenaltyUnitCost"
                          value={costOptimationParameter.PUEarlyPenaltyUnitCost}
                          onChange={handleCostOptimation}
                          className="border border-dark p-2"
                          placeholder="$"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Cost Per Late PU Time Deviation Minutes ($)</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          name="PULatePenaltyUnitCost"
                          value={costOptimationParameter.PULatePenaltyUnitCost}
                          onChange={handleCostOptimation}
                          className="border border-dark p-2"
                          placeholder="$"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Cost Per Early Appointment Deviation Minutes ($)</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          name="ApptEarlyPenaltyUnitCost"
                          value={costOptimationParameter.ApptEarlyPenaltyUnitCost}
                          onChange={handleCostOptimation}
                          className="border border-dark p-2"
                          placeholder="$"
                        />
                      </div>
                    </div>
                  </div>

                           <div className="mb-3 row">
                    <div className="col-12 col-md-3">
                      <div className="border border-dark p-2 fw-bold">Cost Per Late Appointment Deviation Minutes ($)</div>
                    </div>
                    <div className="col-12 col-md-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="number"
                          name="ApptLatePenaltyUnitCost"
                          value={costOptimationParameter.ApptLatePenaltyUnitCost}
                          onChange={handleCostOptimation}
                          className="border border-dark p-2"
                          placeholder="$"
                        />
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>

              <div className="d-flex justify-content-end mt-4 m-3">
                <Button
                  className="bg-secondary text-white text-center"
                  variant="primary"
                  onClick={handleSave}
                >
                  Save Settings
                </Button>
              </div>
            </Card>

                                    <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj.show}
              Title={confirmationModalObj.title}
              Body={confirmationModalObj.body}
              onOk={handleConfirmationModalOk1}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj.btnCanceText}
              btnOkText={confirmationModalObj.btnOkText}
              ShowCancelButton={"true"}
            />
            <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj1.show}
              Title={confirmationModalObj1.title}
              Body={confirmationModalObj1.body}
              onOk={handleConfirmationModalClose}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj1.btnCanceText}
              btnOkText={confirmationModalObj1.btnOkText}
              ShowCancelButton={"false"}
            />
          </div>
        )}
        {activeTab === 'Constraints' &&
          (
            <div
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {/*--------------------------------------------------------------------------------------------------------------*/}
              {/* Content for Route Definitions */}
              <Card style={{ width: "70%" }} className="mb-4">
                <div className="container mt-4">
                  {/* Operation Constraints Section */}
                  <div className="border border-1 border-dark p-3 mb-4">
                    <div className="text-white p-2 mb-2 w-25 mx-auto text-center" style={{ backgroundColor: '#87CEFA' }}>
                      Operation Constraints
                    </div>
                    <div className="mb-3 row">
                      <div className="col-md-3">
                        <div className="border border-dark p-2 fw-bold">Max Route Duration Hrs.</div>
                      </div>
                      <div className="col-md-3">
                        <div className="d-flex align-items-center">
                          <input
                            type="number"
                            name="maxRouteDuration"
                            value={operationConstraintsData1.maxRouteDuration}
                            onChange={handleConstraintsChange1}
                            className="w-100 border border-dark p-2"
                            placeholder="Hrs"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <div className="col-md-3">
                        <div className="border border-dark p-2 fw-bold">Max Trips per Route</div>
                      </div>
                      <div className="col-md-3">
                        <input
                          type="number"
                          name="maxTripsPerRoute"
                          value={operationConstraintsData1.maxTripsPerRoute}
                          onChange={handleConstraintsChange1}
                          className="w-100 border border-dark p-2"
                          placeholder="No. of Trips"
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <div className="col-md-3">
                        <div className="border border-dark p-2 fw-bold">Max No. of Unique Stops</div>
                      </div>
                      <div className="col-md-3">
                        <input
                          type="number"
                          name="maxUniqueStops"
                          value={operationConstraintsData1.maxUniqueStops}
                          onChange={handleConstraintsChange1}
                          className="w-100 border border-dark p-2"
                          placeholder="Maximum No. of Unique Stops"
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <div className="col-md-3">
                        <div className="border border-dark p-2 fw-bold">Max Route Miles.</div>
                      </div>
                      <div className="col-md-3">
                        <div className="d-flex align-items-center">
                          <input
                            type="number"
                            name="maxRouteMiles"
                            value={operationConstraintsData1.maxRouteMiles}
                            onChange={handleConstraintsChange1}
                            className="w-100 border border-dark p-2"
                            placeholder="No. of Maximum Miles in Route"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <div className="col-md-3">
                        <div className="border border-dark p-2 fw-bold">Fixed Start Time</div>
                      </div>
                      <div className="col-md-3">
                        <input
                          style={{ transform: 'scale(1.5)' }} // Adjust scale to make the checkbox bigger
                          type="checkbox"
                          name="fixedStartTime"
                          checked={operationConstraintsData1.fixedStartTime}
                          onChange={handleConstraintsChange1}
                          className="form-check-input ms-2"
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <div className="col-md-3">
                        <div className="border border-dark p-2 fw-bold">Disable Ride Sharing</div>
                      </div>
                      <div className="col-md-3">
                        <input
                          style={{ transform: 'scale(1.5)' }} // Adjust scale to make the checkbox bigger
                          type="checkbox"
                          name="disableRideSharing"
                          checked={operationConstraintsData1.disableRideSharing}
                          onChange={handleConstraintsChange1}
                          className="form-check-input ms-2"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Service Constraints Section */}
                  <div className="border border-1 border-dark mb-4 p-3">
                    <div className="text-white p-2 mb-2 w-25 mx-auto text-center" style={{ backgroundColor: '#87CEFA' }}>
                      Service Constraints
                    </div>
                    <div className="row g-4">
                      {/* Pickup Window */}
                      <div className="col-md-6">
                        <div className="border border-dark">
                          <div className="table-responsive">
                            <table className="table table-bordered border-dark mb-0">
                              <thead>
                                <tr>
                                  <th className="bg-white w-25">Pickup Window:</th>
                                  <th className="text-center bg-white w-25">Desired</th>
                                  <th className="text-center bg-white w-25">Relaxed</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="fw-bold">Earliest Pickup Time</td>
                                  <td className="text-center p-0">
                                    <input
                                      type="number"
                                      className="form-control text-center border-0"
                                      value={pickupWindow.earliestDesired}
                                      onChange={handleNumericChange(setPickupWindow, 'earliestDesired')}
                                      onBlur={handleNumericBlur(setPickupWindow, 'earliestDesired')}
                                      placeholder="Minutes"

                                    />
                                  </td>
                                  <td className="text-center text-danger p-0">
                                    <input
                                      type="number"
                                      className="form-control text-center border-0 text-danger"
                                      value={pickupWindow.earliestRelaxed}
                                      onChange={handleNumericChange(setPickupWindow, 'earliestRelaxed')}
                                      onBlur={handleNumericBlur(setPickupWindow, 'earliestRelaxed')}
                                      placeholder="Minutes"

                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-bold">Late Pickup Time</td>
                                  <td className="text-center p-0">
                                    <input
                                      type="number"
                                      className="form-control text-center border-0"
                                      value={pickupWindow.lateDesired}
                                      onChange={handleNumericChange(setPickupWindow, 'lateDesired')}
                                      onBlur={handleNumericBlur(setPickupWindow, 'lateDesired')}
                                      placeholder="Minutes"

                                    />
                                  </td>
                                  <td className="text-center text-danger p-0">
                                    <input
                                      type="number"
                                      className="form-control text-center border-0 text-danger"
                                      value={pickupWindow.lateRelaxed}
                                      onChange={handleNumericChange(setPickupWindow, 'lateRelaxed')}
                                      onBlur={handleNumericBlur(setPickupWindow, 'lateRelaxed')}
                                      placeholder="Minutes"

                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* Drop Off Window */}
                      <div className="col-md-6">
                        <div className="border border-dark">
                          <div className="table-responsive">
                            <table className="table table-bordered border-dark mb-0">
                              <thead>
                                <tr>
                                  <th className="bg-white w-25">Drop Off Window:</th>
                                  <th className="text-center bg-white w-25">Desired</th>
                                  <th className="text-center bg-white w-25">Relaxed</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="fw-bold">Earliest Drop Time</td>
                                  <td className="text-center p-0">
                                    <input
                                      type="number"
                                      className="form-control text-center border-0"
                                      value={dropOffWindow.earliestDesired}
                                      onChange={handleNumericChange(setDropOffWindow, 'earliestDesired')}
                                      onBlur={handleNumericBlur(setDropOffWindow, 'earliestDesired')}
                                      placeholder="Minutes"

                                    />
                                  </td>
                                  <td className="text-center text-danger p-0">
                                    <input
                                      type="number"
                                      className="form-control text-center border-0 text-danger"
                                      value={dropOffWindow.earliestRelaxed}
                                      onChange={handleNumericChange(setDropOffWindow, 'earliestRelaxed')}
                                      onBlur={handleNumericBlur(setDropOffWindow, 'earliestRelaxed')}
                                      placeholder="Minutes"

                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-bold">Latest Drop Time</td>
                                  <td className="text-center p-0">
                                    <input
                                      type="number"
                                      className="form-control text-center border-0"
                                      value={dropOffWindow.latestDesired}
                                      onChange={handleNumericChange(setDropOffWindow, 'latestDesired')}
                                      onBlur={handleNumericBlur(setDropOffWindow, 'latestDesired')}
                                      placeholder="Minutes"

                                    />
                                  </td>
                                  <td className="text-center text-danger p-0">
                                    <input
                                      type="number"
                                      className="form-control text-center border-0 text-danger"
                                      value={dropOffWindow.latestRelaxed}
                                      onChange={handleNumericChange(setDropOffWindow, 'latestRelaxed')}
                                      onBlur={handleNumericBlur(setDropOffWindow, 'latestRelaxed')}
                                      placeholder="Minutes"

                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* Max Ride Time */}
                      <div className="col-md-6">
                        <div className="border border-dark">
                          <div className="table-responsive">
                            <table className="table table-bordered border-dark mb-0">
                              <thead>
                                <tr>
                                  <th className="bg-white w-25">Max Ride Time</th>
                                  <th className="text-center bg-white w-25">Desired</th>
                                  <th className="text-center bg-white w-25">Relaxed</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="fw-bold">Short Trips</td>
                                  <td className="text-center p-0">
                                    <input
                                      type="number"
                                      className="form-control text-center border-0"
                                      value={maxRideTime.shortDesired}
                                      onChange={handleNumericChange(setMaxRideTime, 'shortDesired')}
                                      onBlur={handleNumericBlur(setMaxRideTime, 'shortDesired')}
                                      placeholder="Minutes"

                                    />
                                  </td>
                                  <td className="text-center text-danger p-0">
                                    <input
                                      type="number"
                                      className="form-control text-center border-0 text-danger"
                                      value={maxRideTime.shortRelaxed}
                                      onChange={handleNumericChange(setMaxRideTime, 'shortRelaxed')}
                                      onBlur={handleNumericBlur(setMaxRideTime, 'shortRelaxed')}
                                      placeholder="Minutes"

                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-bold">Long Trips (%)</td>
                                  <td className="text-center p-0">
                                    <div className="d-flex align-items-center">
                                      <input
                                        type="number"
                                        className="form-control text-center border-0"
                                        value={maxRideTime.longDesired}
                                        onChange={handleStringChange(setMaxRideTime, 'longDesired')}
                                        placeholder="Minutes"

                                      />
                                    </div>
                                  </td>
                                  <td className="text-center text-danger p-0">
                                    <div className="d-flex align-items-center">
                                      <input
                                        type="number"
                                        className="form-control text-center border-0 text-danger"
                                        value={maxRideTime.longRelaxed}
                                        onChange={handleStringChange(setMaxRideTime, 'longRelaxed')}
                                        placeholder="Minutes"

                                      />
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* Service Time */}
                      <div className="col-md-6">
                        <div className="border border-dark">
                          <div className="table-responsive">
                            <table className="table table-bordered border-dark mb-0">
                              <thead>
                                <tr>
                                  <th className="bg-white w-25">Service Time</th>
                                  <th className="text-center bg-white w-25">Amb</th>
                                  <th className="text-center bg-white w-25">W.C</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="fw-bold">Single Person</td>
                                  <td className="text-center p-0">
                                    <input
                                      type="number"
                                      className="form-control text-center border-0"
                                      value={serviceTime.singleAmb}
                                      onChange={handleNumericChange(setServiceTime, 'singleAmb')}
                                      onBlur={handleNumericBlur(setServiceTime, 'singleAmb')}
                                      placeholder="Minutes"

                                    />
                                  </td>
                                  <td className="text-center p-0">
                                    <input
                                      type="number"
                                      className="form-control text-center border-0"
                                      value={serviceTime.singleWc}
                                      onChange={handleNumericChange(setServiceTime, 'singleWc')}
                                      onBlur={handleNumericBlur(setServiceTime, 'singleWc')}
                                      placeholder="Minutes"

                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-bold">Per Additional Rider (%)</td>
                                  <td className="text-center p-0">
                                    <div className="d-flex align-items-center">
                                      <input
                                        type="number"
                                        className="form-control text-center border-0"
                                        value={serviceTime.additionalAmb}
                                        onChange={handleStringChange(setServiceTime, 'additionalAmb')}
                                        placeholder="%"

                                      />
                                    </div>
                                  </td>
                                  <td className="text-center p-0">
                                    <div className="d-flex align-items-center">
                                      <input
                                        type="number"
                                        className="form-control text-center border-0"
                                        value={serviceTime.additionalWc}
                                        onChange={handleStringChange(setServiceTime, 'additionalWc')}
                                        placeholder='%'
                                      />
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end mt-3 mb-3">
                    <Button
                      className="bg-secondary text-white text-center py-2 px-4 rounded-lg shadow-lg transform transition duration-300 hover:bg-secondary-dark hover:scale-105"
                      variant="primary"
                      onClick={handleRouteDefinitionsSave}
                    >
                      Save Route Settings
                    </Button>
                  </div>
                </div>
              </Card>
                                                  <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj.show}
              Title={confirmationModalObj.title}
              Body={confirmationModalObj.body}
              onOk={handleConfirmationModalOk1}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj.btnCanceText}
              btnOkText={confirmationModalObj.btnOkText}
              ShowCancelButton={"true"}
            />
            <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj1.show}
              Title={confirmationModalObj1.title}
              Body={confirmationModalObj1.body}
              onOk={handleConfirmationModalClose}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj1.btnCanceText}
              btnOkText={confirmationModalObj1.btnOkText}
              ShowCancelButton={"false"}
            />
            </div>

          )
        }
        {activeTab === 'Route Builder' && (
                  // <div 
                  // className="d-flex justify-content-between mb-4 flex-wrap"
                      <div className="container mt-4">
      <div className="row justify-content-center d-flex align-items-stretch">
        <div className="col-12 col-md-6 d-flex">
                  {/* <div */}
                  {/* style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
                    <Card style={{ width: "100%", maxWidth: "700px" }} className="shadow-sm d-flex flex-column w-100">
                              {/* <div className="container mt-4"> */}

                        {/* <div
                          className="text-white p-2 mb-2 w-50 mx-auto text-center"
                          style={{ backgroundColor: '#87CEFA' }}
                        >
                          Route Builder Rules
                        </div> */}
                                                 {/* <div className="col-12 col-md-6 d-flex">
          <div className="card shadow-sm d-flex flex-column w-100">
            <div className="card-header fw-bold text-center">Admin Control</div>
            <div className="card-body flex-grow-1"></div> */}
         <div className="card-header fw-bold text-center">Route Builder Rules</div>
                        <div className="mb-4 ">
                                                    {/* <div className="col-12 col-md-6">

                          // <div className="border border-dark p-2 fw-bold" style={{ marginLeft: '20px' }}>SCHEDULE DAYS</div>
                          </div> */}
                                                    <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold" style={{ marginLeft: '20px', marginTop:'15px' }}>SCHEDULE DAYS</div>
                          </div>
                          {/* <div className="block mb-2 fs-6 fw-bold" style={{ marginLeft: '20px' }}>SCHEDULE DAYS</div> */}
                          <div className="d-flex flex-wrap justify-content-start" style={{ marginLeft: '320px' }}>
                            {Object.keys(scheduleDays).map(day => (
                              <label key={day} className="d-flex align-items-center m-2" style={{ width: 'calc(33.33% - 10px)' }}
>
                                <input
                                  style={{ transform: 'scale(1.5)' }} // Adjust scale to make the checkbox bigger
                                  type="checkbox"
                                  checked={scheduleDays[day]}
                                  onChange={() => toggleDay(day)}
                                  className="m-1"
                                />
                                {day}
                              </label>
                            ))}
                          </div>
                        </div>
        
                        <div className="d-none mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Predictive</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <select
                              name="iPredictiveAlgoTypeID"
                              value={operationConstraintsData.iPredictiveAlgoTypeID}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                            >
                              <option value="">Select Algorithm</option>
                            {algorithms.map((algorithm) => (
                              <option key={algorithm.id} value={algorithm.id}>
                                {algorithm.name}
                              </option>
                            ))}
                            </select>
                          </div>
                        </div>
                        <div className="d-none mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Final Run</div>
                          </div>
                          <div className="col-12 col-md-6">
                          <select
                              name="iFinalRunAlgoTypeID"
                              value={operationConstraintsData.iFinalRunAlgoTypeID}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                            >
                              <option value="">Select Algorithm</option>
                            {algorithms.map((algorithm) => (
                              <option key={algorithm.id} value={algorithm.id}>
                                {algorithm.name}
                              </option>
                            ))}
                            </select>
                        </div>
                        </div>
                        <div className="d-none mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Periodic</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <select
                              name="iPeriodicAlgoTypeID"
                              value={operationConstraintsData.iPeriodicAlgoTypeID}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                            >
                              <option value="">Select Algorithm</option>
                            {algorithms.map((algorithm) => (
                              <option key={algorithm.id} value={algorithm.id}>
                                {algorithm.name}
                              </option>
                            ))}
                            </select>
                          </div>
                        </div>
                        <div className="d-none mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Batch</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <select
                              name="iManBatchRoutingAlgoTypeID"
                              value={operationConstraintsData.iManBatchRoutingAlgoTypeID}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                            >
                              <option value="">Select Algorithm</option>
                            {algorithms.map((algorithm) => (
                              <option key={algorithm.id} value={algorithm.id}>
                                {algorithm.name}
                              </option>
                            ))}
                            </select>
                          </div>
                        </div>
                        <div className="d-none mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Single</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <select
                              name="iManSingleRoutingAlgoTypeID"
                              value={operationConstraintsData.iManSingleRoutingAlgoTypeID}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                            >
                              <option value="">Select Algorithm</option>
                            {algorithms.map((algorithm) => (
                              <option key={algorithm.id} value={algorithm.id}>
                                {algorithm.name}
                              </option>
                            ))}
                            </select>
                          </div>
                        </div>
                        <div className="d-none mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Other Manual Functions</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <select
                              name="iOtherManualActionsAlgoTypeID"
                              value={operationConstraintsData.iOtherManualActionsAlgoTypeID}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                            >
                              <option value="">Select Algorithm</option>
                            {algorithms.map((algorithm) => (
                              <option key={algorithm.id} value={algorithm.id}>
                                {algorithm.name}
                              </option>
                            ))}
                            </select>
                          </div>
                        </div>
        
                        <div className="d-none mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Lookahead Window</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <input
                              type="number"
                              name="timeHorizon"
                              value={operationConstraintsData.timeHorizon}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                              placeholder="No. of Minutes"
                            />
                          </div>
                        </div>
        
                        <div className="d-none mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Rolling Horizon</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <input
                              type="number"
                              name="rollingHorizon"
                              value={operationConstraintsData.rollingHorizon}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                              placeholder="No. of Minutes"
                            />
                          </div>
                        </div>

                                                <div className="d-none mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Time Horizon</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <input
                              type="number"
                              name="timeHorizonRhcg"
                              value={operationConstraintsData.timeHorizonRhcg}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                              placeholder="No. of Minutes"
                            />
                          </div>
                        </div>
        
                        <div className="d-none mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Trip Pair Biasing</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <input
                              style={{ transform: 'scale(1.5)' }} // Adjust scale to make the checkbox bigger
                              type="checkbox"
                              name="tripPairBiasing"
                              checked={operationConstraintsData.tripPairBiasing}
                              onChange={handleConstraintsChange}
                            />
                          </div>
                        </div>
        
                        <div className="mb-4 row">
                          {/* <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold" style={{ marginLeft: '20px' }}>Excluded FS</div>
                          </div> */}
                               <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold" style={{ marginLeft: '20px',width: '300px' }}>Excluded FS</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="dropdown">
                              <button
                                className="btn btn-primary dropdown-toggle"
                                type="button"
                                id={FundingSourceFilterMultiSelect.id}
                                onClick={toggleDropdown} // Toggle dropdown visibility on click
                                aria-expanded={dropdownOpen ? "true" : "false"}
                              >
                                {getDropdownText()} {/* Show default or selected values */}
                              </button>
        
                              {/* Dropdown menu, show based on `dropdownOpen` state */}
                              {dropdownOpen && (
                                <ul className="dropdown-menu show scrollable-dropdown" aria-labelledby={FundingSourceFilterMultiSelect.id}
                                style={{
                                  maxHeight: '200px',  // Set max height
                                  maxWidth: '250px',   // Set max width
                                  overflowY: 'auto',   // Make it scrollable vertically
                                  overflowX: 'hidden', // Prevent horizontal scrolling
                                  border: '1px solid #ccc', // Optional: Add a border
                                  borderRadius: '4px',  // Optional: Add rounded corners
                                  position: 'absolute', // Ensure it floats above other content
                                  zIndex: '1000',       // Ensure it's on top of other elements
                                }}>
                                  {/* Select All option */}
                                  <li>
                                    <label className="dropdown-item">
                                      <input
                                        style={{ transform: 'scale(1.5)' }} // Adjust scale to make the checkbox bigger
                                        type="checkbox"
                                        checked={FundingSourceFilterMultiSelect.selectedValues.length === FundingSourceFilterMultiSelect.options.length}
                                        onChange={handleSelectAllChange}
                                      />
                                      {'  ' + FundingSourceFilterMultiSelect.SelectAllPlaceHolder}
                                    </label>
                                  </li>
        
                                  {/* Map over options and create a checkbox for each */}
                                  {FundingSourceFilterMultiSelect.options.map((option) => (
                                    <li key={option.id}>
                                      <label className="dropdown-item">
                                        <input
                                          style={{ transform: 'scale(1.5)' }} // Adjust scale to make the checkbox bigger
                                          type="checkbox"
                                          value={option.id}
                                          checked={FundingSourceFilterMultiSelect.selectedValues.includes(option.id)}
                                          onChange={handleCheckboxChange}
                                        />
                                        {'  ' + option.name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          </div>
                        </div>
                                <div className="mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold" style={{ marginLeft: '20px',width: '300px' }}>Service Start Time</div>
                          </div>
                          <div className="col-12 col-md-6" style={{ width: '170px' }}>
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="dServiceStartTime"
                                    value={operationConstraintsData.dServiceStartTime}
                                    onChange={handleConstraintsChange}
                                    placeholder="Start Time"
                                  />
                          </div>
                        </div>
                        <div className="d-none mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Auto Routing Mode</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <select
                              name="autoRoutingMode"
                              value={operationConstraintsData.autoRoutingMode}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                            >
                              <option value="">Select Mode</option>
                              <option value="0">No Auto Routing</option>
                              <option value="1">Final Run Only</option>
                              <option value="2">Final & Periodic Run</option>
                              <option value="3">Manual Control</option>
                            </select>
                          </div>
                        </div>
        
                        <div className="d-none mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Periodic Timer</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <input
                              type="number"
                              name="periodicTimer"
                              value={operationConstraintsData.periodicTimer}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                              placeholder="No. of Minutes"
                            />
                          </div>
                        </div>
        
                        {/* <div className="d-flex justify-content-end mt-3 m-3">
                          <Button
                            className='bg-secondary text-white text-center'
                            variant="primary"
                            onClick={handleGeneralSettingsSave}
                          >
                            Save Rules
                          </Button>
                        </div> */}
                    {/* </div> */}
                    </Card>
                  {/* </div> */}
</div>
                          <div className="col-12 col-md-6 d-flex">
          <div className="card shadow-sm d-flex flex-column w-100">
            <div className="card-header fw-bold text-center">Admin Control</div>
            <div className="card-body flex-grow-1">
                                      <div className="mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Lookahead Window</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <input
                              type="number"
                              name="timeHorizon"
                              value={operationConstraintsData.timeHorizon}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                              placeholder="No. of Minutes"
                            />
                          </div>
                        </div>
        
                        <div className="mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Rolling Horizon</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <input
                              type="number"
                              name="rollingHorizon"
                              value={operationConstraintsData.rollingHorizon}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                              placeholder="No. of Minutes"
                            />
                          </div>
                        </div>

                                                <div className="mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Time Horizon</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <input
                              type="number"
                              name="timeHorizonRhcg"
                              value={operationConstraintsData.timeHorizonRhcg}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                              placeholder="No. of Minutes"
                            />
                          </div>
                        </div>
        
                        <div className="mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Trip Pair Biasing</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <input
                              style={{ transform: 'scale(1.5)' }} // Adjust scale to make the checkbox bigger
                              type="checkbox"
                              name="tripPairBiasing"
                              checked={operationConstraintsData.tripPairBiasing}
                              onChange={handleConstraintsChange}
                            />
                          </div>
                        </div>

                              <div className="mb-3 row">
                          <div className="col-12 col-md-6">
                            <div className="border border-dark p-2 fw-bold">Aerial Distance Adjustment Percentage</div>
                          </div>
                          <div className="col-12 col-md-6">
                            <input
                              type="number"
                              name="ArialTimeAdjPercentage"
                              value={operationConstraintsData.ArialTimeAdjPercentage}
                              onChange={handleConstraintsChange}
                              className="w-100 border border-dark p-2"
                              placeholder="Distance"
                            />
                          </div>
                        </div>
                          {/* <div className="d-flex justify-content-end mt-3 m-3">
                          <Button
                            className='bg-secondary text-white text-center'
                            variant="primary"
                            onClick={handleGeneralSettingsSave}
                          >
                            Save Rules
                          </Button>
                        </div> */}

                                    <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj.show}
              Title={confirmationModalObj.title}
              Body={confirmationModalObj.body}
              onOk={handleConfirmationModalOk1}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj.btnCanceText}
              btnOkText={confirmationModalObj.btnOkText}
              ShowCancelButton={"true"}
            />
            <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj1.show}
              Title={confirmationModalObj1.title}
              Body={confirmationModalObj1.body}
              onOk={handleConfirmationModalClose}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj1.btnCanceText}
              btnOkText={confirmationModalObj1.btnOkText}
              ShowCancelButton={"false"}
            />
              </div></div></div>
                      <div className="d-flex justify-content-end mt-3 m-3">
                          <Button
                            className='bg-secondary text-white text-center'
                            variant="primary"
                            onClick={handleGeneralSettingsSave}
                          >
                            Save Rules
                          </Button>
                        </div>
        </div></div>
                )}
        {activeTab === 'Multi Iterations' && (
          <div>

            <Card style={{ width: "75%" }} className="mb-4"></Card>
            {/* Content for Trip Filter Criteria */}
            <Card style={{ width: "100%" }} className="mb-4">
              <Card.Body>
                <Form>
                  {/* <div className="d-flex align-items-center mb-3">
                    <Form.Group className="me-3 d-flex align-items-center">
                      <Form.Label className="me-2">Iteration</Form.Label>
                      <Form.Select
                        className="w-auto"
                        value={currentIteration}
                        onChange={handleIterationChange}
                      >
                        <option value="">Select Iteration</option>
                        {iterationOptions.map(num => (
                          <option key={num} value={num}>{num}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div> */}

                  <div className="mb-3">
                    <span className="text-white border w-80 d-block mx-auto text-center p-2"
                      style={{ backgroundColor: '#87CEFA' }}
                    >
                      Trip Filter Criteria
                    </span>
                    {/* <Card.Body>
                      <div className="d-flex gap-3 mb-3 align-items-center">
                        <Form.Group>
                          <Form.Label>Attribute Type</Form.Label>
                          <Form.Select
                            value={formData.attributeType}
                            onChange={handleAttributeTypeChange}
                          >
                            <option value="">Select Type</option>
                            {attributeTypes.map(type => (
                              <option key={type.iID} value={type.vName}>{type.vDesc}</option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Attribute</Form.Label>
                          <Form.Select
                            value={formData.attribute}
                            onChange={(e) => setFormData({ ...formData, attribute: e.target.value })}
                            disabled={!formData.attributeType}
                          >
                            <option value="">Select Attribute</option>
                            {getFilteredAttributes(formData.attributeType).map(attr => (
                              <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group className="mt-4">
                          <Form.Check
                            type="checkbox"
                            label="Match Attribute"
                            checked={formData.matchExempted}
                            onChange={(e) => setFormData({ ...formData, matchExempted: e.target.checked })}
                          />
                        </Form.Group>
                        <Form.Group className="mt-4">
                          <Form.Check
                            type="checkbox"
                            label="Only"
                            checked={formData.only}
                            onChange={(e) => setFormData({ ...formData, only: e.target.checked })}
                          />
                        </Form.Group>
                        <Form.Group className="mt-4">
                          <Form.Label>Acceptable Cost Revenue Threshold</Form.Label>
                          <Form.Control
                            type="number"
                            value={formData.acceptableCostRevThreshold}
                            onChange={(e) => {
                              console.log(parseFloat(e.target.value)); setFormData({
                                ...formData,
                                acceptableCostRevThreshold: parseFloat(e.target.value)
                              })
                            }}
                          />
                        </Form.Group>

                      </div> */}
                    {/* <Button
                        className='bg-secondary text-white text-center'
                        style={{ marginRight: '10px' }}
                        variant="primary"
                        onClick={handleAdd}
                      >
                        Add Rule */}
                    {/* {editingRule ? 'Update Rule' : 'Add Rule'} */}
                    {/* </Button> */}
                    {/* <Button
          variant="primary"
          onClick={resetForm}
          >Clear</Button> */}
                    {/* </Card.Body> */}
                  </div>

                  <div className="mb-3">
                    <div className="text-white row border p-2"
                      style={{ backgroundColor: '#87CEFA' }}
                    >
                      {/* <div className="col-1 border-end"></div> */}
                      <div className="col-1 border-end">Iteration</div>
                      <div className="col-1 border-end">Trip Filter</div>
                      <div className="col-1 border-end">Attribute Type</div>
                      {/* <div className="col-2 border-end">Attribute</div> */}
                      <div className="col-1 border-end">Pickup Attribute</div>
                      <div className="col-1 border-end">Dropoff Attribute</div>
                      <div className="col-2 border-end">All Attribute Must Apply</div>
                      <div className="col-1 border-end">Match Attribute</div>
                      <div className="col-1 border-end">Active</div>
                      {/* <div className="col-1 border-end">Acceptable Cost Rev Threshold</div> */}
                      <div className="col-1 border-end">Min. Profit Growth Margin (%)</div>
                      <div className="col-1 border-end">Route Type</div>
                      <div className="col-1 border-end">Actions</div>
                    </div>
                  </div>


                  {Object?.entries(iterations)?.length <= 0 ? (
                    <div>No iterations available</div>  // This shows if there are no iterations
                  ) : (
                    Object?.entries(iterations)?.map(([iterationId, iteration]) => (
                      <div key={iterationId} className="mb-4">
                        <div style={{ background: "lightgrey" }} className="row border p-1 d-flex justify-content-center align-items-center">
                          <div className="col-1">
                            <Button
                              onClick={() => toggleSection(iterationId)}
                              aria-controls="example-collapse-text"
                              aria-expanded={sections[iterationId]}
                              style={{
                                fontSize: '20px',  // Smaller font size
                                padding: '3px 6px',  // Smaller padding
                                height: 'auto',  // Adjust height based on content
                                width: 'auto',  // Adjust width based on content
                                marginRight: '10px'  // Space from the right
                              }}
                            >
                              {sections[iterationId] ? '-' : '+'}
                            </Button>
                            {iterationId}</div>
                          <div className="col-1"></div>
                          <div className="col-2"></div>
                          <div className="col-2"></div>
                          <div className="col-1">
                            {
                              obj?.editIteration && obj?.iterationId == iterationId ? (
                                <div className="col-1">
                                  <Form.Check
                                    type="checkbox"
                                    checked={iteration.rules[0]?.allattributemustapply || false}  // Safe access to avoid undefined errors
                                    onChange={(e) => {
                                      // prevIterationsRef.current=JSON.parse(JSON.stringify(iterations));

                                      prevIterationsRef.current = { ...iterations };
                                      console.log(prevIterationsRef.current);
                                      const updatedChecked = e.target.checked;  // Get the new checked state
                                      console.log(updatedChecked);
                                      setIterations(prev => {
                                        console.log('Previous State:', prev); // Log the previous state to ensure we are accessing the correct structure
                                        console.log('Iteration ID:', iterationId); // Log the iterationId to verify it's correct

                                        // Check if the iterationId exists in the state
                                        const currentIteration = prev[iterationId] || { rules: [] };

                                        console.log('Current Iteration:', currentIteration); // Log the current iteration object

                                        // Ensure the rules array exists and has at least one rule
                                        const updatedRules = currentIteration.rules.length > 0
                                          ? [
                                            {
                                              ...currentIteration.rules[0],  // Spread the first rule
                                              allattributemustapply: updatedChecked,  // Update the 'only' field
                                            },
                                            ...currentIteration.rules.slice(1),  // Keep other rules unchanged
                                          ]
                                          : [];  // If no rules exist, set updatedRules to an empty array

                                        // Log the updated rules to verify the change
                                        console.log('Updated Rules:', updatedRules);

                                        // Return the updated state
                                        return {
                                          ...prev,
                                          [iterationId]: {
                                            ...currentIteration,  // Keep the existing iteration's properties
                                            rules: updatedRules,  // Update the rules array with the modified rule
                                          },
                                        };
                                      });


                                    }}
                                  />
                                </div>
                              ) : (
                                <div className="col-1">
                                  <Form.Check
                                    type="checkbox"
                                    checked={iteration.rules[0]?.allattributemustapply || false}  // Safe access to avoid undefined errors
                                    readOnly  // Display checkbox as readonly
                                  />
                                </div>
                              )
                            }

                          </div>
                          <div className="col-1">

                          </div>
                          <div className="col-1">

                          </div>
                          {/* <div className="col-2">{iteration.rules[0].dAcceptableCostRevThreshold}</div> */}
                          <div className="col-1">
                            {
                              obj?.editIteration && obj?.iterationId == iterationId ? (
                                <Form.Control
                                  type="number"
                                  value={iteration.rules[0]?.dAcceptableCostRevThreshold || 999999}
                                  onChange={(e) => handleThresholdChange(e, iterationId)}  // Use the handler here
                                />
                              ) : (
                                <span title="Acceptable Cost Rev Threshold">{iteration.rules[0]?.dAcceptableCostRevThreshold || 999999}</span>
                              )
                            }
                          </div>

                          <div className="col-1" >
                            <Form.Select
                              value={iteration.routeType || "All"}
                              onChange={(e) => handleRouteTypeChange(Number(iterationId), e.target.value)}
                            >
                              <option value="All">All</option>
                              <option value="OnlyNew">Only New</option>
                            </Form.Select>
                          </div>
                          <div className="col-1">
                            <div className="d-flex gap-3 mb-3">
                              <Button
                                variant="link"
                                className="p-0 text-danger"
                                onClick={() => handleDeleteIteration(Number(iterationId),iteration.tno)}
                              >
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </Button>
                              <Button
                                variant="link"
                                className="p-0 text-danger"
                                onClick={() => handleEditIteration(Number(iterationId))}
                              >
                                <FontAwesomeIcon icon={faEdit} />
                              </Button>
                            </div>
                            {
                              obj?.editIteration && obj?.iterationId == iterationId ? (
                                <div className="d-flex gap-3">
                                  <>
                                    <Button
                                      variant="success"
                                      onClick={() =>handleIterationUpdate(iteration.tno)}
                                      className="p-0 text-safe"
                                    >
                                      <FontAwesomeIcon icon={faSave} />
                                    </Button>
                                    <Button
                                      variant="link"
                                      onClick={() => {
                                        console.log(prevIterationsRef?.current);
                                        // if(prevIterationsRef?.current!={}){
                                        if (prevIterationsRef?.current && Object.keys(prevIterationsRef.current).length > 0) {
                                          console.log('here')
                                          setIterations(prevIterationsRef.current || {});
                                        }
                                        setObj(null);
                                      }}
                                      className="p-0 text-danger"
                                    >
                                      <FontAwesomeIcon icon={faBroomBall} />
                                    </Button>
                                  </>
                                </div>

                              ) : (<></>)}
                          </div>
                        </div>

                        {iteration.rules.length === 0 ? (
                          <div>No rules available for this iteration</div>  // This shows if no rules exist
                        ) : (
                          iteration.rules.map((rule, index) => (
                            <Collapse in={sections[iterationId]}>
                              <div key={`${iterationId}-${rule.id}`} className="row border p-2">
                                <div className="col-1">
                                  <div className="d-flex gap-2">
                                    <Button
                                      variant="link"
                                      className="p-0"
                                      onClick={() => handleEdit(Number(iterationId), rule)}
                                    >
                                      <FontAwesomeIcon icon={faPencilAlt} />
                                    </Button>
                                    <Button
                                      variant="link"
                                      className="p-0 text-danger"
                                      onClick={() => handleDeleteRule(Number(iterationId), rule.id,iteration.tno)}
                                    >
                                      <FontAwesomeIcon icon={faTrashAlt} />
                                    </Button>
                                  </div>
                                </div>
                                <div className="col-1">{index + 1}</div>
                                {/* <div className="col-2">{rule.attributeType}</div> */}
                                <div className="col-1">
                                  {editingRule && editingRule.id === rule.id ? (
                                    <Form.Select
                                      value={editingRule.attributeType}
                                      onChange={(e) => setEditingRule({ ...editingRule, attributeType: e.target.value,pickupattribute: "",
                                      dropoffattribute:"" })}
                                    >
                                      <option value="">Select Type</option>
                                      {attributeTypes.map((type) => (
                                        <option key={type.iID} value={type.vName}>
                                          {type.vDesc}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  ) : (
                                    <span>{rule.attributeType}</span>
                                  )}
                                </div>
                                <div className="col-1">
                                  {editingRule && editingRule.id === rule.id ? (
                                    <Form.Select
                                      value={editingRule.pickupattribute}
                                      onChange={(e) => setEditingRule({ ...editingRule, pickupattribute: e.target.value })}
                                      disabled={!editingRule.attributeType}
                                    >
                                      <option value="">Select Type</option>
                                      {getFilteredPickupAttributes(editingRule.attributeType).map(attr => (
                                        <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                                      ))}
                                    </Form.Select>
                                  ) : (
                                    <span>{rule.pickupattribute}</span>
                                  )}
                                </div>
                                <div className="col-1">
                                  {editingRule && editingRule.id === rule.id ? (
                                    <Form.Select
                                      value={editingRule.dropoffattribute}
                                      onChange={(e) => setEditingRule({ ...editingRule, dropoffattribute: e.target.value })}
                                      disabled={!editingRule.attributeType}
                                    >
                                      <option value="">Select Type</option>
                                      {getFilteredDropoffAttributes(editingRule.attributeType).map(attr => (
                                        <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                                      ))}
                                    </Form.Select>
                                  ) : (
                                    <span>{rule.dropoffattribute}</span>
                                  )}
                                </div>
                                {/* <div className="col-2">{rule.attribute}</div> */}
                                <div className="col-2">
                                  {/* <Form.Check
          type="checkbox"
          checked={rule.only}
          readOnly
        /> */}
                                </div>
                                {/* <div className="col-2">
        <Form.Check
          type="checkbox"
          checked={rule.matchExempted}
          readOnly
        />
      </div> */}
                                <div className="col-1">
                                  {editingRule && editingRule.id === rule.id ? (
                                    <Form.Check
                                      type="checkbox"
                                      checked={editingRule.matchExempted}
                                      onChange={(e) => setEditingRule({ ...editingRule, matchExempted: e.target.checked })}
                                    />
                                  ) : (
                                    <Form.Check
                                      type="checkbox"
                                      checked={rule.matchExempted}
                                      readOnly
                                    />
                                  )}
                                </div>
                                <div className="col-1">
                                  {editingRule && editingRule.id === rule.id ? (
                                    <Form.Check
                                      type="checkbox"
                                      checked={editingRule.active}
                                      onChange={(e) => setEditingRule({ ...editingRule, active: e.target.checked })}
                                    />
                                  ) : (
                                    <Form.Check
                                      type="checkbox"
                                      checked={rule.active}
                                      readOnly
                                    />
                                  )}
                                </div>

                                {/* <div className="col-1">{rule.active}</div> */}
                                <div className="col-1"></div>
                                <div className="col-1"></div>
                                <div className="col-1">
                                  {editingRule && editingRule.id === rule.id ? (
                                    <div className="d-flex gap-3 ms-1">

                                      <Button
                                        variant="success"
                                        onClick={()=>handleAdd(iteration.tno)}
                                        className="p-0 text-safe"
                                      >
                                        <FontAwesomeIcon icon={faSave} />
                                      </Button>
                                      <Button
                                        variant="link"
                                        onClick={handleCancel}
                                        className="p-0 text-danger"
                                      >
                                        <FontAwesomeIcon icon={faBroomBall} />
                                      </Button>

                                    </div>

                                  ) : (<></>)}
                                </div>

                              </div>
                            </Collapse>
                          ))
                        )}
                        {showRuleFormID == iterationId && (
                          <div className="d-flex gap-3 mb-3 align-items-center" style={{ flexWrap: 'wrap' }}>
                            <Form.Group>
                              <Form.Label>Attribute Type</Form.Label>
                              <Form.Select
                                value={formData.attributeType}
                                onChange={handleAttributeTypeChange}
                              >
                                <option value="">Select Type</option>
                                {attributeTypes.map(type => (
                                  <option key={type.iID} value={type.vName}>{type.vDesc}</option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                            <Form.Group>
                              <Form.Label>Pickup Attribute</Form.Label>
                              <Form.Select
                                value={formData.pickupattribute}
                                onChange={(e) => setFormData({ ...formData, pickupattribute: e.target.value })}
                                disabled={!formData.attributeType}
                              >
                                <option value="">Select Attribute</option>
                                {getFilteredPickupAttributes(formData.attributeType).map(attr => (
                                  <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                            <Form.Group>
                              <Form.Label>Dropoff Attribute</Form.Label>
                              <Form.Select
                                value={formData.dropoffattribute}
                                onChange={(e) => setFormData({ ...formData, dropoffattribute: e.target.value })}
                                disabled={!formData.attributeType}
                              >
                                <option value="">Select Attribute</option>
                                {getFilteredDropoffAttributes(formData.attributeType).map(attr => (
                                  <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                            <Form.Group>
                              <Form.Label>Match Attribute</Form.Label>

                              <Form.Check
                                type="checkbox"
                                // label="Match Attribute"
                                style={{ transform: 'scale(1))' }} // Adjust scale to make the checkbox bigger
                                checked={formData.matchExempted}
                                onChange={(e) => setFormData({ ...formData, matchExempted: e.target.checked })}
                              />
                            </Form.Group>
                            {/* <Form.Group className="mt-4">
            <Form.Check
              type="checkbox"
              label="Only"
              checked={formData.only}
              onChange={(e) => setFormData({ ...formData, only: e.target.checked })}
            />
          </Form.Group>
          <Form.Group className="mt-4">
            <Form.Label>Acceptable Cost Revenue Threshold</Form.Label>
            <Form.Control
              type="number"
              value={formData.acceptableCostRevThreshold}
              onChange={(e) => {
                console.log(parseFloat(e.target.value));
                setFormData({
                  ...formData,
                  acceptableCostRevThreshold: parseFloat(e.target.value),
                });
              }}
            />
          </Form.Group> */}

                            {/* Add Button with FontAwesome tick icon */}
                            <Form.Group>
                              <Button onClick={() => { handleAdd(iteration.tno); }} className="mt-3" style={{
                                backgroundColor: "green"
                              }}>
                                <FontAwesomeIcon icon={faSave} />
                                
                              </Button>
                            </Form.Group>
                            <Form.Group>

                              <Button onClick={() => { setShowRuleFormID(-1); }} className="mt-3" style={{
                                backgroundColor: "red"
                              }}>
                                 <FontAwesomeIcon icon={faBroomBall} />

                              </Button>
                            </Form.Group>
                          </div>
                        )}
                        <Collapse in={sections[iterationId]}>
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <OverlayTrigger
                              placement="top" // Position the tooltip at the top of the button
                              overlay={<Tooltip id="tooltip-top">Click to add a new rule</Tooltip>}
                            >
                              <Button
                                style={{
                                  backgroundColor: "lightgrey", // Light gray background
                                  borderColor: '#a9a9a9', // Slightly darker border
                                  color: '#333', // Dark text color for contrast
                                  fontWeight: 'bold',
                                  padding: '10px 20px', // Add padding for better size
                                  fontSize: '25px',
                                  textAlign: 'center',
                                  borderRadius: '5px',
                                  transition: 'background-color 0.2s ease', // Smooth hover effect
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#a9a9a9'} // Darker on hover
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#d3d3d3'} // Back to gray on hover out
                                onClick={() => { handleIterationChange(Number(iterationId)); setShowRuleFormID(iterationId); setShowIterationsForm(false); }}
                              >
                                +
                              </Button>
                            </OverlayTrigger>
                          </div>

                        </Collapse>
                      </div>
                    ))
                  )}
                  <div className="mb-4">
                    <div
                      style={{
                        background: "lightgrey",
                        height: "60px",  // Adjust this value to increase the height
                      }}
                    >
                      {/* <div className="col-1"> */}
                      <OverlayTrigger
                        placement="top" // Position the tooltip at the top of the button
                        overlay={<Tooltip id="tooltip-top">Click to add a new Iteration</Tooltip>}
                      >
                        <Button
                          style={{
                            backgroundColor: '#a9a9a9', // Light gray background
                            borderColor: '#a9a9a9', // Slightly darker border
                            color: '#333', // Dark text color for contrast
                            fontWeight: 'bold',
                            padding: '10px 20px', // Add padding for better size
                            fontSize: '25px',
                            textAlign: 'center',
                            borderRadius: '5px',
                            transition: 'background-color 0.2s ease', // Smooth hover effect
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#a9a9a9'} // Darker on hover
                          onMouseLeave={(e) => e.target.style.backgroundColor = '#d3d3d3'} // Back to gray on hover out
                          onClick={() => { handleIterationChange(""); setShowIterationsForm(true); setShowRuleFormID(-1); }}
                        >
                          +
                        </Button>
                      </OverlayTrigger>


                      {/* </div> */}
                    </div>
                    {showIterationForm && (

                      <div className="d-flex gap-3 mb-3 align-items-center">
                        <Form.Group>
                          <Form.Label>Attribute Type</Form.Label>
                          <Form.Select
                            value={formData.attributeType}
                            onChange={handleAttributeTypeChange}
                          >
                            <option value="">Select Type</option>
                            {attributeTypes.map(type => (
                              <option key={type.iID} value={type.vName}>{type.vDesc}</option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Pickup Attribute</Form.Label>
                          <Form.Select
                            value={formData.pickupattribute}
                            onChange={(e) => setFormData({ ...formData, pickupattribute: e.target.value })}
                            disabled={!formData.attributeType}
                          >
                            <option value="">Select Attribute</option>
                            {getFilteredPickupAttributes(formData.attributeType).map(attr => (
                              <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Dropoff Attribute</Form.Label>
                          <Form.Select
                            value={formData.dropoffattribute}
                            onChange={(e) => setFormData({ ...formData, dropoffattribute: e.target.value })}
                            disabled={!formData.attributeType}
                          >
                            <option value="">Select Attribute</option>
                            {getFilteredDropoffAttributes(formData.attributeType).map(attr => (
                              <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group className="mt-4">
                          <Form.Check
                            type="checkbox"
                            label="Match Attribute"
                            checked={formData.matchExempted}
                            onChange={(e) => setFormData({ ...formData, matchExempted: e.target.checked })}
                          />
                        </Form.Group>
                        <Form.Group className="mt-4">
                          <Form.Check
                            type="checkbox"
                            label="All Attribute Must Apply"
                            checked={formData.allAttributeMustApply}
                            onChange={(e) => setFormData({ ...formData, allAttributeMustApply: e.target.checked })}
                          />
                        </Form.Group>
                        <Form.Group className="mt-4">
                          <Form.Label>Acceptable Cost Revenue Threshold</Form.Label>
                          <Form.Control
                            type="number"
                            value={formData.acceptableCostRevThreshold}
                            onChange={(e) => {
                              console.log(parseFloat(e.target.value));
                              setFormData({
                                ...formData,
                                acceptableCostRevThreshold: parseFloat(e.target.value),
                              });
                            }}
                          />
                        </Form.Group>

                        {/* Add Button with FontAwesome tick icon */}
                        <Button onClick={() => { handleAdd('dtl_AttributeRoutingRulesV1'); }} className="mt-3" style={{
                          backgroundColor: "green"
                        }}>
                          	  <FontAwesomeIcon icon={faSave} />
                        </Button>
                        <Button onClick={() => { setShowIterationsForm(false) }} className="mt-3" style={{
                          backgroundColor: "red"
                        }}>
                           <FontAwesomeIcon icon={faBroomBall} />

                        </Button>
                      </div>

                    )}

                  </div>
                  <div className="d-flex justify-content-end mt-3">
                    {/* <Button
          variant="primary"
          onClick={() => {
            // Handle final save
            window.close();
          }}
        >
          Save & Close
        </Button> */}
                  </div>
                </Form>
              </Card.Body>
            </Card>
            <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj.show}
              Title={confirmationModalObj.title}
              Body={confirmationModalObj.body}
              onOk={handleConfirmationModalOk}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj.btnCanceText}
              btnOkText={confirmationModalObj.btnOkText}
              ShowCancelButton={"true"}
            />
            <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj1.show}
              Title={confirmationModalObj1.title}
              Body={confirmationModalObj1.body}
              onOk={handleConfirmationModalClose}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj1.btnCanceText}
              btnOkText={confirmationModalObj1.btnOkText}
              ShowCancelButton={"false"}
            />
          </div>
        )}

        {activeTab === 'Route Definitions' && (


          <div>

                                                <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj.show}
              Title={confirmationModalObj.title}
              Body={confirmationModalObj.body}
              onOk={handleConfirmationModalOk1}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj.btnCanceText}
              btnOkText={confirmationModalObj.btnOkText}
              ShowCancelButton={"true"}
            />
            <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj1.show}
              Title={confirmationModalObj1.title}
              Body={confirmationModalObj1.body}
              onOk={handleConfirmationModalClose}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj1.btnCanceText}
              btnOkText={confirmationModalObj1.btnOkText}
              ShowCancelButton={"false"}
            />
            <div className="container-fluid p-4">
              <div className="container-fluid">
                <div className="text-white p-2 mb-2 text-center" style={{ backgroundColor: '#87CEFA' }}>
                  Route Template Definition
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Action</th>
                          <th>Template Name</th>
                          <th>Route Prefix & Starting Number</th>
                          <th>Number of Routes</th>
                          <th>Depot</th>
                          <th>Attribute</th>
                          <th>Vehicle Type</th>
                          <th>Start Time</th>
                          <th>Duration</th>
                          <th>Miles</th>
                          <th>Rec Affiliate</th>
                          <th>Route Break</th>
                          <th>Zone Details</th>
                          <th>Manage</th>
                        </tr>
                      </thead>
                      <tbody>
                        {routeGroups?.map((group, index) => (
                          <tr key={index}>
                            <td>
                              {index !== routeTempAdded && (
                                // <button
                                //   type="button"
                                //   key={index}
                                //   onClick={() => {
                                //     setFormData6(prev => ({
                                //       ...prev,
                                //       templateName: group.TemplateName,
                                //       noOfRoutes: group.iRoutes,
                                //       routePrefix: group.RoutePrefix,
                                //       depot: group.Depot || group.depot,
                                //       vehicleType: group["Vehicle Type"] || group.vVehicleType,
                                //       startTime: group["Start Time"] || group.StartTime,
                                //       recAffiliate: group.iServingAffiliateID || group.iAffiliateID,
                                //       duration: group["Max Route Hours"] || group.MaxRouteHours,
                                //       attribute: String(group.vAttributeIDs) || '',
                                //     }));
                                //     setRouteTempEdited(index);
                                //     setIsButtonTwoDisabled(true);
                                //   }}
                                // >
                                //   <FontAwesomeIcon icon={faPencilAlt} />
                                // </button>
                                <>               <button onClick={() => {alert('are you sure to delete this template');handleDelete(group);}} className="btn btn-danger btn-sm">
                                  
                                  <FontAwesomeIcon icon={faTrashAlt} />
                              </button></>
                              )}
                            </td>
                            <td>
                              {routeTempAdded === index || routeTempEdited === index ? (
                                <input
                                  type="text"
                                  className="form-control"
                                  name="templateName"
                                  value={formData6.templateName}
                                  onChange={handleChange5}
                                  disabled={routeTempEdited === index}
                                />
                              ) : (
                                group.TemplateName
                              )}
                            </td>
                            <td>
                              {routeTempAdded === index || routeTempEdited === index ? (
                                <input
                                  type="text"
                                  className="form-control"
                                  name="routePrefix"
                                  value={formData6.routePrefix}
                                  onChange={handleChange5}
                                  disabled={routeTempEdited === index}
                                />
                              ) : (
                                group.RoutePrefix

                              )}
                            </td>
                            <td>
                              {routeTempAdded === index || routeTempEdited === index ? (
                                <input
                                  type="number"
                                  className="form-control"
                                  name="noOfRoutes"
                                  value={formData6.noOfRoutes}
                                  onChange={handleChange5}
                                  disabled={routeTempEdited===index}
                                />
                              ) : (
                                group.iRoutes

                              )}
                            </td>
                            <td>
                              {routeTempAdded === index || routeTempEdited === index ? (
                                <select
                                  className="form-select"
                                  name="depot"
                                  value={formData6.depot}
                                  onChange={handleChange5}
                                >
                                  <option value="">Select Depot</option>
                                  {depotData.map((depot) => (
                                    <option key={depot.DepotNumber} value={depot.DepotNumber}>
                                      {depot.DepotName}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                depotData.find(item => item.DepotNumber === (group.Depot || group.depot))?.DepotName
                              )}
                            </td>
                            <td>
                              {routeTempAdded === index || routeTempEdited === index ? (
                                // <div className="multi-select-dropdown">
                                //   <p>Select attribute(s):</p>
                                //   <div className="checkbox-list">{routeTempAttributeDropDownHTML}</div>
                                //   <div>
                                //     <p>{formData6.attribute && formData6.attribute.split(',').includes('1') ? 'True' : 'False'}</p>
                                //   </div>
                                // </div>
                                <div className="multi-select-dropdown">
                                <div className="dropdown-container">
                                  <button className="dropdown-toggle" onClick={toggleIsDropdown}
                                            style={{
                                              // width: "100%",
                                              padding: "10px",
                                              fontSize: "16px",
                                              cursor: "pointer",
                                              backgroundColor: "transparent",  // Transparent background
                                              border: "1px solid #ccc",
                                              borderRadius: "4px",
                                              textAlign: "left",
                                              color: "#333",  // Text color
                                            }}
                                  >
                                    {formData6.attribute && AttributeDataRef.current.length>0
                                      ? `${formData6.attribute.split(',').length} Selected`
                                      : "Select Attributes"}
                                  </button>
                          
                                  {isDropdownOpen && (
                                    <div className="checkbox-list"
                                    style={{
                                      // position: "absolute",
                                      // width: "100%",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      backgroundColor: "#fff",
                                      border: "1px solid #ccc",
                                      borderTop: "none",
                                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                      borderRadius: "4px",
                                      padding: "10px",
                                    }}
                                    >
                                      {AttributeDataRef.current.map(function (item, index) {
                                        return (
                                          <div key={index} className="checkbox-item">
                                            <input
                                              type="checkbox"
                                              id={item.iID}
                                              value={item.iID}
                                              checked={formData6.attribute.split(',').includes(String(item.iID))}
                                              onChange={handleAttributeCheckboxChange}
                                            />
                                            <label htmlFor={item.iID}>{item.vTitle}</label>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  )}
                                </div>
                              </div>
                              ) : (
                                // AttributeDataRef?.current?.find(item => item.iID === group.Attribute)?.vTitle || 'N/A'
                                			  

    group.vAttributeIDs?.split(',').map(attributeId => {
      const matchedItem = AttributeDataRef?.current?.find(item => item.iID === Number(attributeId));
      return matchedItem ? matchedItem.vTitle : null;
    }).filter(title => title !== null).map((title, index) => (
      <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <div 
          style={{
            width: '20px',
            height: '20px',
            borderRadius: '4px',
            border: '2px solid #bbb',
            backgroundColor: '#b0e0e6', // Light blue background
            position: 'relative',
            cursor: 'not-allowed',
          }}
        >
          {/* Custom Checkmark */}
          {true && ( // Change this condition to control if checked
            <div 
              style={{
                position: 'absolute',
                top: '2px',
                left: '6px',
                width: '8px',
                height: '12px',
                border: 'solid #ffffff', // White checkmark
                borderWidth: '0 3px 3px 0',
                transform: 'rotate(45deg)',
              }}
            />
          )}
        </div>
        <label style={{ marginLeft: '8px', fontSize: '16px' }}>{title}</label>
      </div>
    ))
                              )}
                            </td>
                            <td>
                              {routeTempAdded === index || routeTempEdited === index ? (
                                <select
                                  className="form-select"
                                  name="vehicleType"
                                  value={formData6.vehicleType}
                                  onChange={handleChange5}
                                >
                                  <option value="">Select Vehicle Type</option>
                                  {VehTypeOptionsTemplateManageHTML}
                                </select>
                              ) : (
                                group["Vehicle Type"] || group.vVehicleType
                              )}
                            </td>
                            <td>
                              {routeTempAdded === index || routeTempEdited === index ? (
                                <input
                                  type="time"
                                  className="form-control"
                                  name="startTime"
                                  value={formData6.startTime}
                                  onChange={handleChange5}
                                />
                              ) : (
                                group["Start Time"] || group.StartTime
                                
                              )}
                            </td>
                            <td>
                              {routeTempAdded === index || routeTempEdited === index ? (
                                <input
                                  type="number"
                                  className="form-control"
                                  name="duration"
                                  value={formData6.duration}
                                  onChange={handleChange5}
                                />
                              ) : (
                                group["Max Route Hours"] || group.MaxRouteHours
                              )}
                            </td>
                            <td>
                              {routeTempAdded === index || routeTempEdited === index ? (
                                <input
                                  type="number"
                                  className="form-control"
                                  name="miles"
                                  value={formData6.miles}
                                  onChange={handleChange5}
                                />
                              ) : (
                                group["Max Route Miles"] || group.bMaxRouteMiles
                              )}
                            </td>
                            <td>
                              {routeTempAdded === index || routeTempEdited === index ? (
                                <select
                                  className="form-select"
                                  name="recAffiliate"
                                  value={formData6.recAffiliate}
                                  onChange={handleChange5}
                                >
                                  <option value="">Select Affiliate</option>
                                  {ReceivingAffiliates.map((affiliate) => (
                                    <option key={affiliate.iAffiliateID} value={affiliate.iAffiliateID}>
                                      {affiliate.vName}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                ReceivingAffiliates.find((affiliate) => affiliate.iAffiliateID === (group.iServingAffiliateID || group.iAffiliateID
                                ))?.vName
                              )}
                            </td>
                            <td>
                              {routeTempAdded === index ? (
                                <button
                                  className="bg-success btn btn-dark ms-2"
                                  onClick={() => {
                                    // group.BreakTimes = breaksRouteGroups.filter(item => item.routePrefix === group.routePrefix);
                                    setShowBreakInputModalTwo(true);
                                  }}
                                >
                                  +
                                </button>
                              ) : (
                                <div
                                  className="btn btn-warning"
                                  onClick={() => {
                                    // group.BreakTimes = breaksRouteGroups.filter(item => item.routeNumber === group.Route || group.routeNo);
                                    if(routeTempEdited!=index){
                                    handleViewDetails3(group);
                                    }
                                  }}
                                >
                                  {routeTempEdited === index ? 'Edit Break Details' : 'Break Details'}
                                </div>
                              )}
                            </td>
                            <td>
                              {/* <div
                                className="btn btn-warning"
                                onClick={() => {
                                  if (group.iDepot !== 0) {
                                    handleZoneDetails2(depots.find(d => d.depotId === group.iDepot));
                                  } else {
                                    setSelectedGroup3(group);
                                    setShowRouteZoneDetailModal2(true);
                                  }
                                }}
                                style={{
                                  pointerEvents: (routeTempEdited === index || routeTempAdded === index) ? 'none' : 'auto',
                                }}
                              > */}
                                {/* {group.iDepot !== 0 ? 'See Zone Details' : 'Add Zone Details'} */}
                              {/* </div> */}
                            </td>
                            <td>
                              {/* <button onClick={() => handleDelete(group)} className="btn btn-danger btn-sm">Delete</button> */}
                              {routeTempAdded === index || routeTempEdited === index ? (
                                <>
                                  <Button
                                    onClick={() => {
                                      // if (formData6.depot===""){
                                      //   alert('attach a depot to save route template');
                                      //   return;
                                      // }
                                      if(formData6.templateName==="" || formData6.routePrefix==="" || formData6.noOfRoutes===0 
                                        || formData6.noOfRoutes==="" || formData6.startTime==="" || formData6.vehicleType===""
                                        || formData6.duration===""
                                      ){
                                        alert('please enter correct info to save route template');
                                        return;
                                      }
                                      if(routeTempEdited === index){
                                        saveRouteTemplate(group.iID);

                                      }
                                      else{
                                      saveRouteTemplate();
                                      }
                                      setRouteGroups(prevArray => {
                                        const newArray = [...prevArray];
                                        newArray.pop();
                                        return newArray;
                                      });
                                      setRouteTempAdded(-1);
                                      setRouteTempEdited(-1);
                                      setIsButtonTwoDisabled(false);
                                    }}
                                    className="btn-sm"
                                    style={{ backgroundColor: "#4CAF50" ,marginBottom: "5px" }}
                                  >
                                     <FontAwesomeIcon icon={faSave} />
                                  
                                  </Button>
                                  <Button
                                    onClick={() => {
                                      if (routeTempAdded === index) {
                                        setRouteGroups(prevArray => {
                                          const newArray = [...prevArray];
                                          newArray.pop();
                                          return newArray;
                                        });
                                        setRouteTempAdded(-1);
                                      }
                                      setRouteTempEdited(-1);
                                      setFormData6(prev => ({
                                        ...prev,
                                        // vehicle:'',
                                        templateName: '',
                                        routePrefix: '',
                                        noOfRoutes: 0,
                                        // routeNo:'',
                                        depot: '',
                                        vehicleType: '',
                                        startTime: '',
                                        recAffiliate: '',
                                        duration: '',
                                        breakTimes: [],
                                        attribute: '',
                                        // activeVehCheck:false
                                      }));
                                      // setFormData7(prev => ({
                                      //   ...prev,
                                      //   templateName: '',
                                      //   noOfRoutes: 0,
                                      //   routePrefix: '',
                                      //   depot: '',
                                      //   vehicleType: '',
                                      //   startTime: '',
                                      //   recAffiliate: '',
                                      //   duration: '',
                                      //   attribute: '',
                                      // }));
                                      setIsButtonTwoDisabled(false);
                                    }}
                                    className="btn-sm"
                                    style={{ backgroundColor: "red" }}
                                  >
                                      <FontAwesomeIcon icon={faBroomBall} />

                                    
                                  </Button>
                                </>
                              ) : null}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td className="text-center">
                            <button
                              className="btn btn-outline-success btn-sm"
                              disabled={isButtonTwoDisabled}
                              onClick={() => {
                                if (sharedData != null) {
                                  setRouteTempAdded(routeGroups?.length||0);
                                  setRouteGroups([... (routeGroups || []), formData6]);
                                  // setRouteGroups([...routeGroups, formData6]);
                                  setIsButtonTwoDisabled(true);
                                } else {
                                  alert('Select a setting');
                                }
                              }}
                            >
                              +
                            </button>
                          </td>
                          <td colSpan="11"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>


              <div className="container-fluid">
                            <div
                className="text-white p-2 mb-2"
                style={{
                  backgroundColor: '#87CEFA',
                  position: 'relative',
                  height: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: '60px',
                  paddingRight: '270px', // space for search box
                }}
              >
                {/* Collapse Button on Left */}
                <div style={{ position: 'absolute', left: '10px' }}>
                  <button
                    onClick={toggleCollapse}
                    className="btn btn-primary"
                    style={{ width: '40px', height: '40px' }}
                  >
                    {isCollapsed ? '+' : '-'}
                  </button>
                </div>

                {/* Centered Title */}
                <div
                  style={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    whiteSpace: 'nowrap',
                    color: '#FFFF',
                  }}
                >
                  Route Definition
                </div>

                {/* Search Bar on Right */}
                <div
                  style={{
                    position: 'absolute',
                    right: '10px',
                    width: '250px',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#fff',
                    borderRadius: '2rem',
                    padding: '0 0.75rem',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                  }}
                >
                  <span style={{ marginRight: '8px' }}>🔍</span>
                  <input
                    type="text"
                    placeholder="Search..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    style={{
                      border: 'none',
                      outline: 'none',
                      flex: 1,
                      padding: '8px 0',
                      background: 'transparent',
                    }}
                  />
                  {query && (
                    <button
                      onClick={() => setQuery("")}
                      aria-label="Clear search"
                      style={{
                        background: 'transparent',
                        border: 'none',
                        fontSize: '1rem',
                        cursor: 'pointer',
                      }}
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>



                {!isCollapsed && (  
                <div className="card-body"
                              style={{
                                    maxHeight: "500px",   // fix table height
                                    maxWidth: "100%",     // fix table width
                                    overflowX: "auto",    // horizontal scroll
                                    overflowY: "auto"     // vertical scroll
                                  }}
                >
                  <table className="table table-bordered">
                    <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                      <tr>
                        <th>Action</th>
                        <th>Template Name</th>
                        <th>Route #</th>
                        <th>Depot</th>
                        <th>Attribute</th>
                        <th>Vehicle #</th>
                        <th>Vehicle Type</th>
                        <th>Max Wheel Chairs</th>
                        <th>Total Capacity</th>
                        <th>Less Per Wheel Chair</th>
                        <th>Start Time</th>
                        <th>Duration</th>
                        <th>Miles</th>
                        <th>Rec Affiliate</th>
                        {/* <th>Active Vehicle</th> */}
                        <th>Default Route</th>
                        <th>Route Break</th>
                        <th>Zone Details</th>
                        <th>Manage</th>
                      </tr>
                    </thead>
                    <tbody>
                      {console.log(routeGroups2)}
                      {routeGroups2?.
                      filter(group => (
                        (group.templateName?.toLowerCase().includes(query.toLowerCase())) ||
                        ((group.Route || group.routeNo)?.toLowerCase().includes(query.toLowerCase()))   ||
                        (depotData.find(item=>item.DepotNumber===(group.iDepot || group.depot))?.DepotName.toLowerCase().includes(query.toLowerCase())) ||
                        ((group.Attributes || group.attribute)?.split(',').map(attributeId => {
                          const matchedItem = AttributeDataRef?.current?.find(item => item.iID === Number(attributeId));
                          return matchedItem ? matchedItem.vTitle : null;
                        }).filter(title => title !== null).some(title =>
                          title.toLowerCase().includes(query.toLowerCase())
                        )) ||
                      ((group["Associated Vehicle"] || group.vehicle)?.toLowerCase().includes(query.toLowerCase())) ||
                      ((group["Vehicle Type"] || group.vehicleType)?.toLowerCase().includes(query.toLowerCase())) ||
                      ((group["Start Time"] || group.startTime)?.toLowerCase().includes(query.toLowerCase())) ||
                      (ReceivingAffiliates.find((affiliate) => affiliate.iAffiliateID === (group.iServingAffiliateID || group.recAffiliate))?.vName.toLowerCase().includes(query.toLowerCase())) ||
                      (Number(group["Max Wheel Chairs"]) === Number(query)) ||
                      (Number(group["Total Capacity"]) === Number(query)) ||
                      (Number(group["Less Per Wheel Chair"]) === Number(query)) ||
                      (Number(group["Max Route Hours"]) === Number(query))
                      ))
                      
                      
                      .map((group, index) => (
                        <tr key={group.iRouteID}>
                          <td>
                          {index!==routeAdded  && (
                            <>
                      <button type="button" 
                      className="btn btn-danger btn-sm mr-2"
                      style={{ marginRight: "5px",marginBottom:"3px" }} 
                      onClick={() => {alert('are you sure to delete this route');handleDelete2(group);}}>
                         <FontAwesomeIcon icon={faTrashAlt} />

                      </button>

                          <button type="button"
                          disabled={isButtonDisabled}
                           className="btn btn-primary btn-sm"
                          onClick={() =>{
                            const vehicleId = vehDataRef?.current?.find(item => item.VehicleNumber === (Number(group["Associated Vehicle"]) || Number(group.vehicle)))?.VehicleID;
                            setFormData4(prev => ({
                              ...prev,
                              // vehicle: group["Associated Vehicle"] || group.vehicle,
                              vehicle: vehicleId!==undefined?String(vehicleId):'', 
                              routeNo: group.Route || group.routeNo||'',
                              depot:group.iDepot || group.depot||'',
                              vehicleType:group["Vehicle Type"] || group.vehicleType||'',
                              startTime:  group["Start Time"] || group.startTime||'',
                              recAffiliate:  group.iServingAffiliateID || group.recAffiliate||0,
                              duration:group["Max Route Hours"] || group.duration,
                              // breakTimes: [],
                              attribute: group.Attributes || '',
                              activeVehCheck:group.bActive || group.activeVehCheck||false,
                              defaultRouteCheck:group.bDefaultRoute || group.defaultRouteCheck ||false,
                              miles:group["Max Route Miles"] || group.miles
                            }));
                            setRouteEdited(index);
                            setIsButtonDisabled(true);
                            }}>
                          <FontAwesomeIcon icon={faPencilAlt} />

                          </button>
                          </>
                           )}
                          </td>
                          <td>{group.templateName || 'N/A'}</td>
                           {/* <td>{group.Route||group.routeNo}</td> */}
                          {/* <td>{group.iDepot||group.depot}</td> */}
                          {/* <td>{group.attribute || 'N/A'}</td> */}
                          {/* * <td>{group.Vehicle Type}</td>  */}
                          {/* <td>{group["Associated Vehicle"]||group.vehicle}</td> */}
                          {/* <td>{group["Vehicle Type"]||group.vehicleType}</td> */}

                          {/* <td>{group["Start Time"]||group.startTime}</td> */}
                          {/* <td>{group["Max Route Hours"]||group.duration}</td> */}
                          {/* <td>{group.iServingAffiliateID||group.recAffiliate}</td> */}
                          <td>
  {routeAdded === index ? (
                            <input
                            type="text"
                            className="form-control"
                            name="routeNo"
                            value={formData4.routeNo}
                            onChange={handleChange4}
                            style={{ width: "150px" }}
                          />
  ) : (
    group.Route || group.routeNo
  )}
</td>
<td>
  {routeAdded === index  || routeEdited === index ? (
                            <select
                            className="form-select"
                            name="depot"
                            value={formData4.depot}
                            onChange={handleChange4}
                            style={{ width: "150px" }}

                          >
                            <option value="">Select Depot</option>
                            {/* Step 4: Map through depotData to create dropdown options */}
                            {depotData.map((depot) => (
                              <option key={depot.DepotNumber} value={depot.DepotNumber}>
                                {depot.DepotName}
                              </option>
                            ))}
                            {/* <option value="">Select Depot</option> */}
                            {/* <option value="MOCO">MOCO</option> */}
                          </select>
  ) : (
    depotData.find(item=>item.DepotNumber===(group.iDepot || group.depot))?.DepotName
  )}
</td>
<td>
  {routeAdded === index  || routeEdited === index ? (
         
                  //   <div className="multi-select-dropdown">
                  //   <p>Select attribute(s):</p>
                  //   <div className="checkbox-list">
                  //     {routeAttributeDropDownHTML}
                  //   </div>
                  //   <div>
                  //   </div>
                  // </div>
                //   <div className="multi-select-dropdown">
                //   {/* <p>Select attribute(s):</p> */}
                //   <div className="dropdown-container">
                //     <button className="dropdown-toggle" onClick={toggleIsDropdown}>
                //       {formData4.attribute ? `${formData4.attribute.split(',').length} Selected` : "Select Attributes"}
                //     </button>
            
                //     {isDropdownOpen && (
                //       <div className="checkbox-list">
                //         {/* {routeAttributeDropDownHTML} */}
                //         {AttributeDataRef.current.map(function (item, index) {
                //           return (

                //             <div key={index} className="checkbox-item">
                //               <input
                //                 type="checkbox"
                //                 id={item.iID}
                //                 value={item.iID}
                //                 checked={formData4.attribute.split(',').includes(String(item.iID))}
                //                 onChange={handleCheckboxChange2} // onChange handler for each checkbox
                //               />
                //               <label htmlFor={item.iID}>{item.vTitle}</label>
                //             </div>
                //           );
                //         })}
                //       </div>
                //     )}
                //   </div>
                // </div>
                <div className="multi-select-dropdown">
                <div className="dropdown-container">
                  <button className="dropdown-toggle" onClick={toggleIsDropdown}
                            style={{
                              // width: "100%",
                              padding: "10px",
                              fontSize: "16px",
                              cursor: "pointer",
                              backgroundColor: "transparent",  // Transparent background
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              textAlign: "left",
                              color: "#333",  // Text color
                              width:"150px"
                            }}
                  >
                    {formData4.attribute && AttributeDataRef.current.length>0
                      ? `${formData4.attribute.split(',').length} Selected`
                      : "Select Attributes"}
                  </button>
          
                  {isDropdownOpen && (
                    <div className="checkbox-list"
                    style={{
                      // position: "absolute",
                      // width: "100%",
                      maxHeight: "200px",
                      overflowY: "auto",
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      borderTop: "none",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      borderRadius: "4px",
                      padding: "10px",
                    }}
                    >
                      {AttributeDataRef.current.map(function (item, index) {
                        return (
                          <div key={index} className="checkbox-item">
                            <input
                              type="checkbox"
                              id={item.iID}
                              value={item.iID}
                              checked={formData4.attribute.split(',').includes(String(item.iID))}
                              onChange={handleCheckboxChange2}
                            />
                            <label htmlFor={item.iID}>{item.vTitle}</label>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
  ) : (
    group.Attributes?.split(',').map(attributeId => {
      const matchedItem = AttributeDataRef?.current?.find(item => item.iID === Number(attributeId));
      return matchedItem ? matchedItem.vTitle : null;
    }).filter(title => title !== null).map((title, index) => (
      <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <div 
          style={{
            width: '20px',
            height: '20px',
            borderRadius: '4px',
            border: '2px solid #bbb',
            backgroundColor: '#b0e0e6', // Light blue background
            position: 'relative',
            cursor: 'not-allowed',
          }}
        >
          {/* Custom Checkmark */}
          {true && ( // Change this condition to control if checked
            <div 
              style={{
                position: 'absolute',
                top: '2px',
                left: '6px',
                width: '8px',
                height: '12px',
                border: 'solid #ffffff', // White checkmark
                borderWidth: '0 3px 3px 0',
                transform: 'rotate(45deg)',
              }}
            />
          )}
        </div>
        <label style={{ marginLeft: '8px', fontSize: '16px' }}>{title}</label>
      </div>
    ))
  )}
</td>
{/* <td>{group.Vehicle Type}</td> */}
<td>
  {routeAdded === index  || routeEdited === index ? (
                            <select
                            className="form-select"
                            name="vehicle"
                            value={formData4.vehicle}
                            onChange={handleChange4}
                            style={{ width: "150px" }}   
                          >
                            <option value="">Select Vehicle</option>

                            {VehOptionsManageHTML}
                            {/* <option value="Transit">Transit</option> */}
                          </select>
  ) : (
    group["Associated Vehicle"] || group.vehicle
  )}
</td>
<td>
  {routeAdded === index  || routeEdited === index ? (
                            <select
                            className="form-select"
                            name="vehicleType"
                            value={formData4.vehicleType}
                            onChange={handleChange4}
                            style={{ width: "150px" }}   

                          >
                            {/* <option value="">Select Vehicle Type</option> */}
                            {/* <option value="Transit">Transit</option> */}
                            <option value="">Select Vehicle Type</option>

                            {VehTypeOptionsManageHTML}
                          </select>
  ) : (
    group["Vehicle Type"] || group.vehicleType
  )}
</td>
<td>{group["Max Wheel Chairs"]}</td>
<td>{group["Total Capacity"]}</td>
<td>{group["Less Per Wheel Chair"]}</td>
<td>
  {routeAdded === index  || routeEdited === index ? (
                            <input
                            type="time"
                            className="form-control"
                            name="startTime"
                            value={formData4.startTime}
                            onChange={handleChange4}
                            style={{ width: "150px" }}   

                          />
  ) : (
    group["Start Time"] || group.startTime
  )}
</td>
<td>
  {routeAdded === index  || routeEdited === index ? (
                            <input
                            type="number"
                            className="form-control"
                            name="duration"
                            value={formData4.duration}
                            onChange={handleChange4}
                            style={{ width: "150px" }}    
                          />
  ) : (
    group["Max Route Hours"] || group.duration
  )}
</td>
<td>
  {routeAdded === index  || routeEdited === index ? (
                            <input
                            type="number"
                            className="form-control"
                            name="miles"
                            value={formData4.miles}
                            onChange={handleChange4}
                            style={{ width: "150px" }}

                          />
  ) : (
    group["Max Route Miles"] || group.miles
  )}
</td>
<td>
  {routeAdded === index  || routeEdited === index ? (
                          <select
                          className="form-select"
                          name="recAffiliate"
                          value={formData4.recAffiliate}
                          onChange={handleChange4}
                          style={{ width: "150px" }}   

                        >
                          <option value="">Select Affiliate</option>
                          {/* Step 4: Map through depotData to create dropdown options */}
                          {ReceivingAffiliates.map((affiliate) => (
                            <option key={affiliate.iAffiliateID} value={affiliate.iAffiliateID}>
                              {affiliate.vName}
                            </option>
                          ))}
                        </select>
  ) : (
    ReceivingAffiliates.find((affiliate) => affiliate.iAffiliateID === (group.iServingAffiliateID || group.recAffiliate))?.vName
    // group.iServingAffiliateID || group.recAffiliate
  )}
</td>
{/* <td>
  {routeAdded === index  || routeEdited === index ? (
  
  <Form.Check
    type="checkbox"
    name="activeVehCheck"
    // className="form-control"
    checked={formData4.activeVehCheck}  // Use checked for checkbox state
    onChange={handleChange4}
    style={{ width: '20px', height: '20px', margin: '0' }}  // Adjust styles as needed
    // name="startTime"  // Uncomment if needed
    disabled={!formData4.vehicle}
  />
) : (
  <Form.Check
    type="checkbox"
    name="activeVehCheck"
    // className="form-control"
    checked={group.bActive || group.activeVehCheck}  // Use checked for checkbox state
    onChange={handleChange4}
    style={{ width: '20px', height: '20px', margin: '0'}}  // Adjust styles as needed

    disabled
  />
)}
</td> */}
<td>
{/* {routeAdded === index ? (
        <input
        type="checkbox"
        className="form-control"
        // name="startTime"
        value={formData4.activeVehCheck}
        onChange={handleChange4}
        // disabled
      />
):(
      <input
        type="checkbox"
        className="form-control"
        // name="startTime"
        value={group.bActive || group.activeVehCheck}
        onChange={handleChange4}
        disabled
      />
    
)} */}
{routeAdded === index  || routeEdited === index ? (
  
  <Form.Check
    type="checkbox"
    name="defaultRouteCheck"
    // className="form-control"
    checked={formData4.defaultRouteCheck}  // Use checked for checkbox state
    onChange={handleChange4}
    style={{ width: '20px', height: '20px', margin: '0' }}  // Adjust styles as needed
    // name="startTime"  // Uncomment if needed
    // disabled={!formData4.vehicle}
  />
) : (
  <Form.Check
    type="checkbox"
    name="defaultRouteCheck"
    // className="form-control"
    checked={group.bDefaultRoute || group.defaultRouteCheck}  // Use checked for checkbox state
    onChange={handleChange4}
    style={{ width: '20px', height: '20px', margin: '0'}}  // Adjust styles as needed

    disabled
  />
)}
</td>

                          <td>
                          {routeAdded === index ? (
                          <button
                                className="bg-success btn btn-dark  ms-2"
                                onClick={() =>{
                              // group.BreakTimes=breaksRouteGroups2.filter(item => item.routeNumber === group.Route || group.routeNo)
                              setShowBreakInputModal(true)}}
                              >
                                +
                              </button>
                                                         
                            ):(
                              // handleViewDetails2(group)
                            <div className='btn btn-warning' onClick={() =>{
                              // group.BreakTimes=breaksRouteGroups2.filter(item => item.routeNumber === group.Route || group.routeNo)
                              // break=breaksRouteGroups2.filter(item => item.routeNumber === group.Route || group.routeNo)
                              // if()
                              // setBreakTimeEdited((prevState) => ({
                              //   ...prevState, // Spread the previous object properties
                              //   startHours: breaksRouteGroups2.find(item => item.routeNumber === group.Route || item.routeNo === group.routeNo)?.startHours,
                              //   earlyWindow: breaksRouteGroups2.find(item => item.routeNumber === group.Route || item.routeNo === group.routeNo)?.earlyWindow,
                              //   lateWindow: breaksRouteGroups2.find(item => item.routeNumber === group.Route || item.routeNo === group.routeNo)?.lateWindow,
                              //   duration: breaksRouteGroups2.find(item => item.routeNumber === group.Route || item.routeNo === group.routeNo)?.duration,
                              //   startTime: breaksRouteGroups2.find(item => item.routeNumber === group.Route || item.routeNo === group.routeNo)?.startTime
                              // }));
                              // if(routeEdited===index){
                                console.log('hello')
                                console.log(breaksRouteGroups2.find(item => item.routeNumber === group.Route || item.routeNo === group.routeNo));
                                setEditedBreaksRouteGroups2(
                                  breaksRouteGroups2
                                    .filter(item => item.routeNumber === group.Route || item.routeNo === group.routeNo)
                                    .map(item => JSON.parse(JSON.stringify(item)))  // Deep copy each item
                                );
                              // }
                              handleViewDetails2(group)
                            }}
                            style={{
                              pointerEvents: (routeEdited !==-1 && routeEdited!==index) ? 'none' : 'auto',
                              // opacity: routeEdited !== -1 ? 0.5 : 1, // Optional for visual feedback
                            }}
                            >{routeEdited===index?'Edit Break Details':'Break Details'}</div>
                              )}
                            
                          </td>
                          <td>
                          <div className="btn btn-warning" onClick={() => {
                            // handleZoneDetails(depot)
                            //setShowRouteZoneDetailModal(true);
                            if(group.iDepot!==0  && depotData.find(item=>item.DepotNumber===(group.iDepot || group.depot))?.DepotName){
                            handleZoneDetails(depots.find(d => d.depotId === group.iDepot));
                            }
                            else{
                              setSelectedGroup2(group);
                              setShowRouteZoneDetailModal(true);
                            }
                          }
                            }
                            style={{
                              pointerEvents: (routeEdited === index || routeAdded===index) ? 'none' : 'auto',
                              // opacity: routeEdited !== -1 ? 0.5 : 1, // Optional for visual feedback
                            }}
                            >
                              Zone Details
                               {/* {group.iDepot!==0 ? 'See Zone Details':'Add Zone Details'} */}
                         {/* {routeAdded === index || routeEdited === index ? 'Add/Edit Zone Details' : 'See Zone Details'} */}
                      </div>
                          </td>
                          <td>
                            {/* <button onClick={() => {alert('are you sure to delete this route');handleDelete2(group)}} className="btn btn-danger btn-sm">Delete</button> */}
                            {routeAdded === index || routeEdited === index ? (
                              <>
                                        <Button  onClick={() => {
                                          // if (formData4.depot===""){
                                          //   alert('attach a depot to save/update route');
                                          //   return;
                                          // }
                                          // setRouteGroups2(prevArray => prevArray.slice(0, prevArray.length - 1));
                                          // setRouteGroups2(prevArray => {
                                          //   const newArray = [...prevArray];
                                          //   newArray.pop();
                                          //   return newArray;
                                          // });
                                          //setRouteAdded(-1);
                                         // setRouteEdited(-1);
                                          if(routeEdited===index){
                                          handleSave3(group.iRouteID);
                                          }
                                          else{
                                            handleSave3();

                                          }
                                          //setIsButtonDisabled(false);
                                          }} className="btn-sm mr-6" style={{
                                          backgroundColor: "#4CAF50",marginBottom: "5px" }}>
                          <FontAwesomeIcon icon={faSave} />
                          </Button>
                          <Button  onClick={() => {
                            if(routeAdded===index){
                            // setRouteGroups2(prevArray => prevArray.slice(0, prevArray.length - 1));
                            setRouteGroups2(prevArray => {
                              const newArray = [...prevArray];
                              newArray.pop();
                              return newArray;
                            });
                            setRouteAdded(-1);
                            }
                            setRouteEdited(-1);
                            setFormData4(prev => ({
                              ...prev,
                              vehicle:'',
                              routeNo:'',
                              depot: '',
                              vehicleType: '',
                              startTime: '',
                              recAffiliate: '',
                              duration: '',
                              breakTimes: [],
                              attribute: '',
                              activeVehCheck:false,
                              defaultRouteCheck:false,
                              miles:''

                            }));
                            setIsButtonDisabled(false);
                          }} className="btn-sm" style={{
                                          backgroundColor: "red"}}>
                                           
                                           <FontAwesomeIcon icon={faBroomBall} />

                          </Button>
                          </>
                              ): (
                                <></>
                                // group.iServingAffiliateID || group.recAffiliate
                              )}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td className="text-center">
                          <button
                          // setShowModal3(true);
                            className="btn btn-outline-success btn-sm"
                            disabled={isButtonDisabled}
                            onClick={() =>{ 
                              if(sharedData!=null){
                              setRouteAdded(routeGroups2.length);
                              setRouteGroups2([...routeGroups2, formData4])
                              setIsButtonDisabled(true);
                              }
                              else{
                                alert('select a setting')
                              }
                            }}
                          >
                            +
                          </button>
                        </td>
                        <td colSpan='11'></td>

                      </tr>
                    </tbody>
                  </table>
                </div>
                )}
              </div>


              {showModal && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="bg-success text-white p-2 mb-2 w-25 mx-auto text-center">Add Route Group</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowModal(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Template Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="templateName"
                              value={formData3.templateName}
                              onChange={handleChange3}
                            />
                          </div>
                          {/* 'activeVehCheck' */}
                          <div className="col-md-6">
                            <label className='form-label fw-bold'>Active Vehicle?</label><input type='checkbox' name="activeVehCheck" checked={formData3.activeVehCheck} onChange={handleChange3} className='mx-2' style={{ cursor: "pointer" }} />
                          </div>

                          <div className="col-md-6">
                            <label className="form-label fw-bold">Route Prefix & Starting Number</label>
                            <input
                              type="text"
                              className="form-control"
                              name="routePrefixAndStartingNumber"
                              value={formData3.routePrefixAndStartingNumber}
                              onChange={handleChange3}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Number of Routes</label>
                            <input
                              type="number"
                              className="form-control"
                              name="numberOfRoutes"
                              value={formData3.numberOfRoutes}
                              onChange={handleChange3}
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Depot</label>
                            <select
                              className="form-select"
                              name="depot"
                              value={formData3.depot}
                              onChange={handleChange3}
                            >
                              <option value="">Select Depot</option>
                              {/* Step 4: Map through depotData to create dropdown options */}
                              {depotData.map((depot) => (
                                <option key={depot.DepotNumber} value={depot.DepotNumber}>
                                  {depot.DepotName}
                                </option>
                              ))}
                              {/* <option value="">Select Depot</option> */}
                              {/* <option value="MOCO">MOCO</option> */}
                            </select>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Vehicle Type</label>
                            <select
                              className="form-select"
                              name="vehicleType"
                              value={formData3.vehicleType}
                              onChange={handleChange3}
                            >
                              <option value="">Select Vehicle Type</option>

                              {VehTypeOptionsManageHTML}
                              {/* <option value="Transit">Transit</option> */}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Vehicle</label>
                            {/* <input
                              type="number"
                              className="form-control"
                              name="vehicle"
                              value={formData3.vehicle}
                              onChange={handleChange3}
                            /> */}
                            <select
                              className="form-select"
                              name="vehicle"
                              value={formData3.vehicle}
                              onChange={handleChange3}
                            >
                              <option value="">Select Vehicle</option>

                              {VehOptionsManageHTML}
                              {/* <option value="Transit">Transit</option> */}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Start Time</label>
                            <input
                              type="time"
                              className="form-control"
                              name="startTime"
                              value={formData3.startTime}
                              onChange={handleChange3}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Duration</label>
                            <input
                              type="number"
                              className="form-control"
                              name="duration"
                              value={formData3.duration}
                              onChange={handleChange3}
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Miles</label>
                            <input
                              type="number"
                              className="form-control"
                              name="duration"
                              value={formData3.duration}
                              onChange={handleChange3}
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Attribute</label>
                            <select
                              className="form-select"
                              name="attribute"
                              value={formData3.attribute}
                              onChange={handleChange3}
                            >
                              <option value="">Select attribute</option>
                              {routeAttributeDropDownHTML}
                              {/* <option value="attribute">attribute</option> */}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-bold">Rec Affiliate</label>
                          {/* <input
                            type="text"
                            className="form-control"
                            name="recAffiliate"
                            value={formData3.recAffiliate}
                            onChange={handleChange3}
                          /> */}
                          <select
                            className="form-select"
                            name="recAffiliate"
                            value={formData3.recAffiliate}
                            onChange={handleChange3}
                          >
                            <option value="">Select Affiliate</option>
                            {/* Step 4: Map through depotData to create dropdown options */}
                            {ReceivingAffiliates.map((affiliate) => (
                              <option key={affiliate.iAffiliateID} value={affiliate.iAffiliateID}>
                                {affiliate.vName}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="row mb-3 mt-3">
                          <div className="col-12">
                            <div className='d-flex align-items-center'>
                              <h5 className="">Break Times</h5>
                              <button
                                className="bg-success btn btn-dark  ms-2"
                                onClick={addBreakTime}
                              >
                                +
                              </button>
                            </div>
                            {formData?.breakTimes?.map((breakTime, index) => (
                              <div key={index} className="row mb-2 align-items-center">
                                <div className="col-2">
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="startTime"
                                    value={breakTime.startTime}
                                    onChange={(e) => handleBreakTimeChange(index, e)}
                                    placeholder="Start Time"
                                  />
                                </div>
                                <div className="col-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="startHours"
                                    value={breakTime.startHours}
                                    onChange={(e) => handleBreakTimeChange(index, e)}
                                    placeholder="Start Hrs"
                                  />
                                </div>
                                <div className="col-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="earlyWindow"
                                    value={breakTime.earlyWindow}
                                    onChange={(e) => handleBreakTimeChange(index, e)}
                                    placeholder="Early Win"
                                  />
                                </div>
                                <div className="col-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="lateWindow"
                                    value={breakTime.lateWindow}
                                    onChange={(e) => handleBreakTimeChange(index, e)}
                                    placeholder="Late Win"
                                  />
                                </div>
                                <div className="col-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="duration"
                                    value={breakTime.duration}
                                    onChange={(e) => handleBreakTimeChange(index, e)}
                                    placeholder="Duration"
                                  />
                                </div>
                                <div className="col-2">
                                  <button
                                    className="btn btn-dark me-2"
                                    onClick={() => removeBreakTime(index)}
                                  >
                                    X
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setShowModal(false)}
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleSave3}
                        >
                          Save Changes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}


              {showDepotDetailModal && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Depot Zone Details</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => {
                            setShowDepotDetailModal(false)
                            setFormData5(prev => ({
                              ...prev,
                              pickupattribute: '',
                              dropoffattribute: '',
                              triptype: ''
                            }));
                          }}
                        ></button>
                      </div>
                      <div className="modal-body">
                      {/* {!(selectedDepot?.isEditing || false) && ( */}
                      {(selectedDepot && selectedDepot.isEditing) && (

                        <div className="row mb-4">

                          {/* <label className="form-label"><strong>Zones</strong></label> */}
                          {/* {formData5?.zonedetails.map((zonedetail, index) => ( */}
                          <div className="col-md-3">

                            <Form.Label><strong>Pickup Attribute</strong></Form.Label>

                            <Form.Select
                              value={formData5.pickupattribute}
                              name="pickupattribute"
                              onChange={handleChangeDepotAttributeCombinationPopup}
                            // disabled={!editingRule.attributeType}
                            >
                              <option value="">Any</option>
                              {
                              // pickupAttributes.map(attr => (
                              //   <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                              // ))
                              getFilteredPickupAttributes('Zone').map(attr => (
                                  <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                                ))
                              }
                            </Form.Select>
                          </div>
                          <div className="col-md-3">

                            <Form.Label><strong>Dropoff Attribute</strong></Form.Label>

                            <Form.Select
                              name="dropoffattribute"
                              value={formData5.dropoffattribute}
                              onChange={handleChangeDepotAttributeCombinationPopup}

                            >
                              <option value="">Any</option>
                              {
                                getFilteredDropoffAttributes('Zone').map(attr => (
                                  <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                                ))
                              // dropoffAttributes.map(attr => (
                              //   <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                              // ))
                              
                              }
                            </Form.Select>
                          </div>
                          {/* <div className="col-md-3">

                            <Form.Label><strong>Apply To</strong></Form.Label>

                            <Form.Select
                              name="triptype"
                              value={formData5.triptype}
                              onChange={handleChangeDepotAttributeCombinationPopup}

                            >
                              <option value="">Select Type</option>
                              <option value="0">First Trip</option>
                              <option value="1">Other Trips</option>
                              <option value="1">All Trips</option>

                            </Form.Select>

                          </div> */}
                          <div className="col-md-3">
                            <Form.Label><strong>Add Combination</strong></Form.Label>

                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={() => addZoneDetailsToAttrbiuteRefTable(selectedDepot.depotId, 'Depot')}
                              disabled={!(selectedDepot?.isEditing || false)}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                        )}
                        <table className="table table-striped table-bordered table-hover">
                          <thead>
                            <tr>
                              <th>Pickup Attribute</th>
                              <th>DropOff Attribute</th>
                              {/* <th>Trip Type</th> */}
                              {(selectedDepot && selectedDepot?.isEditing)  && (
                                <th>Actions</th>
                              )}
                              {/* <th>Actions</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {depotAttributeCombinationDetails.filter(entry => entry.REFID === selectedDepot?.depotId).map((entry) => (
                              <tr key={entry.iID}>
                                <td>
                                  {pickupAttributes.find(pickup => pickup.iID === entry.iPickupAttributeID)?.vTitle ||'Any'}
                                </td>
                                <td>
                                  {dropoffAttributes.find(dropoff => dropoff.iID === entry.iDropOffAttributeID)?.vTitle || 'Any'}
                                </td>
                                {/* <td>{tripTypeDescriptions[entry.TripType] || 'Unknown'}</td> */}
                                {(selectedDepot && selectedDepot?.isEditing)  && (
                                <td>
                                  <button
                                    disabled={!(selectedDepot?.isEditing || false)}
                                    onClick={() => handleDepotAttributeCombinationDelete(entry.iID)}
                                    className="btn btn-danger btn-sm">
                                    Delete
                                  </button>
                                </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => {
                            setShowDepotDetailModal(false);
                            setFormData5(prev => ({
                              ...prev,
                              pickupattribute: '',
                              dropoffattribute: '',
                              triptype: ''
                            }));
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showRouteZoneDetailModal && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Route Zone Details</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => {
                            setShowRouteZoneDetailModal(false);
                            setSelectedGroup2(null);
                            setFormData5(prev => ({
                              ...prev,
                              pickupattribute: '',
                              dropoffattribute: '',
                              triptype: ''
                            }));
                          }}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="row mb-4">

                          {/* <label className="form-label"><strong>Zones</strong></label> */}
                          {/* {formData5?.zonedetails.map((zonedetail, index) => ( */}
                          <div className="col-md-3">

                            <Form.Label><strong>Pickup Attribute</strong></Form.Label>

                            <Form.Select
                              value={formData5.pickupattribute}
                              name="pickupattribute"
                              onChange={handleChangeDepotAttributeCombinationPopup}
                            // disabled={!editingRule.attributeType}
                            >
                              <option value="">Any</option>
                              {pickupAttributes.map(attr => (
                                <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                              ))}
                            </Form.Select>
                          </div>
                          <div className="col-md-3">

                            <Form.Label><strong>Dropoff Attribute</strong></Form.Label>

                            <Form.Select
                              name="dropoffattribute"
                              value={formData5.dropoffattribute}
                              onChange={handleChangeDepotAttributeCombinationPopup}

                            >
                              <option value="">Any</option>
                              {dropoffAttributes.map(attr => (
                                <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                              ))}
                            </Form.Select>
                          </div>
                          {/* <div className="col-md-3">

                            <Form.Label><strong>Apply To</strong></Form.Label>

                            <Form.Select
                              name="triptype"
                              value={formData5.triptype}
                              onChange={handleChangeDepotAttributeCombinationPopup}

                            >
                              <option value="">Select Type</option>
                              <option value="0">First Trip</option>
                              <option value="1">Other Trips</option>
                              <option value="1">All Trips</option>

                            </Form.Select>

                          </div> */}
                          <div className="col-md-3">
                            <Form.Label><strong>Add Combination</strong></Form.Label>

                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={() => addZoneDetailsToAttrbiuteRefTable(selectedGroup2.iRouteID, 'Route')}
                            //  disabled={!(routeEdited===-1)}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                        <table className="table table-striped table-bordered table-hover">
                          <thead>
                            <tr>
                              <th>Pickup Attribute</th>
                              <th>DropOff Attribute</th>
                              {/* <th>Trip Type</th> */}
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {routetAttributeCombinationDetails.filter(entry => entry.REFID === selectedGroup2.iRouteID).map((entry) => (
                              <tr key={entry.iID}>
                                <td>
                                  {pickupAttributes.find(pickup => pickup.iID === entry.iPickupAttributeID)?.vTitle || 'Any'}
                                </td>
                                <td>
                                  {dropoffAttributes.find(dropoff => dropoff.iID === entry.iDropOffAttributeID)?.vTitle || 'Any'}
                                </td>
                                {/* <td>{tripTypeDescriptions[entry.TripType] || 'Unknown'}</td> */}
                                <td>
                                  <button
                                    //  disabled={!(selectedDepot?.isEditing || false)}
                                    onClick={() => handleDepotAttributeCombinationDelete(entry.iID)}
                                    className="btn btn-danger btn-sm">
                                    Delete
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => {
                            setSelectedGroup2(null);
                            setShowRouteZoneDetailModal(false);
                            setFormData5(prev => ({
                              ...prev,
                              pickupattribute: '',
                              dropoffattribute: '',
                              triptype: ''
                            }));
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}


              {showRouteZoneDetailModal2 && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Route Template Zone Details</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => {
                            setShowRouteZoneDetailModal2(false);
                            setSelectedGroup3(null);
                            setFormData7(prev => ({
                              ...prev,
                              pickupattribute: '',
                              dropoffattribute: '',
                              triptype: ''
                            }));
                          }}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="row mb-4">

                          {/* <label className="form-label"><strong>Zones</strong></label> */}
                          {/* {formData5?.zonedetails.map((zonedetail, index) => ( */}
                          <div className="col-md-3">

                            <Form.Label><strong>Pickup Attribute</strong></Form.Label>

                            <Form.Select
                              value={formData7.pickupattribute}
                              name="pickupattribute"
                              onChange={handleChangeDepotAttributeCombinationPopup2}
                            // disabled={!editingRule.attributeType}
                            >
                              <option value="">Select Type</option>
                              {pickupAttributes.map(attr => (
                                <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                              ))}
                            </Form.Select>
                          </div>
                          <div className="col-md-3">

                            <Form.Label><strong>Dropoff Attribute</strong></Form.Label>

                            <Form.Select
                              name="dropoffattribute"
                              value={formData7.dropoffattribute}
                              onChange={handleChangeDepotAttributeCombinationPopup2}

                            >
                              <option value="">Select Type</option>
                              {dropoffAttributes.map(attr => (
                                <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                              ))}
                            </Form.Select>
                          </div>
                          {/* <div className="col-md-3">

                            <Form.Label><strong>Apply To</strong></Form.Label>

                            <Form.Select
                              name="triptype"
                              value={formData7.triptype}
                              onChange={handleChangeDepotAttributeCombinationPopup2}

                            >
                              <option value="">Select Type</option>
                              <option value="0">First Trip</option>
                              <option value="1">Other Trips</option>
                              <option value="1">All Trips</option>

                            </Form.Select>

                          </div> */}
                          <div className="col-md-3">
                            <Form.Label><strong>Add Combination</strong></Form.Label>

                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={() => addZoneDetailsToAttrbiuteRefTable(selectedGroup3.iRouteTemplateID, 'Route Template')}
                            //  disabled={!(routeEdited===-1)}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                        <table className="table table-striped table-bordered table-hover">
                          <thead>
                            <tr>
                              <th>Pickup Attribute</th>
                              <th>DropOff Attribute</th>
                              {/* <th>Trip Type</th> */}
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {routeTempAttributeCombinationDetails.filter(entry => entry.REFID === selectedGroup3.iRouteTemplateID).map((entry) => (
                              <tr key={entry.iID}>
                                <td>
                                  {pickupAttributes.find(pickup => pickup.iID === entry.iPickupAttributeID)?.vTitle || entry.iPickupAttributeID}
                                </td>
                                <td>
                                  {dropoffAttributes.find(dropoff => dropoff.iID === entry.iDropOffAttributeID)?.vTitle || entry.iDropOffAttributeID}
                                </td>
                                {/* <td>{tripTypeDescriptions[entry.TripType] || 'Unknown'}</td> */}
                                <td>
                                  <button
                                    //  disabled={!(selectedDepot?.isEditing || false)}
                                    onClick={() => handleDepotAttributeCombinationDelete(entry.iID)}
                                    className="btn btn-danger btn-sm">
                                    Delete
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => {
                            setSelectedGroup3(null);
                            setShowRouteZoneDetailModal2(false);
                            setFormData7(prev => ({
                              ...prev,
                              pickupattribute: '',
                              dropoffattribute: '',
                              triptype: ''
                            }));
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}



              {showModal3 && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="bg-success text-white p-2 mb-2 w-25 mx-auto text-center">Add Route Group</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowModal3(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Route #</label>
                            <input
                              type="text"
                              className="form-control"
                              name="routeNo"
                              value={formData4.routeNo}
                              onChange={handleChange4}
                            />
                          </div>
                          <div className="col-md-6">
                            <label className='form-label fw-bold'>Active Vehicle?</label><input type='checkbox' name="activeVehCheck" checked={formData4.activeVehCheck} onChange={handleChange4} className='mx-2' style={{ cursor: "pointer" }} />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Vehicle</label>
                            {/* <input
                              type="number"
                              className="form-control"
                              name="vehicle"
                              value={formData4.vehicle}
                              onChange={handleChange3}
                            /> */}
                            <select
                              className="form-select"
                              name="vehicle"
                              value={formData4.vehicle}
                              onChange={handleChange4}
                            >
                              <option value="">Select Vehicle</option>

                              {VehOptionsManageHTML}
                              {/* <option value="Transit">Transit</option> */}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Depot</label>
                            <select
                              className="form-select"
                              name="depot"
                              value={formData4.depot}
                              onChange={handleChange4}
                            >
                              <option value="">Select Depot</option>
                              {/* Step 4: Map through depotData to create dropdown options */}
                              {depotData.map((depot) => (
                                <option key={depot.DepotNumber} value={depot.DepotNumber}>
                                  {depot.DepotName}
                                </option>
                              ))}
                              {/* <option value="">Select Depot</option> */}
                              {/* <option value="MOCO">MOCO</option> */}
                            </select>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Vehicle Type</label>
                            <select
                              className="form-select"
                              name="vehicleType"
                              value={formData4.vehicleType}
                              onChange={handleChange4}
                            >
                              {/* <option value="">Select Vehicle Type</option> */}
                              {/* <option value="Transit">Transit</option> */}
                              <option value="">Select Vehicle Type</option>

                              {VehTypeOptionsManageHTML}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Start Time</label>
                            <input
                              type="time"
                              className="form-control"
                              name="startTime"
                              value={formData4.startTime}
                              onChange={handleChange4}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Duration</label>
                            <input
                              type="number"
                              className="form-control"
                              name="duration"
                              value={formData4.duration}
                              onChange={handleChange4}
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Miles</label>
                            <input
                              type="number"
                              className="form-control"
                              name="duration"
                              value={formData4.duration}
                              onChange={handleChange4}
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Attribute</label>
                            <select
                              className="form-select"
                              name="attribute"
                              value={formData4.attribute}
                              onChange={handleChange4}
                            >
                              <option value="">Select attribute</option>
                              {routeAttributeDropDownHTML}
                              {/* <option value="attribute">attribute</option> */}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-bold">Rec Affiliate</label>
                          {/* <input
                            type="text"
                            className="form-control"
                            name="recAffiliate"
                            value={formData4.recAffiliate}
                            onChange={handleChange3}
                          /> */}
                          <select
                            className="form-select"
                            name="recAffiliate"
                            value={formData4.recAffiliate}
                            onChange={handleChange4}
                          >
                            <option value="">Select Affiliate</option>
                            {/* Step 4: Map through depotData to create dropdown options */}
                            {ReceivingAffiliates.map((affiliate) => (
                              <option key={affiliate.iAffiliateID} value={affiliate.iAffiliateID}>
                                {affiliate.vName}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="row mb-3 mt-3">
                          <div className="col-12">
                            <div className='d-flex align-items-center'>
                              <h5 className="">Break Times</h5>
                              <button
                                className="bg-success btn btn-dark  ms-2"
                                onClick={addBreakTime}
                              >
                                +
                              </button>
                            </div>
                            {formData?.breakTimes?.map((breakTime, index) => (
                              <div key={index} className="row mb-2 align-items-center">
                                <div className="col-2">
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="startTime"
                                    value={breakTime.startTime}
                                    onChange={(e) => handleBreakTimeChange(index, e)}
                                    placeholder="Start Time"
                                  />
                                </div>
                                <div className="col-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="startHours"
                                    value={breakTime.startHours}
                                    onChange={(e) => handleBreakTimeChange(index, e)}
                                    placeholder="Start Hrs"
                                  />
                                </div>
                                <div className="col-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="earlyWindow"
                                    value={breakTime.earlyWindow}
                                    onChange={(e) => handleBreakTimeChange(index, e)}
                                    placeholder="Early Win"
                                  />
                                </div>
                                <div className="col-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="lateWindow"
                                    value={breakTime.lateWindow}
                                    onChange={(e) => handleBreakTimeChange(index, e)}
                                    placeholder="Late Win"
                                  />
                                </div>
                                <div className="col-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="duration"
                                    value={breakTime.duration}
                                    onChange={(e) => handleBreakTimeChange(index, e)}
                                    placeholder="Duration"
                                  />
                                </div>
                                <div className="col-2">
                                  <button
                                    className="btn btn-dark me-2"
                                    onClick={() => removeBreakTime(index)}
                                  >
                                    X
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setShowModal3(false)}
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleSave3}
                        >
                          Save Changes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}


              {showModal2 && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="bg-success text-white p-2 mb-2 w-25 mx-auto text-center">Add Route Group</div>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowModal2(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Template Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="templateName"
                              value={formData2.templateName}
                              onChange={handleChange2}
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Route Prefix & Starting Number</label>
                            <input
                              type="text"
                              className="form-control"
                              name="routeNumber"
                              value={formData2.routeNumber}
                              onChange={handleChange2}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label">Associated Zone</label>
                            <select
                              className="form-select"
                              name="depot"
                              value={formData2.depot}
                              onChange={handleChange2}
                            >
                              <option value="">Select Depot</option>
                              <option value="MOCO">MOCO</option>
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Vehicle #</label>
                            <input
                              type="number"
                              className="form-control"
                              name="vehicleNumber"
                              value={formData2.vehicleNumber}
                              onChange={handleChange2}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label">Vehicle Type</label>
                            <select
                              className="form-select"
                              name="vehicleType"
                              value={formData2.vehicleType}
                              onChange={handleChange2}
                            >
                              <option value="">Select Vehicle Type</option>
                              <option value="Transit">Transit</option>
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Start Time</label>
                            <input
                              type="time"
                              className="form-control"
                              name="startTime"
                              value={formData2.startTime}
                              onChange={handleChange2}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label">Duration</label>
                            <input
                              type="number"
                              className="form-control"
                              name="duration"
                              value={formData2.duration}
                              onChange={handleChange2}
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Miles</label>
                            <input
                              type="number"
                              className="form-control"
                              name="duration"
                              value={formData2.duration}
                              onChange={handleChange2}
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Attribute</label>
                            <select
                              className="form-select"
                              name="attribute"
                              value={formData2.attribute}
                              onChange={handleChange2}
                            >
                              <option value="">Select attribute</option>
                              <option value="attribute">attribute</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Rec Affiliate</label>
                          <input
                            type="text"
                            className="form-control"
                            name="recAffiliate"
                            value={formData2.recAffiliate}
                            onChange={handleChange2}
                          />
                        </div>

                        <div className="row mb-3 mt-3">
                          <div className="col-12">
                            <div className='d-flex align-items-center'>
                              <h5 className="">Break Times</h5>
                              <button
                                className="btn btn-dark  ms-2"
                                onClick={addBreakTime2}
                              >
                                +
                              </button>
                            </div>
                            {formData2?.breakTimes?.map((breakTime, index) => (
                              <div key={index} className="row mb-2 align-items-center">
                                <div className="col-2">
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="startTime"
                                    value={breakTime.startTime}
                                    onChange={(e) => handleBreakTimeChange2(index, e)}
                                    placeholder="Start Time"
                                  />
                                </div>
                                <div className="col-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="startHours"
                                    value={breakTime.startHours}
                                    onChange={(e) => handleBreakTimeChange2(index, e)}
                                    placeholder="Start Hrs"
                                  />
                                </div>
                                <div className="col-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="earlyWindow"
                                    value={breakTime.earlyWindow}
                                    onChange={(e) => handleBreakTimeChange2(index, e)}
                                    placeholder="Early Win"
                                  />
                                </div>
                                <div className="col-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="lateWindow"
                                    value={breakTime.lateWindow}
                                    onChange={(e) => handleBreakTimeChange2(index, e)}
                                    placeholder="Late Win"
                                  />
                                </div>
                                <div className="col-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="duration"
                                    value={breakTime.duration}
                                    onChange={(e) => handleBreakTimeChange2(index, e)}
                                    placeholder="Duration"
                                  />
                                </div>
                                <div className="col-2">
                                  <button
                                    className="btn btn-dark me-2"
                                    onClick={() => removeBreakTime2(index)}
                                  >
                                    X
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setShowModal2(false)}
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleSave2}
                        >
                          Save Changes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {showDetailModal && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Route Group Details</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowDetailModal(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label fw-bold">Template Name</label>
                            <p>{selectedGroup.templateName}</p>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Route Prefix & Starting Number</label>
                            <p>{selectedGroup.routePrefixAndStartingNumber}</p>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label">Number of Routes</label>
                            <p>{selectedGroup.numberOfRoutes}</p>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Depot</label>
                            <p>{selectedGroup.depot}</p>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label">Vehicle Type</label>
                            <p>{selectedGroup.vehicleType}</p>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Start Time</label>
                            <p>{selectedGroup.startTime}</p>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label">Duration</label>
                            <p>{selectedGroup.duration}</p>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Miles</label>
                            <p>{selectedGroup.duration}</p>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Rec Affiliate</label>
                            <p>{selectedGroup.recAffiliate}</p>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Attribute</label>
                          <p>{selectedGroup.attribute}</p>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className="form-label">Break Times</label>
                            {selectedGroup.breakTimes.map((breakTime, index) => (
                              <div key={index} className="row mb-2">
                                <div className="col-2">
                                  <p>{breakTime.startTime}</p>
                                </div>
                                <div className="col-2">
                                  <p>{breakTime.startHours}</p>
                                </div>
                                <div className="col-2">
                                  <p>{breakTime.earlyWindow}</p>
                                </div>
                                <div className="col-2">
                                  <p>{breakTime.lateWindow}</p>
                                </div>
                                <div className="col-2">
                                  <p>{breakTime.duration}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setShowDetailModal(false)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {showBreakInputModal && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Add Break Details</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowBreakInputModal(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className="form-label">
                              <strong>Break Times</strong>
                            </label>

                            {/* Loop through formData4.breakTimes to display each set of fields */}
                            {formData4.breakTimes.map((breakTime, index) => (
                              <div key={index} className="row mb-2">
                                <div className="col-3">
                                  <label><strong>Start Time</strong></label>
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="startTime"
                                    value={breakTime.startTime}
                                    onChange={(e) => handleInputChange(index, e)}
                                    placeholder="Start Time"
                                  />
                                </div>

                                <div className="col-3">
                                  <label><strong>Hrs From Route Start</strong></label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="startHours"
                                    value={breakTime.startHours}
                                    onChange={(e) => handleInputChange(index, e)}
                                  />
                                </div>

                                <div className="col-3">
                                  <label><strong>Break Early Window</strong></label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="earlyWindow"
                                    value={breakTime.earlyWindow}
                                    onChange={(e) => handleInputChange(index, e)}
                                  />
                                </div>

                                <div className="col-3">
                                  <label><strong>Break Late Window</strong></label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="lateWindow"
                                    value={breakTime.lateWindow}
                                    onChange={(e) => handleInputChange(index, e)}
                                  />
                                </div>

                                <div className="col-3">
                                  <label><strong>Break Duration</strong></label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="duration"
                                    value={breakTime.duration}
                                    onChange={(e) => handleInputChange(index, e)}
                                  />
                                </div>
                                {/* Remove button */}
                                <div className="col-1 d-flex align-items-center justify-content-center">
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => removeBreakTime(index)}
                                  >
                                    <strong>X</strong>
                                  </button>
                                </div>
                              </div>
                            ))}

                            {/* Button to add a new break time */}
                            <div className="col-3">
                              <button
                                type="button"
                                className="btn btn-success mt-3"
                                onClick={addBreakTime}
                              >
                                + Add
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => {
                            if(!applyBreakValidations(formData4.breakTimes)){
                              alert('change break times as per rules')
                            }
                            else{
                            setShowBreakInputModal(false)
                            }
                          }}
                        >
                          Save & Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {showBreakInputModalTwo && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Add Break Details</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowBreakInputModalTwo(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className="form-label">
                              <strong>Break Times</strong>
                            </label>

                            {/* Loop through formData4.breakTimes to display each set of fields */}
                            {formData6.breakTimes.map((breakTime, index) => (
                              <div key={index} className="row mb-2">
                                <div className="col-3">
                                  <label><strong>Start Time</strong></label>
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="startTime"
                                    value={breakTime.startTime}
                                    onChange={(e) => handleInputChangeTwo(index, e)}
                                    placeholder="Start Time"
                                  />
                                </div>

                                <div className="col-3">
                                  <label><strong>Hrs From Route Start</strong></label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="startHours"
                                    value={breakTime.startHours}
                                    onChange={(e) => handleInputChangeTwo(index, e)}
                                  />
                                </div>

                                <div className="col-3">
                                  <label><strong>Break Early Window</strong></label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="earlyWindow"
                                    value={breakTime.earlyWindow}
                                    onChange={(e) => handleInputChangeTwo(index, e)}
                                  />
                                </div>

                                <div className="col-3">
                                  <label><strong>Break Late Window</strong></label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="lateWindow"
                                    value={breakTime.lateWindow}
                                    onChange={(e) => handleInputChangeTwo(index, e)}
                                  />
                                </div>

                                <div className="col-3">
                                  <label><strong>Break Duration</strong></label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="duration"
                                    value={breakTime.duration}
                                    onChange={(e) => handleInputChangeTwo(index, e)}
                                  />
                                </div>
                                {/* Remove button */}
                                <div className="col-1 d-flex align-items-center justify-content-center">
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => removeBreakTimeTwo(index)}
                                  >
                                    <strong>X</strong>
                                  </button>
                                </div>
                              </div>
                            ))}

                            {/* Button to add a new break time */}
                            <div className="col-3">
                              <button
                                type="button"
                                className="btn btn-success mt-3"
                                onClick={addBreakTimeTwo}
                              >
                                + Add
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => {

                            if(!applyBreakValidations(formData6.breakTimes)){
                              alert('change break times as per rules')
                            }
                            else{
                              setShowBreakInputModalTwo(false)
                            }
                          }}
                        >
                          Save & Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}


              {showDetailModal2 && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Route {selectedGroup2.Route || selectedGroup2.routeNo} Break Details</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => {
                            // setBreakTimeEdited({
                            //   startTime:'',
                            //   startHours:'',
                            //   earlyWindow:'',
                            //   lateWindow:'',
                            //   duration:''
                            // });
                            setIsButtonThreeDisabled(false)
                            setEditedBreaksRouteGroups2([]);
                            setShowDetailModal2(false)}
                        }
                        ></button>
                      </div>
                      <div className="modal-body">
                        {/* <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label"><strong>Template Name</strong></label>
                            <p>{selectedGroup2.templateName  || 'N/A'}</p>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label"><strong>Route Number</strong></label>
                            <p>{  selectedGroup2.Route || selectedGroup2.routeNo}</p>
                          </div>
                        </div> */}
                        {/* <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label"><strong>Attribute</strong></label>
                            <p>{selectedGroup2.attribute || 'N/A'}</p>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label"><strong>Depot</strong></label>
                            <p>{selectedGroup2.depot || selectedGroup2.iDepot}</p>
                          </div>
                        </div> */}
                        {/* <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label"><strong>Vehicle #</strong></label>
                            <p>{selectedGroup2.vehicle || selectedGroup2["Associated Vehicle"]}</p>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label"><strong>Vehicle Type</strong></label>
                            <p>{selectedGroup2.vehicleType || selectedGroup2["Vehicle Type"]}</p>
                          </div>
                        </div> */}

                        {/* <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label"><strong>Start Time</strong></label>
                            <p>{selectedGroup2.startTime || selectedGroup2["Start Time"]}</p>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label"><strong>Duration</strong></label>
                            <p>{selectedGroup2.duration || selectedGroup2["Max Route Hours"]}</p>
                          </div>
                        </div> */}
                        {/* <div className="col-md-6">
                          <label className="form-label"><strong>Rec Affiliate</strong></label>
                          <p>{selectedGroup2.recAffiliate || selectedGroup2.iServingAffiliateID }</p>
                        </div> */}
                        <div className="row mb-3">
                          <div className="col-md-12">
                            {/* <label className="form-label"><strong>Break Times</strong></label> */}
                            {/* { */}
                      {breaksRouteGroups2.filter(item => item.routeNumber === selectedGroup2.Route || selectedGroup2.routeNo).length === 0
                      ? <p>No breaks available for this route</p>
                      : breaksRouteGroups2.filter(item => item.routeNumber === selectedGroup2.Route || selectedGroup2.routeNo).map((breakTime, index) => (
                      <div key={breakTime.iID} className="row mb-4 align-items-end">
                        <div className="col-2">
                        <label><strong>Start Time</strong></label>
                
                          <input
                             type="time"
                             name="startTime"
                            className="form-control"
                            value={editedBreaksRouteGroups2.find(item => item.iID === breakTime.iID)?.startTime?.slice(11, 16) ||
                               editedBreaksRouteGroups2.find(item => item.iID === breakTime.iID)?.startTime}
                            
                            onChange={(e) => handleBreakTimeEdited(breakTime.iID,'startTime', e.target.value)}

                          />
                          {/* <p>{breakTime.startTime || 'N/A'}</p> */}

                      </div>
                      <div className="col-2">
                        <label><strong>Hrs From Route Start</strong></label>
                          <input
                            type="number"
                            name="startHours"
                            className="form-control"
                            value={editedBreaksRouteGroups2.find(item => item.iID === breakTime.iID)?.startHours ||
                              editedBreaksRouteGroups2.find(item => item.iID === breakTime.iID)?.startHours}
                            // {editedBreaksRouteGroups2[index]?.startHours || 0}
                            onChange={(e) => handleBreakTimeEdited(breakTime.iID,'startHours', e.target.value)}

                          />

                          {/* <p>{breakTime.startHours || 'X'}</p> */}

                      </div>
                      <div className="col-2">
                        <label><strong>Break Early Window</strong></label>

                          <input
                            type="number"
                            name="earlyWindow"
                            className="form-control"
                            value={editedBreaksRouteGroups2.find(item => item.iID === breakTime.iID)?.earlyWindow ||
                              editedBreaksRouteGroups2.find(item => item.iID === breakTime.iID)?.earlyWindow}
                            // {editedBreaksRouteGroups2[index]?.earlyWindow || 0}
                            onChange={(e) => handleBreakTimeEdited(breakTime.iID,'earlyWindow', e.target.value)}

                          />
                          {/* <p>{breakTime.earlyWindow || 'X'}</p> */}
                      </div>
                      <div className="col-2">
                        <label><strong>Break Late Window</strong></label>
                          <input
                            type="number"
                            name="lateWindow"
                            className="form-control"
                            value={editedBreaksRouteGroups2.find(item => item.iID === breakTime.iID)?.lateWindow ||
                              editedBreaksRouteGroups2.find(item => item.iID === breakTime.iID)?.lateWindow}
                            //{editedBreaksRouteGroups2[index]?.lateWindow || 0}
                            onChange={(e) => handleBreakTimeEdited(breakTime.iID,'lateWindow', e.target.value)}

                          />
                          {/* <p>{breakTime.lateWindow || 'X'}</p> */}
                      </div>
                      <div className="col-2">
                        <label><strong>Break Duration</strong></label>
                          <input
                            type="number"
                            className="form-control"
                            name="duration"
                            value={editedBreaksRouteGroups2.find(item => item.iID === breakTime.iID)?.duration ||
                              editedBreaksRouteGroups2.find(item => item.iID === breakTime.iID)?.duration}
                            //{editedBreaksRouteGroups2[index]?.duration || 0}
                            onChange={(e) => handleBreakTimeEdited(breakTime.iID,'duration', e.target.value)}
                          />

                          {/* <p>{breakTime.duration || 'X'}</p> */}
                            
                      </div>
                      <div className="col-2">

                      <Button  onClick={() => {
                        if(!applyBreakValidations(editedBreaksRouteGroups2.filter(item =>item.routeNumber === selectedGroup2.Route || item.routeNumber === selectedGroup2.routeNo).filter(item=>item.iID!==0))){
                          alert('change  break times as per rules')
                        }
                        else{
                        handleBreakEditSave(selectedGroup2.Route || selectedGroup2.routeNo,editedBreaksRouteGroups2.find(item => item.iID === breakTime.iID));
                        }
                      }}
                                         className="btn btn-sm me-2" style={{
                                          backgroundColor: "green"}}>
                          <FontAwesomeIcon icon={faSave} /> 
                          </Button>

                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => setShowModalBreakDelete(true)}
                              >
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </button>

                              <Modal show={showModalBreakDelete} onHide={() => setShowModalBreakDelete(false)} centered>
                                <Modal.Header closeButton>
                                  <Modal.Title>Confirm Delete</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  Are you sure you want to delete this break?
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button variant="secondary" onClick={() => setShowModalBreakDelete(false)}>
                                    No
                                  </Button>
                                  <Button variant="danger" onClick={() => handleDeleteBreak(selectedGroup2.Route || selectedGroup2.routeNo,breakTime)}>
                                    Yes
                                  </Button>
                                </Modal.Footer>
                              </Modal>

                          </div>
                      {/* <div className="col-2">
                                                      <button
                                className="btn btn-danger btn-sm"
                                onClick={() =>{ 
                                  alert('are you sure to delete');
                                  }}
                              >
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </button>
                        </div> */}
                          {/* <div className="col-3">
                          {routeEdited !== -1 ? (   
          <button
            type="button"
            className="btn btn-success mt-3"
            onClick={addBreakTime}
          >
            + Add
          </button>
           ) : (
            <></>
            // <p>{breakTime.duration || 'X'}</p>
          )}
          </div> */}
                      </div>
                        ))
                        }

{editedBreaksRouteGroups2.filter(item => item.routeNumber === selectedGroup2.Route || selectedGroup2.routeNo).length === 0
? <p></p>
: editedBreaksRouteGroups2.filter(item => item.routeNumber === selectedGroup2.Route || selectedGroup2.routeNo).map((breakTime, index) => ( 
  //  <></> 
  // <div className="col-3">
                      <div key={index} className="row mb-4">

   {breakTime.iID === 0 && (
  <div key={index} className="row mb-4 align-items-end">
  <div className="col-2">
  <label><strong>Start Time</strong></label>
    <input
       type="time"
       name="startTime"
      className="form-control"
      value={breakTime?.startTime?.slice(11, 16) || breakTime.startTime}
      
      onChange={(e) => handleBreakTimeEdited(breakTime.iID,'startTime', e.target.value)}

    />

</div>
<div className="col-2">
  <label><strong>Hrs From Route Start</strong></label>
    <input
      type="number"
      name="startHours"
      className="form-control"
      value={breakTime?.startHours}
      onChange={(e) => handleBreakTimeEdited(breakTime.iID,'startHours', e.target.value)}

    />
</div>
<div className="col-2">
  <label><strong>Break Early Window</strong></label>
    <input
      type="number"
      name="earlyWindow"
      className="form-control"
      value={breakTime?.earlyWindow}
      onChange={(e) => handleBreakTimeEdited(breakTime.iID,'earlyWindow', e.target.value)}

    />
</div>
<div className="col-2">
  <label><strong>Break Late Window</strong></label>
    <input
      type="number"
      name="lateWindow"
     className="form-control"
      value={breakTime?.lateWindow}
      onChange={(e) => handleBreakTimeEdited(breakTime.iID,'lateWindow', e.target.value)}

    />
</div>
<div className="col-2">
  <label><strong>Break Duration</strong></label>
    <input
      type="number"
      name="duration"
      className="form-control"
      value={breakTime?.duration}
      onChange={(e) => handleBreakTimeEdited(breakTime.iID,'duration', e.target.value)}

    />
  
</div>
<div className="col-2">




<Button  onClick={() => {
                        if(!applyBreakValidations(editedBreaksRouteGroups2.filter(item =>item.routeNumber === selectedGroup2.Route || item.routeNumber === selectedGroup2.routeNo))){
                          alert('change  break times as per rules')
                        }
                        else{
  handleNewBreakSave(selectedGroup2.Route || selectedGroup2.routeNo,breakTime);
  }
}}
                   className="btn-sm me-2" style={{
                    backgroundColor: "yellow"}}>
    ✔
    </Button>
    <Button  onClick={() => {
              const filteredArray = editedBreaksRouteGroups2.filter(item => item.iID !== 0);
              setEditedBreaksRouteGroups2(filteredArray);
              setIsButtonThreeDisabled(false);
    }} className="btn-sm" style={{backgroundColor: "red"}}>                 
                          X
    </Button>


    </div>
</div>
    
  )}
   </div>
   ))
}
   <div className="col-3">
                          {routeEdited !== -1 ? (   
          <button
            type="button"
            className="btn btn-success mt-3"
            disabled={isButtonThreeDisabled}                
            onClick={() => {
              setIsButtonThreeDisabled(true);
              setEditedBreaksRouteGroups2((prevArray) => {
                const updatedArray = [...prevArray]; // Create a copy of the array
                updatedArray.push({ // Append a new object
                  earlyWindow: "",
                  lateWindow: "",
                  routeNumber: selectedGroup2.Route || selectedGroup2.routeNo,
                  duration: "",
                  startHours: "",
                  startTime: '',
                  iID: 0,
                });
                return updatedArray; // Return the updated array
              });
            }}
            // ={addBreakTime}
          >
            + Add
          </button>
           ) : (
            
            // <p>{breakTime.duration || 'X'}</p>
            <>
                      <button
            type="button"
            className="btn btn-success mt-3"
            disabled={isButtonThreeDisabled}                
            onClick={() => {
              setIsButtonThreeDisabled(true);
              setEditedBreaksRouteGroups2((prevArray) => {
                const updatedArray = [...prevArray]; // Create a copy of the array
                updatedArray.push({ // Append a new object
                  earlyWindow: "",
                  lateWindow: "",
                  routeNumber: selectedGroup2.Route || selectedGroup2.routeNo,
                  duration: "",
                  startHours: "",
                  startTime: '',
                  iID: 0,
                });
                return updatedArray; // Return the updated array
              });
            }}
            // ={addBreakTime}
          >
            + Add
          </button>
          </>
          )}
          </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => {setShowDetailModal2(false)
                            //                         setBreakTimeEdited({
                            //   startTime:'',
                            //   startHours:'',
                            //   earlyWindow:'',
                            //   lateWindow:'',
                            //   duration:''
                            // });
                            setIsButtonThreeDisabled(false)
                            setEditedBreaksRouteGroups2([]);
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}


              {showDetailModal3 && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Route Temp Details</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowDetailModal3(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        {/* <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label"><strong>Template Name</strong></label>
                            <p>{selectedGroup2.templateName  || 'N/A'}</p>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label"><strong>Route Number</strong></label>
                            <p>{  selectedGroup2.Route || selectedGroup2.routeNo}</p>
                          </div>
                        </div> */}
                        {/* <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label"><strong>Attribute</strong></label>
                            <p>{selectedGroup2.attribute || 'N/A'}</p>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label"><strong>Depot</strong></label>
                            <p>{selectedGroup2.depot || selectedGroup2.iDepot}</p>
                          </div>
                        </div> */}
                        {/* <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label"><strong>Vehicle #</strong></label>
                            <p>{selectedGroup2.vehicle || selectedGroup2["Associated Vehicle"]}</p>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label"><strong>Vehicle Type</strong></label>
                            <p>{selectedGroup2.vehicleType || selectedGroup2["Vehicle Type"]}</p>
                          </div>
                        </div> */}

                        {/* <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="form-label"><strong>Start Time</strong></label>
                            <p>{selectedGroup2.startTime || selectedGroup2["Start Time"]}</p>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label"><strong>Duration</strong></label>
                            <p>{selectedGroup2.duration || selectedGroup2["Max Route Hours"]}</p>
                          </div>
                        </div> */}
                        {/* <div className="col-md-6">
                          <label className="form-label"><strong>Rec Affiliate</strong></label>
                          <p>{selectedGroup2.recAffiliate || selectedGroup2.iServingAffiliateID }</p>
                        </div> */}
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className="form-label"><strong>Break Times</strong></label>
                            {
                              breaksRouteGroups.filter(item => item.iMVRouteVehiclesSettingsTemplateID === selectedGroup3.iID).length === 0
                                ? <p>No breaks available for this route</p>
                                : breaksRouteGroups.filter(item => item.iMVRouteVehiclesSettingsTemplateID === selectedGroup3.iID).map((breakTime, index) => (
                                  <div key={index} className="row mb-2">
                                    <div className="col-2">
                                      <label><strong>Start Time</strong></label>
                                      <p>{isNaN(new Date(breakTime.startTime)) ? 'X' : new Date(breakTime.startTime).toLocaleString()}</p>
                                    </div>
                                    <div className="col-2">
                                      <label><strong>Hrs From Route Start</strong></label>
                                      <p>{breakTime.startHours || 'X'}</p>
                                    </div>
                                    <div className="col-2">
                                      <label><strong>Break Early Window</strong></label>
                                      <p>{breakTime.earlyWindow || 'X'}</p>
                                    </div>
                                    <div className="col-2">
                                      <label><strong>Break Late Window</strong></label>
                                      <p>{breakTime.lateWindow || 'X'}</p>
                                    </div>
                                    <div className="col-2">
                                      <label><strong>Break Duration</strong></label>
                                      <p>{breakTime.duration || 'X'}</p>
                                    </div>
                                  </div>
                                ))
                            }

                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setShowDetailModal3(false)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

            </div>


          </div>
        )}

        {activeTab === 'Depot Definitions' && (
          <div
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <Card style={{ width: "75%" }} className="mb-4">
              {/* Content for Depot Definitions */}
              <div className="container mt-4">
                <div className="text-white p-2 mb-2 w-25 mx-auto text-center" style={{ backgroundColor: '#87CEFA' }}>
                  Depot Settings
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="thead-dark">
                      <tr>
                        <th>Actions</th>
                        <th>Depot Name</th>
                        <th>Depot Address</th>
                        <th>Latitude</th>
                        <th>Longitude</th>
                        <th>Zone</th>
                      </tr>
                    </thead>
                    <tbody>
                      {depots.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            <button className="btn btn-secondary" onClick={handleDepotAdd}>
                              <FontAwesomeIcon icon={faPlus} />
                            </button>
                          </td>
                        </tr>
                      ) : (
                        depots.map((depot, index) => (
                          <tr key={index}>
                            <td>
                              {index + 1 === depots.length && !AddingDepot && !depots.filter(depot => depot.isEditing).length>=1 &&(
                                <button className="btn btn-primary btn-sm me-2" onClick={() => handleDepotAdd()}>
                                  <FontAwesomeIcon icon={faPlus} />
                                </button>
                              )}
                              <button
                                className="btn btn-warning btn-sm me-2"
                                onClick={() => handleDepotEdit(depot.depotId)}
                                disabled={depots.filter(depot => depot.isEditing).length>=1 && !depot.isEditing}
                              >
                                {depot.isEditing ? <FontAwesomeIcon icon={faSave} /> : <FontAwesomeIcon icon={faPencilAlt} />}
                              </button>
                              {!depot.isEditing &&(
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() =>{ 

                                 alert('are you sure to delete');
                                  handleDeleteDepot(depot.depotId);}}
                              >
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </button>
                              )}
                              {depot.isEditing &&(
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => {handleChange(depot.depotId, "isEditing",!depot.isEditing);
                                                fetchDepotData();
                                                if(AddingDepot){setAddingDepot(!AddingDepot)}
                                }}
                              >
                                <FontAwesomeIcon icon={faTimes} />
                              </button>
                              )}
                            </td>
                            <td>
                              {depot.isEditing ? (
                                <input
                                  type="text"
                                  className="form-control"
                                  value={depot.depotName}
                                  onChange={(e) => handleChange(depot.depotId, "depotName", e.target.value)}
                                />
                              ) : (
                                depot.depotName
                              )}
                            </td>
                            <td>
                              {depot.isEditing ? (
                                <input
                                  type="text"
                                  className="form-control"
                                  value={depot.Street}
                                  onChange={(e) => handleChange(depot.depotId, "Street", e.target.value)}
                                />
                              ) : (
                                depot.Street
                              )}
                            </td>
                            <td>{depot.Latitude}</td>
                            <td>{depot.Longitude}</td>
                            <td>
                              <div className="btn btn-warning" onClick={() => handleZoneDetails(depot)}>
                              Zone Details
                                {/* {!depot.isEditing ? 'See Zone Details' : 'Add Zone Details'} */}
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </Card>


            {/* Modal for Zone Details */}
            {showDepotDetailModal && (
              <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Depot Zone Details</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowDepotDetailModal(false)}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="row mb-4">

                        {/* <label className="form-label"><strong>Zones</strong></label> */}
                        {/* {formData5?.zonedetails.map((zonedetail, index) => ( */}
                        <div className="col-md-3">

                          <Form.Label><strong>Pickup Attribute</strong></Form.Label>

                          <Form.Select
                            value={formData5.pickupattribute}
                            name="pickupattribute"
                            onChange={handleChangeDepotAttributeCombinationPopup}
                          // disabled={!editingRule.attributeType}
                          >
                            <option value="">Any</option>
                            {pickupAttributes.map(attr => (
                              <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                            ))}
                          </Form.Select>
                        </div>
                        <div className="col-md-3">

                          <Form.Label><strong>Dropoff Attribute</strong></Form.Label>

                          <Form.Select
                            name="dropoffattribute"
                            value={formData5.dropoffattribute}
                            onChange={handleChangeDepotAttributeCombinationPopup}

                          >
                            <option value="">Any</option>
                            {dropoffAttributes.map(attr => (
                              <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                            ))}
                          </Form.Select>
                        </div>
                        {/* <div className="col-md-3">

                          <Form.Label><strong>Apply To</strong></Form.Label>

                          <Form.Select
                            name="triptype"
                            value={formData5.triptype}
                            onChange={handleChangeDepotAttributeCombinationPopup}

                          >
                            <option value="">Select Type</option>
                            <option value="0">First Trip</option>
                            <option value="1">Other Trips</option>
                            <option value="1">All Trips</option>

                          </Form.Select>

                        </div> */}
                        <div className="col-md-3">
                          <Form.Label><strong>Add Combination</strong></Form.Label>

                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => addZoneDetailsToAttrbiuteRefTable(selectedDepot.depotId, 'Depot')}
                            disabled={!selectedDepot.isEditing}
                          >
                            + Add
                          </button>
                        </div>
                      </div>
                      <table className="table table-striped table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>Pickup Attribute</th>
                            <th>DropOff Attribute</th>
                            {/* <th>Trip Type</th> */}
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {depotAttributeCombinationDetails.filter(entry => entry.REFID === selectedDepot.depotId).map((entry) => (
                            <tr key={entry.iID}>
                              <td>
                                {pickupAttributes.find(pickup => pickup.iID === entry.iPickupAttributeID)?.vTitle || 'Any'}
                              </td>
                              <td>
                                {dropoffAttributes.find(dropoff => dropoff.iID === entry.iDropOffAttributeID)?.vTitle || 'Any'}
                              </td>
                              {/* <td>{tripTypeDescriptions[entry.TripType] || 'Unknown'}</td> */}
                              <td>
                                <button
                                  disabled={!selectedDepot.isEditing}
                                  onClick={() => handleDepotAttributeCombinationDelete(entry.iID)}
                                  className="btn btn-danger btn-sm">
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          setShowDepotDetailModal(false);
                          setFormData5(prev => ({
                            ...prev,
                            pickupattribute: '',
                            dropoffattribute: '',
                            triptype: ''
                          }));
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

                                                <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj.show}
              Title={confirmationModalObj.title}
              Body={confirmationModalObj.body}
              onOk={handleConfirmationModalOk1}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj.btnCanceText}
              btnOkText={confirmationModalObj.btnOkText}
              ShowCancelButton={"true"}
            />
            <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj1.show}
              Title={confirmationModalObj1.title}
              Body={confirmationModalObj1.body}
              onOk={handleConfirmationModalClose}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj1.btnCanceText}
              btnOkText={confirmationModalObj1.btnOkText}
              ShowCancelButton={"false"}
            />
          </div>
        )}

      </div>
    </div>
  )
}

export default Paratransit
